// Shopping Cart/Checkout JS
//V2022.06.16

NS('fishersci.components').CartCheckoutUI = (function () {

    var _SCRIPT_NAME = 'ShoppingCart.js',
        $_SHOPPING_CART_PROGRESS,
        $_SHIPPING_FORM,
        $_CUSTOMER_DATA_FORM,
        $_FORM_ERRORS,
        $_PAYMENT_FORM,
        $_CHECKOUT_FORM,
        $_MEMBER_ID,
        _GUEST_CHECKOUT_MODAL,
        $_VALID_ZIP_ELEMENT,
        $_DATA_ERROR_MESSAGE,
        _DATA_ZIP_TYPE,
        $_STATE_ZIP_ELEMENT,
        _CART_SERVICE,
        _CONFIRMATION_SERVICE,
        isPunchout,
        $ajaxSelectors,
        maximumLineItemsForQuote,
        totalPage=0,
        favList,
        currentPageNumber,
        cache={},
        screenWidth,
        uomLocation
    ;


    return {
        /**
         * Initialize Shopping Cart functions
         *
         * @return {undefined}
         */
        init: function () {
            console.log('Shopping Cart init');
            var _SELF = this;

            _SELF.initVariables();
            _SELF.initCartFunctions();
            
            // check if customer survey is existing
            if( !$('#FS-CAS-B2B-US').length ) { // we will not have a sticky proceed to checkout if the customer survey is attached
                _SELF.stickyCheckoutBtn();
            }

            //Init tool tips
            _SELF.initToolTips();

            //Favorites
            _SELF.initFavorites();

            //Show My Top Purchases for Registered Users
            if ($.cookie('usertype') === "R" && typeof $.cookie('gsessionId') !== "undefined" && typeof env.myTopPurchasesAccountNumber !== "undefined") {
                _SELF.initMyTopPurchases(env.myTopPurchasesAccountNumber);
            }


            $(window).resize(function() {
                if($(window).width() >=1440){
                    screenWidth = 1440;
                }
                else if($(window).width() >=1200 &&  $(window).width() <1440 ) {
                    screenWidth = 1200;

                }
                else if($(window).width() >=992 &&  $(window).width() <1200 ) {
                    screenWidth = 992;

                }
                else if($(window).width() >=768 &&  $(window).width() <992 ) {
                    screenWidth = 768;

                }
                else if($(window).width() >=320 &&  $(window).width() <768 ) {
                    screenWidth=320;
                }
            }).resize()

            // check if customer survey is existing
            if( !$('#FS-CAS-B2B-US').length ) { // we will not have a sticky proceed to checkout if the customer survey is attached
                _SELF.stickyCheckoutBtn();
            }

            //Merge saved items if needed only if the feature is enabled
            if ( env.enableSaveForLater ){
                if (sessionStorage.getItem("savedCartMerged") === null && localStorage.getItem('saveForLaterCartId') !== null && typeof $.cookie('gsessionId') !== "undefined"){
                    _SELF.mergeSavedForLaterItems();
                } else {
                    // get saved for later items
                    _SELF.getSavedForLaterItems();
                }
            }

            //Check for optinMessage query param and display notification
            _SELF.checkForB2bOptinMessage();

            //Find out more
            $(document).on("click", ".js-find-out-more", function(e){
                e.preventDefault();
                $.colorbox({
                    inline: true,
                    href: "#findOutMore",
                    width: fishersci.components.CartCheckoutUI.getColorboxWidth()
                });
            });

            //Disable the checkout button if any required assay ids are not valid
            if(fishersci.components.CartCheckoutUI.countInvalidAssays() !== 0){
                $('#qa_begin_checkout').addClass('disabled');
                $('.notification-widget').remove();
                fishersci.components.CartCheckoutUI.showAssayNotification();
            }

            //prevent AJAX caching
            $.ajaxSetup({cache: false});

            //Inline Notifications Cancel action
            $(document).on("click",'.notification .cancel', function(){
                var $this = $(this);
                var $parent = $this.closest('.notification');
                var $originalInput = $parent.data('elementid');
                var $originalQty = $parent.data('originalqty');

                //Remove working class
                $ajaxSelectors.removeClass('working');

                //Reset the value of the qty field
                $('#' + $originalInput).val( $originalQty );

                $parent.addClass('hide');
            });

            //Inline Notifications Proceed action
            $(document).on("click",'#removeQuote', function(){
                var $this = $(this);
                var $parent = $this.closest('.notification');
                var $originalInput = $parent.data('elementid');
            
                //Remove working classes
                $ajaxSelectors.removeClass('working');
            
                //Remove the quote data attribute of the  qty field and trigger a change event
                $('#' + $originalInput).find('.qty-field').removeData('quoteitem').attr('data-quoteitem',false).trigger('change');
            });

            //Make any third party AJAX calls for Availability ( Honeywell, Alfa Aesar, etc..)
            _SELF.findAvailabilityElements({
                element: $('.fetch-availability'),
                callback : _SELF.getAvailability
            });

            //CSD Toggles
            $(document).on("click",".js-edit-csd", function( e ){
                e.preventDefault();
                $(this).closest('td').toggleClass('csd-view edit-view');
            });

            //CSD header - trigger click to icon
            $(document).on("click", ".js-csd-header", function( e ){
                e.preventDefault();
                $(this).prev('a').trigger('click');
            });

            $(document).on("click", '#myTopPurchasesTab', function (e) {
                //Show the correct footer
                $('.save-for-later-footer').addClass('hide')
                $('.favorites-footer').addClass('hide')
                $('.top-purchases-footer').removeClass('hide')
            });

            $(document).on("click", '#favoritesTab', function (e) {
                //Show the correct footer
                $('.save-for-later-footer').addClass('hide')
                $('.top-purchases-footer').addClass('hide')
                $('.favorites-footer').removeClass('hide')
            });

            $(document).on("click", '#savedForLaterTab', function (e) {
                //Show the correct footer
                $('.favorites-footer').addClass('hide')
                $('.top-purchases-footer').addClass('hide')
                $('.save-for-later-footer').removeClass('hide')
            });

            $(document).on("click", '#moveAllToCartFavorites', function (e) {
                e.preventDefault();
                var $this = $(this);
                var saveId = localStorage.getItem('saveForLaterCartId') || null;
                var items = [];
                var omnitureParts = [];

                $(".js-add-favorites-to-cart").each(function(x, y) {
                    var $el = $(y);
                    var $partNumber = $el.data('partnumber');
                    var item = {
                        "partNumber": $partNumber,
                        "quantity": $el.data('qty'),
                        "uom": $el.data('uom'),
                        "uomType": $el.data('uomtype') ? $el.data('uomtype') : "STD",
                        "orderItemId": $el.closest('tbody').data('containerOrderitemid')
                    }
                    items.push(item);
                    omnitureParts.push($partNumber);
                });

                var data = {
                    "saveForLaterCartId": saveId,
                    "itemList": items,
                    "addToCartFrom": "Save Items for Later",
                    "moveall": true,
                    "fromSaveForlater": "false"
                };

                $.ajax({
                    url : '/store1/cart/saveforlater/movetocart/?language=' + LocalePath.getLanguage().toLowerCase() + '&countryCode=' + LocalePath.getCountry().toUpperCase(),
                    type: 'POST',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: JSON.stringify(data),
                    beforeSend: function() {
                        fishersci.components.CartCheckoutUI.addSpinnerToElement($this, {"image": "transparent-loader.gif", "position":"after"});
                    },
                    success: function(data) {
                        var shippingAndTaxData = {};

                        _SELF.updateCartUi({"data":data});

                        //Check for duplicate items
                        if ( typeof data.duplicateQuoteItems !== "undefined" ){
                            shippingAndTaxData.duplicateQuoteItems = data.duplicateQuoteItems;
                        }

                        //Check for messages
                        if (typeof data.messageList !== "undefined") {
                            $.each(data.messageList, function (key, value) {
                                if (value === "DUPLICATE_ITEM") {
                                    shippingAndTaxData.DUPLICATE_ITEM = true;
                                }
                            })
                        }

                        if( data.wasAdded && ( data.productsNotFoundQuickAdd == "" || !data.productsNotFoundQuickAdd ) ){
                            if(env.punchoutUser && !env.punchoutUseShippingAndTaxService){
                                fishersci.components.CartCheckoutUI.updateCartUi({"data":$.extend(data,shippingAndTaxData)})
                            } else {
                                fishersci.components.CartCheckoutUI.updateShippingAndTax(shippingAndTaxData);
                            }
                        } else {
                            //Pass bad parts into shipping and tax call so we can stuff them in the JSON
                            shippingAndTaxData.productsNotFoundQuickAdd = data.productsNotFoundQuickAdd;

                            if(env.punchoutUser  && !env.punchoutUseShippingAndTaxService){
                                fishersci.components.CartCheckoutUI.updateCartUi({"data":$.extend(data,shippingAndTaxData)})
                            } else {
                                fishersci.components.CartCheckoutUI.updateShippingAndTax(shippingAndTaxData);
                            }
                        }

                        fishersci.components.CartCheckoutUI.removeSpinnerFromElement($this);
                        //Treat as Add to Cart for Adobe
                        fishersci.components.CartCheckoutUI.addToCartAnalytics({
                            "parts": omnitureParts,
                            "addToCartFrom": "Move all to Cart from Top Purchases"
                        });
                    },
                    error : function(xhr) {
                        console.log(xhr);
                    },
                    done: function() {
                        //
                    }
                });
            });

            $(document).on("click", '#moveAllToCartTopPurchases', function (e) {
                e.preventDefault();
                var $this = $(this);
                var saveId = localStorage.getItem('saveForLaterCartId') || null;
                var items = [];
                var omnitureParts = [];

                $(".js-add-my-top-purchases-to-cart").each(function(x, y) {
                    var $el = $(y);
                    var $partNumber = $el.data('partnumber');
                    var item = {
                        "partNumber": $partNumber,
                        "quantity": $el.data('qty'),
                        "uom": $el.data('uom'),
                        "uomType": $el.data('uomtype') ? $el.data('uomtype') : "STD",
                        "orderItemId": $el.closest('tbody').data('containerOrderitemid')
                    }
                    items.push(item);
                    omnitureParts.push($partNumber);
                });

                var data = {
                    "saveForLaterCartId": saveId,
                    "itemList": items,
                    "addToCartFrom": "Save Items for Later",
                    "moveall": true,
                    "fromSaveForlater": "false"
                };

                $.ajax({
                    url : '/store1/cart/saveforlater/movetocart/?language=' + LocalePath.getLanguage().toLowerCase() + '&countryCode=' + LocalePath.getCountry().toUpperCase(),
                    type: 'POST',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: JSON.stringify(data),
                    beforeSend: function() {
                        fishersci.components.CartCheckoutUI.addSpinnerToElement($this, {"image": "transparent-loader.gif", "position":"after"});
                    },
                    success: function(data) {
                        var shippingAndTaxData = {};

                        _SELF.updateCartUi({"data":data});

                        //Check for duplicate items
                        if ( typeof data.duplicateQuoteItems !== "undefined" ){
                            shippingAndTaxData.duplicateQuoteItems = data.duplicateQuoteItems;
                        }

                        //Check for messages
                        if (typeof data.messageList !== "undefined") {
                            $.each(data.messageList, function (key, value) {
                                if (value === "DUPLICATE_ITEM") {
                                    shippingAndTaxData.DUPLICATE_ITEM = true;
                                }
                            })
                        }

                        if( data.wasAdded && ( data.productsNotFoundQuickAdd == "" || !data.productsNotFoundQuickAdd ) ){
                            if(env.punchoutUser && !env.punchoutUseShippingAndTaxService){
                                fishersci.components.CartCheckoutUI.updateCartUi({"data":$.extend(data,shippingAndTaxData)})
                            } else {
                                fishersci.components.CartCheckoutUI.updateShippingAndTax(shippingAndTaxData);
                            }
                        } else {
                            //Pass bad parts into shipping and tax call so we can stuff them in the JSON
                            shippingAndTaxData.productsNotFoundQuickAdd = data.productsNotFoundQuickAdd;

                            if(env.punchoutUser  && !env.punchoutUseShippingAndTaxService){
                                fishersci.components.CartCheckoutUI.updateCartUi({"data":$.extend(data,shippingAndTaxData)})
                            } else {
                                fishersci.components.CartCheckoutUI.updateShippingAndTax(shippingAndTaxData);
                            }
                        }

                        fishersci.components.CartCheckoutUI.removeSpinnerFromElement($this);
                        //Treat as Add to Cart for Adobe
                        fishersci.components.CartCheckoutUI.addToCartAnalytics({
                            "parts": omnitureParts,
                            "addToCartFrom": "Move all to Cart from Top Purchases"
                        });
                    },
                    error : function(xhr) {
                        console.log(xhr);
                    },
                    done: function() {
                        //
                    }
                });
            });

            //CSD Update
            $(document).on("click", ".js-update-csd", function( e ){
                var $this = $(this);
                var options = {};
                var contract = {};
                var csdDataList = [];
                var $formdata = $this.closest('.js-csd-data-container').find('.js-csd-data');
                var $orderItemId = $this.data('orderitemid');
                var $formErrors = fishersci.components.CartCheckoutUI.validateFields({element: $this.closest('.js-csd-data-container').find('[data-required]')});

                if ($this.hasClass('disabled') || $formErrors > 0) {

                    fishersci.components.CartCheckoutUI.doNotifications({
                        data: {
                            message: i18nTranslations.cartUi.messages.csdError,
                            icon:   "icon_Warning_Outline_Thin",
                            type: "error"
                        },
                        showProgress: false,
                        showProgressContainer: false,
                        removeAfterTime: true,
                        removeWhenDone: true
                    });

                    return false;
                }

                e.preventDefault();
                //do validation

                //build object
                contract.orderItemId = $orderItemId;

                $formdata.each(function( i ){
                    var $this = $(this);
                    csdDataList.push(
                        {
                            "categoryCode" : $this.data('categorycode'),
                            "csdFieldValue" : $this.val()
                        }
                    )
                });

                contract.csdDataList = csdDataList;
                options.data = contract;
                options.endpoint = "updatecsd";

                //Callbacks
                options.callback = function (data) {
                    $this.removeClass('disabled');
                    fishersci.components.CartCheckoutUI.updateCartUi({"data":data});
                };

                options.beforeSendCallback = function () {
                    fishersci.components.CartCheckoutUI.addSpinnerToElement($this, {"image": "transparent-loader.gif", "position":"after"});
                    $this.addClass('disabled');
                };

                options.errorCallback = function (xhr, status, error) {
                    fishersci.components.CartCheckoutUI.removeSpinnerFromElement($this);
                    $this.removeClass('disabled');
                };


                //Call updateCSD
                _SELF.updateLineLevel( options );


            });
            //updating the booleanCSD value
            $(document).on("click", ".js-ut-reference-checkbox-input", function( e ){
                if($(this).is(':checked')){
                    $(this).val('true');
                }
                else{
                    $(this).val('false');
                }
            });
            //Update Button for Consolidated (reference) fields - submit ALL fields
            $(document).on("click", ".js-update-reference", function( e ){
                var $this = $(this);
                var options = {};
                var contract = {};
                var consolidatedFieldDataList = [];
                var $formdata = $this.closest('.reference-fields-container').find('.reference-data');
                var $orderItemId = $this.data('orderitemid');
                var $configItem = $(this).data('configitem') || false;
                var $formErrors = fishersci.components.CartCheckoutUI.validateEmptyFields({element: $this.closest('.reference-fields-container').find('[data-required]'), toggle: true});

                if ($formErrors > 0) {
                    return false;
                }

                e.preventDefault();
                //do validation

                //build object
                contract.orderItemId = $orderItemId;

                $formdata.each(function( i ){
                    var $this = $(this);
                    consolidatedFieldDataList.push(
                        {
                            "consolidatedFieldKey" : $this.attr('name'),
                            "consolidatedFieldValue" : $this.val()
                        }
                    )
                });

                contract.consolidatedFieldDataList = consolidatedFieldDataList;
                options.data = contract;
                options.endpoint = "updatelinecomment2";
                options.extraParams = {
                    omitHeaderString : true
                }

                if($configItem){
                    options.extraParams.configItem = true;
                }

                //Callbacks
                options.callback = function (data) {
                    $this.removeClass('disabled');
                    fishersci.components.CartCheckoutUI.updateCartUi({"data":data});
                };

                options.beforeSendCallback = function () {
                    fishersci.components.CartCheckoutUI.addSpinnerToElement($this, {"image": "transparent-loader.gif", "position":"after"});
                    $this.addClass('disabled');
                };

                options.errorCallback = function (xhr, status, error) {
                    fishersci.components.CartCheckoutUI.removeSpinnerFromElement($this);
                    $this.removeClass('disabled');
                };

                //Call to update line level fields
                _SELF.updateLineLevel( options );


            });
            //Individual field update for Consolidated (reference) fields
            /*$(document).on("change", ".reference-data", function( e ){
                var $this = $(this);
                var options = {};
                var contract = {};
                var consolidatedFieldDataList = [];
                var $formdata = $this.closest('.reference-fields-container').find('.reference-data');
                var $orderItemId = $this.closest('.reference-fields-container').find('button').data('orderitemid');
                var $configItem = $(this).data('configitem') || false;
                var $formErrors = fishersci.components.CartCheckoutUI.validateEmptyFields({element: $this, toggle: true});

                if ($formErrors > 0) {
                    return false;
                }

                e.preventDefault();
                //do validation

                //build object
                contract.orderItemId = $orderItemId;

                $formdata.each(function( i ){
                    var $this = $(this);
                    consolidatedFieldDataList.push(
                        {
                            "consolidatedFieldKey" : $this.attr('name'),
                            "consolidatedFieldValue" : $this.val()
                        }
                    )
                });

                contract.consolidatedFieldDataList = consolidatedFieldDataList;
                options.data = contract;
                options.endpoint = "updatelinecomment2";
                options.extraParams = {
                    omitHeaderString : true
                };

                if($configItem){
                    options.extraParams.configItem = true;
                }

                //Callbacks
                options.callback = function (data) {
                    $this.removeClass('disabled');
                    fishersci.components.CartCheckoutUI.updateCartUi({"data":data});
                };

                options.beforeSendCallback = function () {
                    fishersci.components.CartCheckoutUI.addSpinnerToElement($this, {"image": "transparent-loader.gif", "position":"after"});
                    $this.addClass('disabled');
                };

                options.errorCallback = function (xhr, status, error) {
                    fishersci.components.CartCheckoutUI.removeSpinnerFromElement($this);
                    $this.removeClass('disabled');
                };

                //Call to update line level fields
                _SELF.updateLineLevel( options );


            });*/

            //CSD - add regex data attribute to each field
            _SELF.setCsdRegExpression();

            //Get a Quote button ( new experience when both flags enabled)
            $(document).on("click", "#getAQuote",function(){
                var _SELF = fishersci.components.CartCheckoutUI;

                //High level click tracking
                fisherDataLayer.uiLabel = "UI Event captured: Get a Quote from Cart";
                fisherDataLayer.customLinkGeneral = "UI Event captured: Get a Quote from Cart";
                if(typeof _satellite !== "undefined") {
                    _satellite.track('trackUiGeneral');
                }

                _SELF.getAQuoteAction({'quoteType' : 'allQuotes'});
            })

            //New experience for CUSTOM QUOTE only enabled
            $(document).on("click", "#getACustomQuote", function() {
                var _SELF = fishersci.components.CartCheckoutUI;

                //High level click tracking
                fisherDataLayer.uiLabel = "UI Event captured: Request a Custom Quote from Cart";
                fisherDataLayer.customLinkGeneral = "UI Event captured: Request a Custom Quote from Cart";
                if(typeof _satellite !== "undefined") {
                    _satellite.track('trackUiGeneral');
                }

                _SELF.getAQuoteAction({'quoteType': 'customQuoteOnly'});
            });
            //Generate Instant Quote ( will function exactly as "Generate Web Quote" )
            $(document).on("click", "#getAnInstantQuote", function (){
                var _SELF = fishersci.components.CartCheckoutUI;
                //Check if cart has too many line items ( requirement says 100 )
                if ( _SELF.hasMaximumLineItemsForQuote() ){
                    return _SELF.showMaximumLineQuoteMessage();
                }

                //High level click tracking
                fisherDataLayer.uiLabel = "UI Event captured: Get an Instant Quote from Cart";
                fisherDataLayer.customLinkGeneral = "UI Event captured: Get an Instant Quote from Cart";
                if(typeof _satellite !== "undefined") {
                    _satellite.track('trackUiGeneral');
                }
                document.getElementById('generateWebQuote').click();
            });


            //Generate Web Quote button
            $(document).on("click", "#generateWebQuote", _SELF.generateWebQuoteListenerAction);

            //Generate Web quote for EU users that can add optional address info
            $(document).on("click", ".js-submit-address", function(){
                env.pricingConfirmationFields = {
                    address1 : $("#pricingAddress1").val(),
                    address2 : $("#pricingAddress2").val()
                };

                _SELF.generateWebQuoteListenerAction({}); //send in dummy event
                $.colorbox.close();
            });

            //Submit B2B web quote request - if validated, close the modal
            $(document).on("click", "#generateWebQuoteB2BButton", function( e ){
                var $this = $(this);

                e.preventDefault();

                //Call action method for Generate Web Quote - pass in this button
                if( _SELF.doValidateModalForm( {selector: "#generateWebQuoteB2B .required"} ) ){

                    //Serialize data and attach it to the body
                    $('body').data('serializedB2B', $('#generateWebQuoteB2B').serialize() );
                    _SELF.generateWebQuoteListenerAction({ selector: $this, b2bForm: true });
                    $.colorbox.close();
                }
            });

            //Close notifications with X
            $(document).on("click", ".close-notification", function (e) {
                clearInterval(window._progressTime); //stop the animation
                $(this).closest('.notification-widget').fadeOut(function(){
                    $(this).remove();
                    _SELF.alignWidgets();
                });

                //Reset all working fields
                $ajaxSelectors.removeClass('working');
            });

            $(document).on("click", "#quoteCancel", function(){
                if (typeof closeGetAQuoteModalBase === 'function') {
                    closeGetAQuoteModalBase();
                }
             });

            // fund_tracking hide-show:
            $(document).on("change", ".fund_tracking_form input:radio", function () {
                if ($(this).val() == "Apply") {
                    // enable here
                    $('.apply_fund_div').removeClass('hide');
                } else {
                    // disable here
                    $('.apply_fund_div').addClass('hide');
                }
            });

            //Listener for checkout button when email needs sent for Smart Filter / CSD customers
            $("body").on("click", ".js-email-smartfilter", _SELF.sendSmartFilterEmail);

            //For capturing currently selected stockroom item
            $("body").on("click", ".js-check-stockroom-shipped-section", function (e) {
                //set environmental variable to hold current orderitemid
                env.orderitemid = $(this).data('orderitemid');
            });

            $(document).on("click", ".js-item-level-promo", function (e) {
                var $this = $(this);
                var options = {};
                var $promoDetailsScript = $this.find('.js-promo-details-html');
                e.preventDefault();
            
                //Capture event for Adobe
                fisherDataLayer.events = "event116";
                if(typeof _satellite !== "undefined") {
                    _satellite.track("trackEventsGeneral");
                }
            
                if($promoDetailsScript.length > 0){ // new promo modal from PDP is present
                    var promoPopupHtml =  $promoDetailsScript.text();
                    var modal = document.querySelector('#promotionModal');
                    var contentDiv = $('#promotionContent');
            
                    // Check if we have valid HTML content
                    if (promoPopupHtml && promoPopupHtml.trim().length > 0) {
                        contentDiv.html(promoPopupHtml);
                    } else {
                        contentDiv.html('No promotion content available.');
                    }
            
                    if(modal.isActive){
                        modal.isopen = false;
                        modal.isActive = false;
                        return
                    } else {
                        modal.isopen = true;
                        modal.isActive = true;
                        
                        // Add event handler for links inside the modal
                        setupModalLinkHandlers(modal, contentDiv);
                        
                        setTimeout(function () {
                            var svg = null;
                            if (modal && modal.shadowRoot) {
                                svg = modal.shadowRoot.querySelector('.core-modal__close')
                            }
                            if (svg) {
                                svg.style.width = '18px';
                                svg.style.height = '18px';
                            } else {
                                console.warn("SVG not found inside core-modal shadowRoot");
                            }
                        }, 50);
                    }
                } else { //legacy CQ promo modal
                    options.href = document.location.protocol + "//" + document.location.hostname + $this.data('href');
                    options.callback = function () {
                        _SELF.initItemLevelPromos();
                        _SELF.renderI18n();
                    }
                    _SELF.renderItemLevelPromo(options);
                }
            });
            
            // Function to handle links inside the modal
            function setupModalLinkHandlers(modal, contentDiv) {
                // Handle anchor links inside the modal content
                $(modal).on('click', 'a', function(e) {
                    e.stopPropagation(); // Prevent event bubbling
                    
                    var href = $(this).attr('href');
                    var target = $(this).attr('target');
                    
                    if (href && href !== '#' && href !== 'javascript:void(0);') {
                        // If target is _blank or _new, open in new window/tab
                        if (target === '_blank' || target === '_new') {
                            window.open(href, target);
                            e.preventDefault();
                        } else {
                            // For same window navigation, you might want to close modal first
                            modal.isopen = false;
                            modal.isActive = false;
                            setTimeout(function() {
                                contentDiv.html('');
                                window.location.href = href;
                            }, 100);
                            e.preventDefault();
                        }
                    }
                });
                
                // Handle button clicks inside modal (like "Apply Promo and Add to Cart")
                $(modal).on('click', 'button', function (e) {
                    e.stopPropagation(); // Prevent event bubbling
                    
                    // Let the button's normal functionality proceed
                    // Check if this is a promo-popup-container button
                    if ($(this).closest('.promo-popup-container').length > 0) {
                        // Check if this is a sign-in button
                        if ($(this).hasClass('btn-sign-in')) {

                            // Fallback: trigger click on first sign-in button in header/nav
                            $('.btn-sign-in').first().trigger('click');
                            return;
                        }
                        var $button = $(this);
                        var originalText = $button.text().replace(/\s+/g, ' ').trim().toLowerCase();
                        var promoCode = $button.find('[data-promocode]').data('promocode');
                        var partNumber = $button.find('[data-partnumber]').data('partnumber');
                        if(partNumber){
                            partNumber = partNumber.toString().replace(/[^a-zA-Z\d]/g, "").toUpperCase();
                        }
                       

                        var action = "add";
                        // Update button text based on current text
                        if (!promoCode) {
                            // Prevent multiple clicks by checking if button is already processing
                            if ($button.hasClass('processing')) {
                                return;
                            }
                            
                            // Mark button as processing and update UI
                            $button.addClass('processing');
                            $button.addClass('hide');
                            $button.siblings('.promo_cart_spinner').removeClass('hide');

                            var itemList = [];
                            itemList.push({
                                "partNumber": partNumber,
                                "userEnteredPartNumber": partNumber,
                                "quantity": 1,
                                "uomType": ""
                            });
                            _SELF.addToCart({
                                data: {
                                    "addToCartFrom": "Forget Something",
                                    "itemList": itemList
                                },
                                errorCallback: function (xhr, status, error) {
                                    // Restore the original button state on error
                                    $button.removeClass('processing');
                                    $button.removeClass('hide');
                                    $button.siblings('.promo_cart_spinner').addClass('hide');
                                    // Close core-modal if it exists
                                    var modal = document.querySelector('#promotionModal');
                                    if (modal && modal.isopen) {
                                        modal.isopen = false;
                                    }
                                    //fishersci.components.CartCheckoutUI.removeSpinnerFromElement($('#forgotSomethingButton'));
                                    //$('#forgotSomethingButton').removeClass('disabled');

                                    var errorJson;

                                    try {
                                        errorJson = JSON.parse(xhr.responseText);

                                        if (errorJson.showError) {
                                            _SELF.cartErrorModal({
                                                "message": i18nTranslations.cartUi.messages.webOrderingUnavailable,
                                                "serviceErrorCode": errorJson.serviceErrorCode,
                                                "icon": "icon_Warning_Triangle"
                                            })
                                        }
                                    } catch (e) {
                                        console.error(e);
                                    }
                                }
                                ,
                                callback: function (data) {
                                    // Restore the original button state on success
                                    $button.removeClass('processing');
                                    $button.removeClass('hide');
                                    $button.siblings('.promo_cart_spinner').addClass('hide');
                                    // Close core-modal if it exists
                                    var modal = document.querySelector('#promotionModal');
                                    if (modal && modal.isopen) {
                                        modal.isopen = false;
                                    }

                                    var shippingAndTaxData = {};

                                    //In case of error from backend returned in 200 status
                                    if (data.status) {
                                        if (data.status !== 200) {
                                            fishersci.components.CartCheckoutUI.removeSpinnerFromElement($('#forgotSomethingButton'));
                                            //$('#forgotSomethingButton').removeClass('disabled');
                                            //$('#forgetSomething').removeClass('working');
                                            console.log(data);
                                            return;
                                        }
                                    }

                                    //Check for duplicate items
                                    if (typeof data.duplicateQuoteItems !== "undefined") {
                                        shippingAndTaxData.duplicateQuoteItems = data.duplicateQuoteItems;
                                    }

                                    if (typeof data.duplicateItemsInCartCA !== "undefined") {
                                        shippingAndTaxData.duplicateItemsInCartCA = data.duplicateItemsInCartCA;
                                        data.showDuplicateItemsCAWarningFooter = true;
                                        shippingAndTaxData.showDuplicateItemsCAWarningFooter = true;
                                    }

                                    //Check for messages
                                    if (typeof data.messageList !== "undefined") {
                                        $.each(data.messageList, function (key, value) {
                                            if (value === "DUPLICATE_ITEM") {
                                                shippingAndTaxData.DUPLICATE_ITEM = true;
                                            }
                                        })
                                    }

                                    //Update Shipping and Taxes
                                    //TODO clean up repetitive code
                                    if (data.wasAdded && (data.productsNotFoundQuickAdd == "" || !data.productsNotFoundQuickAdd)) {
                                        if (env.punchoutUser && !env.punchoutUseShippingAndTaxService && LocalePath.getCountry().toUpperCase() !== "CA") {
                                            fishersci.components.CartCheckoutUI.updateCartUi({ "data": $.extend(data, shippingAndTaxData) })
                                        } else {
                                            fishersci.components.CartCheckoutUI.updateShippingAndTax(shippingAndTaxData);
                                        }
                                    } else {
                                        //Pass bad parts into shipping and tax call so we can stuff them in the JSON
                                        shippingAndTaxData.productsNotFoundQuickAdd = data.productsNotFoundQuickAdd;

                                        if (env.punchoutUser && !env.punchoutUseShippingAndTaxService && LocalePath.getCountry().toUpperCase() !== "CA") {
                                            fishersci.components.CartCheckoutUI.updateCartUi({ "data": $.extend(data, shippingAndTaxData) })
                                        } else {
                                            fishersci.components.CartCheckoutUI.updateShippingAndTax(shippingAndTaxData);
                                        }
                                    }


                                    //if any url-query messages, reload the cart
                                    fishersci.components.CartCheckoutUI.checkResponseForMessages({ data: data });


                                    fishersci.components.CartCheckoutUI.addToCartAnalytics({
                                        "parts": omnitureParts,
                                        "addToCartFrom": "Order By Catalog Number - In Cart",
                                        "cartId": data.cartId,
                                        "cartTotal": data.cartSummary.cartSubTotal,
                                        "totalQty": data.cartLineItems
                                    });
                                }

                            })


                        } else if (promoCode) {
                            // Prevent multiple clicks by checking if button is already processing
                            if ($button.hasClass('processing')) {
                                return;
                            }
                            
                            // Mark button as processing and update UI
                            $button.addClass('processing');
                            $button.addClass('hide');
                            $button.siblings('.promo_cart_spinner').removeClass('hide');

                            _SELF.applyPromo({
                                "promoCode": promoCode,
                                "action": action,
                                callback: function () {
                                    // Restore the original button state
                                    $button.removeClass('processing');
                                    $button.removeClass('hide');
                                    $button.siblings('.promo_cart_spinner').addClass('hide');

                                    fishersci.components.CartCheckoutUI.removeInputSpinner({ element: $('#promoCode') });
                                    fisherDataLayer.promoCode = promoCode;
                                    fisherDataLayer.promoData.action = 'Add';
                                    fisherDataLayer.customLinkGeneral = 'Promo Code Applied';
                                    fisherDataLayer.promoCodeApplied = promoCode;
                                }
                            })
                        }
                    }
                });
            }
            
            // Also try listening for the modal's built-in close event
            $(document).ready(function() {
                var modal = document.querySelector('#promotionModal');
                if (modal) {
                    modal.addEventListener('close', function() {
                        modal.isopen = false;
                        $('#promotionContent').html('');
                    });
                }
            });

             // Prevent modal from closing when clicking inside the modal content
            $(document).on('click', '#promotionModal', function(e) {
                e.stopPropagation();
            });
            
            //Generic Cancel button
            $(document).on("click", '.cancel_btn', function (e) {
                e.preventDefault();
                $.colorbox.close();
            });

            //Check out button listener
            $(document).on('click', '.js-checkout-button', function (e) {
                var $this = $(this);

                try {
                    const rec = document.getElementById('checkout-recommendations-html-container');
                    var modal = document.querySelector('#checkout-recommendations-modal');
                    var popupDiv = document.getElementById('dm-fs-cart-checkout-popup-recommendations');
                    var isDisplayed = popupDiv instanceof Element && window.getComputedStyle(popupDiv).display !== 'none';
                    var shouldShowCheckoutPopup =
                        !modal.isopen &&
                        rec && rec.innerHTML.trim() !== '' &&
                        $.cookie('usertype') === "R" &&
                        popupDiv &&
                        isDisplayed;
                    if (shouldShowCheckoutPopup) {   // has a recommendations popup: show modal
                        var contentDiv = $('#checkout-recommendations-modal-content');
                        contentDiv.html(rec.innerHTML);
                        modal.isopen = true;
                        return;
                    }
                } catch (error) {
                    console.error('Error displaying checkout recommendations: ', error);
                }

                //Check CSD fields before submitting
                if ( env.hasCSD ){
                    _SELF.checkRequiredFields({
                        container: $('.js-csd-data-container'),
                        errorElement: $('#csdWarningError'),
                        doClickAction : false,
                        callback : fishersci.components.CartCheckoutUI.validateFields
                    });
                }

                e.preventDefault();

                //display login dialog for persistent user
                if (typeof $.cookie('persistentUser') !== 'undefined' && $.cookie('usertype') === "G" && !sessionStorage.getItem('persistentUserCheckoutCart')) {
                    sessionStorage.setItem('persistentUserCheckoutCart', 'true');
                    $('.btn-sign-in').click();
                    $("#cboxClose, #cboxOverlay").click(function(){
                        if (sessionStorage.getItem('persistentUserCheckoutCart')) {
                            sessionStorage.removeItem('persistentUserCheckoutCart');
                        }
                    });
                    return;
                }   

                //If this button is disabled, return
                if($this.hasClass('disabled')){
                    return;
                }

                //Capture event for Adobe
                fisherDataLayer.uiLabel = "Proceed to Checkout";
                fisherDataLayer.customLinkGeneral = "UI Event captured: Proceed to Checkout";
                if(typeof _satellite !== "undefined") {
                    _satellite.track('trackUiGeneral');
                }

                //disable the button to prevent multiple checkouts
                $this.addClass('disabled');

                //If we need to send SmartFilter email, wait 2.5 seconds before submitting to make sure request goes through
                if($this.hasClass('js-email-smartfilter')){
                    setTimeout(function(){
                        _SELF.doCheckoutButton();
                    }, 2500);
                } else {
                    _SELF.doCheckoutButton();
                }
            });

            //Cancel CXML orders
            $(document).on('click', '.js-cancel-button', function (e) {
                e.preventDefault();

                _SELF.cancelCxmlOrder();
            });

            if (fishersci.util) {
                if (fishersci.util.QueryString.getByKey("modal") == "guestCheckout") {
                    fishersci.components.CartCheckoutUI.openGuestCheckoutModal();
                }
            }

            $(document).on('click', '.js-cart-button', function () {
                _SELF.openPrintViewPage(_CART_SERVICE, "shoppingCartTitle");
            });

            $(document).on('click', '.print_confirmation', function () {
                _SELF.openPrintViewPage(_CONFIRMATION_SERVICE, "orderConfirmationTitle");
            });

            //Check for part numbers for Shared Cart - delay to prevent s.event clashes
            setTimeout(function () {
                if (fishersci.Common.getQueryString('emailPartNumbers')) {
                    var parts = decodeURI(fishersci.Common.getQueryString('emailPartNumbers')).split("|");
                    if (parts.length > 0) {
                        fishersci.components.CartCheckoutUI.addToCartAnalytics({
                            parts: parts,
                            addToCartFrom: "Shared Cart"
                        });
                    }
                }
            }, 4500)

            //Add listener for assay ID field
            $(document).on('blur', '.js-assay-id', function(){
                var $this = $(this);
                var $partNumber = $this.closest('.cart-ui-product-table').data('catalog-number');
                var $warningMessageContainer = $this.closest('.js-assay-id-container').find('.js-assay-warning');
                var $warningMessage = $this.closest('.js-assay-id-container').find('.js-assay-warning-message');
                var $assayId = $this.val();
                var data = { "parts": [{"partNumber" : $partNumber, "assayId" : $assayId}] };
                var $qtyField = $(this).closest('tbody').find('.qty-field.non-modal');
                var $checkoutBtn = $('#qa_begin_checkout');
            
                $.ajax({
                    url : '/store1/cart/updatecart/assayidvalidation',
                    type: 'POST',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: JSON.stringify(data),
                    beforeSend: function() {
                        fishersci.components.CartCheckoutUI.doInputSpinner({element: $this});
                    },
                    success: function(data){
                        if(data.parts[0].valid) {
                            $this.closest('.js-assay-id-container').removeClass('js-assay-needed js-assay-invalid');
                            $this.closest('.roRow--Std').removeClass('assay-warn');
                            $warningMessageContainer.addClass('hide');
                            $this.removeClass('error-border');
                            fishersci.components.CartCheckoutUI.removeInputSpinner({element: $this});
            
                            //If all valid assays exist, go ahead and hide the notification
                            if($('.js-assay-needed').length === 0 ){
                                $('.notification-widget').remove();
                                
                                //Re-enable the button if all assays are valid
                                if(fishersci.components.CartCheckoutUI.countInvalidAssays() === 0){
                                    $checkoutBtn.removeClass('disabled');
                                }
                            }
            
                            //Update the cart
                            $qtyField.data('triggeredBy', 'AssayValidation').trigger('change');
            
                            //Analytics
                            fisherDataLayer.uiLabel = "Successful assay Id match";
                            fisherDataLayer.customLinkGeneral = "UI Event captured: Successful assay Id match";
                            if(typeof _satellite !== "undefined") {
                                _satellite.track('trackUiGeneral');
                            }
                        } else {
                            $this.closest('.js-assay-id-container').addClass('js-assay-needed js-assay-invalid');
                            $this.closest('.assay_id_form_container').addClass('assay-warn');
                            $warningMessageContainer.removeClass('hide');
                            $warningMessage.text(i18nTranslations.cartUi.messages.invalidAssayId);
                            $warningMessageContainer.find('.assay-icon').addClass('red');
                            $this.addClass('error-border');
                            fishersci.components.CartCheckoutUI.removeInputSpinner({element: $this});
            
                            //Disable the button if any assays are not valid
                            if(fishersci.components.CartCheckoutUI.countInvalidAssays() !== 0){
                                $checkoutBtn.addClass('disabled');
            
                            }
            
                            //Show the notification
                            $('.notification-widget').remove();
                            fishersci.components.CartCheckoutUI.showAssayNotification();
            
                            //Analytics
                            fisherDataLayer.uiLabel = "Unsuccessful assay Id match";
                            fisherDataLayer.customLinkGeneral = "UI Event captured: Unsuccessful assay Id match";
                            if(typeof _satellite !== "undefined") {
                                _satellite.track('trackUiGeneral');
                            }
                        }
                    },
                    error : function (xhr) {
                        console.log(xhr);
                    },
                    done:   function () {
                        fishersci.components.CartCheckoutUI.removeInputSpinner({element: $this});
                    }
                })
            });
        },
        initCartFunctions: function () {
            var _SELF = this;
            var i18nTranslations = window.i18nTranslations || {};

            //init the "Forget Something?" functionality
            var partCount = [];
            var totalAllowedParts = 100;

            //'Sign in to switch account' for Persistent User
            $(document).on('click', '#loginToSwitchAccounts', function (e) {
                e.preventDefault();
                $('.btn-sign-in').click();
            });

            //Add listener for Add to Cart button
            $(document).on('click', '#forgotSomethingButton', function (e) {
                var $this = $(this);
                var omnitureParts = [];
                var cleanPart = '';
                var userEnteredPartNumber = '';
                var spinnerHtml = '<div id="ring-cart-forgot-something" class="ring small-padding-left white"><div></div><div></div><div></div><div></div></div>';
                e.preventDefault();

                if ($this.hasClass('disabled')) {
                    return;
                } else {
                    var itemList = [];
                    //Loop through products, stop after totalAllowedParts (25)
                    for (var i = 0; i <= (partCount.length - 1); i++) {
                        //If we're at 100 parts, break out
                        if (i === (totalAllowedParts)) {
                            break;
                        }
                        if (partCount[i] !== "") {
                            cleanPart = partCount[i].replace(/[^a-zA-Z\d]/g, "").toUpperCase();
                            userEnteredPartNumber = partCount[i].replace(/[^a-zA-Z\d.-]/g, "").toUpperCase();
                            itemList.push({
                                "partNumber": cleanPart,
                                "userEnteredPartNumber": userEnteredPartNumber,
                                "quantity": 1,
                                "uomType": ""
                            });

                            //add to array for Adobe
                            omnitureParts.push(cleanPart);
                        }
                    }
                }

                //Add to cart
                _SELF.addToCart({
                    data: {
                        "addToCartFrom": "Forget Something",
                        "itemList": itemList
                    },
                    beforeSendCallback: function () {
                        $this.after(spinnerHtml);
                        $('#forgotSomethingButton').addClass('disabled');

                    },
                    errorCallback: function (xhr, status, error) {
                        fishersci.components.CartCheckoutUI.removeSpinnerFromElement($('#forgotSomethingButton'));
                        $('#forgotSomethingButton').removeClass('disabled');

                        var errorJson;

                        try {
                            errorJson = JSON.parse(xhr.responseText);

                            if (errorJson.showError) {
                                _SELF.cartErrorModal({
                                    "message": i18nTranslations.cartUi.messages.webOrderingUnavailable,
                                    "serviceErrorCode": errorJson.serviceErrorCode,
                                    "icon": "icon_Warning_Triangle"
                                })
                            }
                        } catch (e) {
                            console.error(e);
                        }
                    }
                    ,
                    callback: function (data) {

                        var shippingAndTaxData = {};

                        //In case of error from backend returned in 200 status
                        if( data.status  ){
                            if( data.status !== 200 ){
                                fishersci.components.CartCheckoutUI.removeSpinnerFromElement($('#forgotSomethingButton'));
                                $('#forgotSomethingButton').removeClass('disabled');
                                $('#forgetSomething').removeClass('working');
                                console.log(data);
                                return;
                            }
                        }

                        //Check for duplicate items
                        if ( typeof data.duplicateQuoteItems !== "undefined" ){
                            shippingAndTaxData.duplicateQuoteItems = data.duplicateQuoteItems;
                        }

                        //Check for messages
                        if (typeof data.messageList !== "undefined") {
                            $.each(data.messageList, function (key, value) {
                                if (value === "DUPLICATE_ITEM") {
                                    shippingAndTaxData.DUPLICATE_ITEM = true;
                                }
                            })
                        }

                        //Update Shipping and Taxes
                        //TODO clean up repetitive code
                        if( data.wasAdded && ( data.productsNotFoundQuickAdd == "" || !data.productsNotFoundQuickAdd ) ){
                            if(env.punchoutUser && !env.punchoutUseShippingAndTaxService){
                                fishersci.components.CartCheckoutUI.updateCartUi({"data":$.extend(data,shippingAndTaxData)})
                            } else {
                                fishersci.components.CartCheckoutUI.updateShippingAndTax(shippingAndTaxData);
                            }
                        } else {
                            //Pass bad parts into shipping and tax call so we can stuff them in the JSON
                            shippingAndTaxData.productsNotFoundQuickAdd = data.productsNotFoundQuickAdd;

                            if(env.punchoutUser  && !env.punchoutUseShippingAndTaxService){
                                fishersci.components.CartCheckoutUI.updateCartUi({"data":$.extend(data,shippingAndTaxData)})
                            } else {
                                fishersci.components.CartCheckoutUI.updateShippingAndTax(shippingAndTaxData);
                            }
                        }                      


                        //if any url-query messages, reload the cart
                        fishersci.components.CartCheckoutUI.checkResponseForMessages({data: data});


                        fishersci.components.CartCheckoutUI.addToCartAnalytics({
                            "parts": omnitureParts,
                            "addToCartFrom": "Order By Catalog Number - In Cart",
                            "cartId" : data.cartId,
                            "cartTotal" : data.cartSummary.cartSubTotal,
                            "totalQty" : data.cartLineItems
                        });

                        //Fire cart overlay if cookie enabled
                        //TODO this is POC code - we won't call this from Cart - only outside areas (search, my lists, etc)
                        var overlayPart = itemList[0].partNumber;
                        if($.cookie('new_overlay_in_cart')){
                            $.ajax({
                                url: '/store1/cart/cartOverlay/'+overlayPart+'?language=' + LocalePath.getLanguage().toLowerCase() + '&countryCode=' + LocalePath.getCountry().toUpperCase(),
                                dataType: "html",
                                success: function(data){
                                    if($("#cartOverlay").length > 0) {
                                        $('#cartOverlayWrapper, #pageOverlay').remove();
                                    }
                                    $('body').append(data);
                                }
                            })
                        }
                    }

                })
            });

            $(document).on('click', '#accessoryAddToCart', function (e) {
                var $this = $(this);
                e.preventDefault();
                if ($this.hasClass('disabled')) {
                    return;
                } else {
                    var itemList = [];
                    var accessoryPartNumber = $this.data("partnumber");
                    var accessoryuom = $this.closest('.accessory-row').find('.js-ut-selected-uom').val();
                    var accessoryPartArray = []; //Add analytics tracking
                    accessoryPartArray.push(accessoryPartNumber);

                    itemList.push({
                        "partNumber": accessoryPartNumber,
                        "quantity": 1,
                        "uom":accessoryuom
                    });
                    if($this.hasClass('working')){
                        return;
                    }

                    $this.addClass('working');
                    if(!$this.hasClass('loading')) {
                        $this.addClass('loading');
                        $this.find('.liAtc1').css('display', 'none');
                        $this.find('.liAtc2').css('display', 'block');
                        $("#circle").css('display','block');
                    }
                }

                //Add to cart
                _SELF.addToCart({
                    data: {
                        "addToCartFrom": "Forget Something",
                        "itemList": itemList
                    },
                    beforeSendCallback: function () {
                        $('#accessoryAddToCart').addClass('disabled');

                    },
                    errorCallback: function (xhr, status, error) {
                        fishersci.components.CartCheckoutUI.removeSpinnerFromElement($('#forgotSomethingButton'));
                        $('#accessoryAddToCart').removeClass('disabled');
                        $this.removeClass('disabled working');
                        //Reset buttons
                        if($this.hasClass('inactiveATC')) {
                            $this.removeClass('activeATC loading');
                            $this.css('background-color', '#fff');
                            $this.find('.liAtc2').css('display', 'none');
                            $this.find('.liAtc1').css('display', 'block');
                        }

                        var errorJson;

                        try {
                            errorJson = JSON.parse(xhr.responseText);

                            if (errorJson.showError) {
                                _SELF.cartErrorModal({
                                    "message": i18nTranslations.cartUi.messages.webOrderingUnavailable,
                                    "serviceErrorCode": errorJson.serviceErrorCode,
                                    "icon": "icon_Warning_Triangle"
                                })
                            }
                        } catch (e) {
                            console.error(e);
                        }
                    }
                    ,
                    callback: function (data) {

                        var shippingAndTaxData = {};

                        //In case of error from backend returned in 200 status
                        if( data.status  ){
                            if( data.status !== 200 ){
                                $('#accessoryAddToCart').removeClass('disabled');
                                if($this.hasClass('inactiveATC')) {
                                    $this.find('.liAtc2').css('display', 'none');
                                    $("#circle").css('display','none');
                                    $this.removeClass('working');
                                }
                                console.log(data);
                                return;
                            }
                        }

                        //Check for duplicate items
                        if ( typeof data.duplicateQuoteItems !== "undefined" ){
                            shippingAndTaxData.duplicateQuoteItems = data.duplicateQuoteItems;
                        }

                        //Check for messages
                        if (typeof data.messageList !== "undefined") {
                            $.each(data.messageList, function (key, value) {
                                if (value === "DUPLICATE_ITEM") {
                                    shippingAndTaxData.DUPLICATE_ITEM = true;
                                }
                            })
                        }

                        //Update Shipping and Taxes
                        //TODO clean up repetitive code
                        if( data.wasAdded && ( data.productsNotFoundQuickAdd == "" || !data.productsNotFoundQuickAdd ) ){
                            if(env.punchoutUser && !env.punchoutUseShippingAndTaxService){
                                fishersci.components.CartCheckoutUI.updateCartUi({"data":$.extend(data,shippingAndTaxData)})
                            } else {
                                fishersci.components.CartCheckoutUI.updateShippingAndTax(shippingAndTaxData);
                            }
                        } else {
                            //Pass bad parts into shipping and tax call so we can stuff them in the JSON
                            shippingAndTaxData.productsNotFoundQuickAdd = data.productsNotFoundQuickAdd;

                            if(env.punchoutUser  && !env.punchoutUseShippingAndTaxService){
                                fishersci.components.CartCheckoutUI.updateCartUi({"data":$.extend(data,shippingAndTaxData)})
                            } else {
                                fishersci.components.CartCheckoutUI.updateShippingAndTax(shippingAndTaxData);
                            }
                        }


                        //if any url-query messages, reload the cart
                        fishersci.components.CartCheckoutUI.checkResponseForMessages({data: data});


                        fishersci.components.CartCheckoutUI.addToCartAnalytics({
                            "parts": accessoryPartArray,
                            "addToCartFrom": "Add Accessory to Order - In Cart",
                            "cartId" : data.cartId,
                            "cartTotal" : data.cartSummary.cartSubTotal,
                            "totalQty" : data.cartLineItems
                        });

                        //scroll to last element
                        const lastEle = document.querySelector("#qa_forget_something_lbl");
                        lastEle.scrollIntoView({block: "start", behavior: "smooth"});

                    }

                })

            });

            $(document).on('click','.promo-label',function(){
                var $this = $(this);
                $this.closest('.columns').find('.js-apply').removeClass('hide');
                $this.removeClass('promo-label').find('.font_icon').remove();
                document.dispatchEvent(new CustomEvent("promoCodeInitiate")); //new analytics
                $('.js-promo-code-label').remove();
            });

            $(document).on('keydown', '#promoCode', function (e) {
                //if enter key, submit the form
                if (e.which == 13) {
                    e.preventDefault();
                    $('#promoCodeButton').trigger('click');
                }
            });

            $(document).on('keydown', '.js-assay-id', function (e) {
                //if enter key, submit the form
                if (e.which == 13) {
                    e.preventDefault();
                    $(this).trigger('blur');
                }
            });

            $(document).on('keydown', '#forgetSomething', function (e) {
                var $this = $(this);
                if($this.hasClass('working')){return;}
                //if enter key, submit the form
                if (e.which == 13) {
                    $this.addClass('working');
                    e.preventDefault();
                    $('#forgotSomethingButton').trigger('click');
                } else {
                    $this.removeClass('working');
                }
            });

            $(document).on('keyup paste blur', '#forgetSomething', function (e) {
                var $this = $(this);
                var cleanInput = $this.val().replace(/,/g, " ");
                var finalOutput = cleanInput.replace(/  +/g, ' ');

                //update the txt field
                $this.val(finalOutput);

                partCount = $.trim(finalOutput).split(" ");

                //if not valid parts in the array, empty it
                if (partCount.length == 1 && partCount[0] == "") {
                    partCount = [];
                }

                if (partCount.length > totalAllowedParts) {
                    $('#forgetSomethingError').removeClass('hide').find('#forgetSomethingMessage').html(_showPartsOverLimit(partCount));
                } else {
                    $('#forgetSomethingError').addClass('hide');
                }

                //If at least one part, enable button
                if (partCount.length > 0) {
                    $('#forgotSomethingButton').removeClass('disabled');
                } else {
                    $('#forgotSomethingButton').addClass('disabled');
                }

                //Create string to show parts that won't get added
                _showPartsOverLimit = function (partCount) {
                    return partCount.slice(totalAllowedParts, partCount.length).join(" , ");
                }
            });

            //Automatically resize all colorbox windows when they complete
            $(document).bind('cbox_complete', function () {
                //setTimeout($.colorbox.resize, 2000);
            });

            $(document).on('click', '#submit_punchout_true', function (e) {
                e.preventDefault();

                //TODO Analytics for Punchout Submit

                //Submit punchout form
                $('#PunchOutForm').submit();
            })

            //Listen to key entries for promo code for UI
            $(document).on('keyup', '#promoCode', function (e) {
                var $this = $(this);
                var promoCodeVal = $this.closest('.row').find('#promoCode').val();
                var promoCodeRemove = $this.closest('.row').find('#promoCodeRemove');
                var promoCodeButton = $this.closest('.row').find('#promoCodeButton');
                var promoCodeMessage = $this.closest('.row').find('.promoCodeMessage');
                var $zipcodeError = $(this).closest('.input-container').find('#qa_guest_zipcode_error_ui');
                // var promoCodeVal = $.trim($('#promoCode').val());
                if (promoCodeVal != "") {
                    promoCodeRemove.css("display", "inline-block");
                } else {
                    promoCodeRemove.hide();
                }
                if (promoCodeVal.length > 2) {
                    promoCodeButton.removeClass("disabled");
                    promoCodeMessage.remove();
                } else {
                    promoCodeButton.addClass("disabled");
                }
            });

            //Listen to clicks on the Apply Promo button
            $(document).on('click', ".js-promo-code-apply", function (e) {
                e.preventDefault();
                var $this = $(this);
                var promoCodeEle = $this.closest('.row').find('#promoCode');
                var promoCode = $this.closest('.row').find('#promoCode').val().trim();
                var action = "add";

                document.dispatchEvent(new CustomEvent("promoCodeSubmit", { detail: {code: promoCode}})); //new analytics

                if (!($(this).hasClass("disabled"))) {
                    //Spinner (element / obj of options)
                    fishersci.components.CartCheckoutUI.addSpinnerToElement($('.js-promo-progress'), {classes: ' float_right'});
                }

                //Only call function if promo field has values in it
                if (promoCode !== "") {
                    _SELF.applyPromo({
                        "promoCode": promoCode,
                        "action": action,
                        beforeSendCallback: function () {
                            fishersci.components.CartCheckoutUI.doInputSpinner({element: promoCodeEle});
                        },
                        errorCallback: function () {
                            fishersci.components.CartCheckoutUI.removeInputSpinner({element: promoCodeEle});
                        },
                        callback: function () {
                            fishersci.components.CartCheckoutUI.removeInputSpinner({element: promoCodeEle});

                            //update data layer
                            fisherDataLayer.promoCode = promoCode;
                            fisherDataLayer.promoData.action = 'Apply';
                            fisherDataLayer.customLinkGeneral = 'Promo Code Applied';

                            setTimeout(function () {
                                if(typeof _satellite !== "undefined") {
                                    _satellite.track('promoCodes');
                                }
                            }, 500);

                        }
                    })
                }
            });

            //Clear promo field on click of X
            $(document).on('click', "#promoCodeRemove, .promoCodeRemoveSubmitted", function ( e ) {
                e.preventDefault();
                var $this = $(this);
                var promoCodeEle = $this.closest('.row').find('#promoCode');
                var promoCodeAppliedWrapper = $this.closest('.promo-code').find('#promocodeAppliedWrapper');
                var promoCodeSubmitted = $this.closest('.promo-code').find('#promocodeSubmitted');
                var promoCodeRemove = $this.closest('.row').find('#promoCodeRemove');
                var promoCodeButton = $this.closest('.row').find('#promoCodeButton');
                $(".js-apply, .js-promo-code-label").show();
                promoCodeAppliedWrapper.hide();
                promoCodeSubmitted.text("");
                promoCodeRemove.css("display", "none");
                fisherDataLayer.promoCode = "";
                promoCodeButton.addClass("disabled");
                promoCodeEle.val("");
            });
            //Remove promo code on click of remove link
            $(document).on('click', "#promoCodeRemoveSubmitted", function ( e ) {
                e.preventDefault();
                var promoCode = $("#promoAppliedName").data('promo');
                var action = "remove";

                _SELF.applyPromo({
                    "promoCode": promoCode,
                    "action": action,
                    callback: function () {
                        fishersci.components.CartCheckoutUI.removeInputSpinner({element: $('#promoCode')});

                        fisherDataLayer.promoCode = promoCode;
                        fisherDataLayer.promoData.action = 'Remove';
                        fisherDataLayer.customLinkGeneral = 'Promo Code Removed';
                        fisherDataLayer.promoCodeRemoved = promoCode;
                        document.dispatchEvent(new CustomEvent("promoCodeRemoved", {detail: {code: promoCode}}))
                    }
                })

            })

            //Apply zip code
            $(document).on('click', "#zipCodeApply", function (e) {
                e.preventDefault();
                var $zipcodeVal = $(this).closest('.row').find('.input').val();
                var $zipcodeError = $(this).closest('.input-container').find('#qa_guest_zipcode_error_ui');
                var $promoCode;
                if (!$zipcodeVal) {
                    $zipcodeError.html("<span class='icon_Warning_Triangle'>" + i18nTranslations.cartUi.messages["pleaseProvideZip"] + "</span>");
                    $zipcodeError.removeClass('hide');
                    //return false;
                } else if (!Validator.validateZipCode($zipcodeVal)) {
                    $zipcodeError.html("<span class='icon_Warning_Triangle'>" + i18nTranslations.cartUi.messages["invalidZip"] + "</span>");
                    $zipcodeError.removeClass('hide');
                    return false;
                } else if ($zipcodeError.is(":visible")) {
                    $zipcodeError.addClass('hide');
                }

                //To persist promo, we have to send the code
                $promoCode = $('#promoAppliedName').attr('data-promo') || null;

                //save zipcode in cookie if valid
                $.cookie("shipZipCode", $zipcodeVal, {path: "/"});

                //update via service
                _SELF.updateZipCode({
                    zipcode: $zipcodeVal,
                    promoCode : $promoCode,
                    beforeSendCallback: function () {
                        fishersci.components.CartCheckoutUI.doInputSpinner({element: $('#qa_gu_zipcode')});
                    },
                    errorCallback: function () {
                        fishersci.components.CartCheckoutUI.removeInputSpinner({element: $('#qa_gu_zipcode')});
                    },
                    callback: function ( data ) {

                        fishersci.components.CartCheckoutUI.removeInputSpinner({element: $('#qa_gu_zipcode')});

                        //Update Shipping and Taxes if needed
                        if( data.cartSummary ){
                            if ( !data.cartSummary.shippingAndTax ){
                                env.callShippingAndTax = true;
                                if(env.punchoutUser  && !env.punchoutUseShippingAndTaxService){
                                    fishersci.components.CartCheckoutUI.updateCartUi({"data" : data});
                                } else {
                                    fishersci.components.CartCheckoutUI.updateShippingAndTax();
                                }

                            }
                        }

                        //Capture event for Adobe
                        fisherDataLayer.uiLabel = "Apply Zip Code";
                        fisherDataLayer.customLinkGeneral = "UI Event captured: Apply Zip Code";
                        if(typeof _satellite !== "undefined") {
                            _satellite.track('trackUiGeneral');
                        }
                    }
                });
            });

            //confirm selection simply closes modal
            $(document).on('click', '#confirmSelection', function (e) {
                e.preventDefault();
                $.colorbox.close();
            })

            // stockroom modal passing uom and uom type value on click of quantity box
            $(document).on('click', ".qty-field", function (){
                var $this = $(this);
                var uom = $this.closest('tbody').find('[name="selectedUom"]').val();
                var uomType = $this.closest('tbody').find('[name="selectedUom"]').data('uomtype');
                var stockroomVal = $this.closest('tbody').hasClass('js-pickUpItem');
                if (stockroomVal) {
                    var stockroomelement = $this.closest('.qty-column').find('.stockroom-modal');
                    stockroomelement.data('uom', uom);
                    stockroomelement.data('uom-type', uomType);
                    fishersci.components.StockRoomModal.initStockRoomElement(stockroomelement, true);
                }
            });

            //listen to qty field
            $(document).on('change', ".qty-field.non-modal", function () {
                var $this = $(this);
                var triggeredBy = ($this.data('triggeredBy'))
                if ($this.data('triggeredBy') === 'AssayValidation') {
                    console.log('Triggered by Assay Validation');
                }
                var orderItemId = $this.data('orderitemid');
                var partNumber = $this.data('partnumber');
                var uom = $this.closest('tbody').find('[name="selectedUom"]').val();
                var uomType = $this.closest('tbody').find('[name="selectedUom"]').data('uomtype');
                var qty = $.trim($this.val().replace(/\W/g, ''));
                var assayId = $this.closest('tbody').find('.js-assay-id').val() || "";
                var validQty = _SELF.validateQty(qty);
                var options = {};

                if( $this.hasClass('working')){
                    return;
                }

                // checking the below condition to differentiate the main line item and accessory line item
                var isHyphen = orderItemId.toString().includes("-") ? true : false
                var accessoryPartNumber = "";
                if(isHyphen){
                    accessoryPartNumber = partNumber.toString().replace(/-/g, "");
                }

                $ajaxSelectors.addClass('working');

                options.data = {
                    "itemList": [{
                        "partNumber": partNumber,
                        "uom": uom,
                        "quantity": qty,
                        "assayId" : assayId
                    }],
                    "orderItemId": orderItemId
                };

                //If there's an assayId, set the itemType as MGLN to prevent dropped assays from orders
                if( assayId !== "" ){
                    options.data.itemList[0].itemType = 'MGLN';
                }

                //If the qty is empty or 0, delete versus update

                if (qty === "0" || qty === "") {
                    try {
                        sessionStorage.setItem("cartTotal" , fisherDataLayer.productData.cartTotalOnLoad);
                    }catch(e){}
                    _SELF.deleteItem({
                        orderItemId: orderItemId,
                        partNumber: accessoryPartNumber,
                        callback:   function(){
                            var $parentTbody = $this.closest('tbody');
                            fisherDataLayer.productData.cartTotal = sessionStorage.getItem("cartTotal");
                            fisherDataLayer.productData.basePrice = $parentTbody.find('.js-selected-uom').data('listprice');
                            fisherDataLayer.productData.currency = "USD";
                            fisherDataLayer.productData.qty = $parentTbody.find('.js-original-qty').val();
                            fisherDataLayer.productData.productId = $parentTbody.find('[name="shoppingCartCatNum"]').val();
                            fisherDataLayer.productData.productName = $parentTbody.find('.cart_description').text();
                            fisherDataLayer.events = "event119";
                            fisherDataLayer.deleteSingle = true;
                            if(typeof _satellite !== "undefined") {
                                _satellite.track("deleteItem");
                            }
                            $ajaxSelectors.removeClass('working');
                        },
                        beforeSendCallback: function () {
                            fishersci.components.CartCheckoutUI.editPartUI($this);
                        },
                        errorCallback: function () {
                            fishersci.components.CartCheckoutUI.resetEditPartUI($this);
                            $ajaxSelectors.removeClass('working');
                        }
                    })
                } else {

                    if (!validQty.result && typeof(validQty.message) !== "undefined") {
                        $this.removeClass('working');
                        $this.closest('td').find('.js-message-container').removeClass('hide').find('.js-message').text(validQty.message);
                    } else {
                    
                    //Check if this is a quoted item - if so, throw warning before updating qty
                    //Note - this is only US-specific code for now
                    if(LocalePath.getCountry().toUpperCase() === "US"){
                        if($this.data('quoteitem') == true && $this.data('editable') == false && triggeredBy != 'AssayValidation') {
                            _SELF.doInlineNotification({
                                top: ($this.offset().top - $('.shopping_cart_main').offset().top) - 10,
                                right: 15,
                                data : {
                                    originalqty : $this.data('originalqty'),
                                    elementid : $this.closest('td').prop('id')
                                }
                            });
                            return;
                        }
                    }

                    //valid qty - update qty
                    $this.closest('td').find('.js-message-container').addClass('hide');
                    options.callback = function (data) {
                        _SELF.updateCartUi({"data":data});

                        //Capture event for Adobe
                        fisherDataLayer.events = "event77,event133";
                        if(typeof _satellite !== "undefined") {
                            _satellite.track("trackEventsGeneral");
                        }
                    }

                    options.beforeSendCallback = function () {
                        fishersci.components.CartCheckoutUI.editPartUI($this);
                    }

                    options.errorCallback = function (xhr, status, error) {
                        fishersci.components.CartCheckoutUI.resetEditPartUI($this);

                        var errorJson;

                        try {
                            errorJson = JSON.parse(xhr.responseText);

                            if (errorJson.status.showError) {
                                _SELF.cartErrorModal({
                                    "message": i18nTranslations.cartUi.messages.cannotUpdateCart,
                                    "serviceErrorCode": errorJson.status.serviceErrorCode,
                                    "icon": "icon_Warning_Triangle"
                                })
                            }
                        } catch (e) {
                            console.error(e);
                        }
                    }

                    _SELF.updateCart(options);
                    } 
                }
            });

            // capturing close and cancel button in stockroom modal
            $("#cboxWrapper").on("click", "#cboxClose", function (e) {
                if(uomLocation){
                var stockroomValLoc = uomLocation.closest('tbody').hasClass('js-pickUpItem');
                console.log(stockroomValLoc);
                if (stockroomValLoc) {
                    uomLocation.closest('tbody').find('.price').each(function () {
                        if ($(this).find(".js-uom").data("selected") == "selected") {
                            $(this).find(".js-uom").prop("checked",true);
                        }
                        else{
                            $(this).find(".js-uom").attr("checked",false);
                        }
                    })
                }
            }
            });

            $("#cboxWrapper").on("click",".stockRoomModal  .cancelBtn", function (e) {
                if(uomLocation){
                var stockroomValLoc = uomLocation.closest('tbody').hasClass('js-pickUpItem');
                if (stockroomValLoc) {
                    uomLocation.closest('tbody').find('.price').each(function () {
                        if ($(this).find(".js-uom").data("selected") == "selected") {
                            $(this).find(".js-uom").prop("checked",true);
                        }
                        else{
                            $(this).find(".js-uom").attr("checked",false);
                        }
                    })
                }
            }
            });

            //listen to UOM change
            $(document).on('change', ".js-uom", function (e) {
                var $this = $(this);
                uomLocation = $this;
                e.preventDefault();
                var orderItemId = $this.closest('tbody').find('.qty-field').data('orderitemid');
                var partNumber = $this.data('partnumber');
                var uomType = $this.data('uomtype')? $this.data('uomtype') : "STD" ;
                var qty = $this.closest('tbody').find('.qty-field').val();
                var uom = $this.val();
                var stockroomVal = $this.closest('tbody').hasClass('js-pickUpItem');
                console.log(stockroomVal);
                var options = {};
                options.data = {
                    "itemList": [{
                        "partNumber": partNumber,
                        "uom": uom,
                        "quantity": qty
                    }],
                    "orderItemId": orderItemId
                };
                // stockroom modal display on uom change passing the uom and uom type value
                if (stockroomVal && !env.punchoutUser) {
                    var stockroomelement = $this.closest('.uom-column').find('.stockroom-modal');
                    stockroomelement.data('uom', uom);
                    stockroomelement.data('uom-type', uomType);
                    fishersci.components.StockRoomModal.initStockRoomElement(stockroomelement, true);
                }
                options.callback = function (data) {
                    data.updatedPartNumber = partNumber;

                    _SELF.updateCartUi({"data":data});
                    //Capture event for Adobe
                    fisherDataLayer.events = "event118";
                    if(typeof _satellite !== "undefined") {
                        _satellite.track("trackEventsGeneral");
                    }
                };

                options.beforeSendCallback = function () {
                    fishersci.components.CartCheckoutUI.editPartUI($this);
                };

                options.errorCallback = function (xhr, status, error) {
                    fishersci.components.CartCheckoutUI.resetEditPartUI($this);

                    var errorJson;

                    try {
                        errorJson = JSON.parse(xhr.responseText);

                        if (errorJson.status.showError) {
                            _SELF.cartErrorModal({
                                "message": i18nTranslations.cartUi.messages.cannotUpdateCart,
                                "serviceErrorCode": errorJson.status.serviceErrorCode,
                                "icon": "icon_Warning_Triangle"
                            })
                        }
                    } catch (e) {
                        console.error(e);
                    }
                };
                if (stockroomVal == false || env.punchoutUser) {
                    _SELF.updateCart(options);
                }
            });


            $(document).on('change', ".js-uom-accessory", function (e) {
                var $this = $(this);
                e.preventDefault();
                var uom = $this.val();
                var updateduom = $this.closest('.accessory-row').find('.js-ut-selected-uom').val(uom);
                console.log(updateduom);
            });

            //view alternate link for disc. items
            $(document).on('click', ".js-view-subs", function (e) {
                e.preventDefault();
                Handlebars.registerPartial("cart-select-alt-product", ShoppingCart.templates['cart-select-alt-product']);
                var $this = $(this);
                var originalPart = $this.data('item-row');
                var subPart = $this.data('sub-partnumber');
                var uom = $this.parent().find('.js-discontinued-uom').val();
                //var qty = $this.parent().find('.js-discontinued-qty').val();
                var data = {
                    "itemList": [
                        {
                            partNumber: subPart,
                            quantity: 1,
                            uom: uom
                        }
                    ]
                };
                var options = {};
                var html;

                //set options
                options.data = data;

                //callback to handle AJAX response
                options.callback = function (data) {

                    //if there's a lineitem, process
                    if (!data.lineItems) {
                        return;
                    }

                    //Make sure there's an object for the sub item based on its part number
                    if (!data.lineItems[subPart]) {
                        return;
                    }

                    //Mixin discontinued data
                    data = $.extend(data.lineItems[subPart], discontinuedObj[originalPart]);

                    //Add in optional data for tracking the type of modal for Adobe, etc
                    data.accessorytype = "availableSubstitute";
                    if(data.priceUoms[0].availabilities.length !== 0)
                        data.availabilityString = data.priceUoms[0].availabilities[0].availabilityString;

                    //Pull in different template for EU
                    if(LocalePath.getCountry().toUpperCase() !== "US"){
                        html = Handlebars.partials['cart-general-product'](data);
                        _SELF.doGeneralProductModal({
                            html: html
                        })
                    }else{
                        html = Handlebars.partials['cart-select-alt-product'](data);
                        _SELF.doViewAltProductModal({
                            html: html
                        })
                    }

                    //Capture event for Adobe
                    fisherDataLayer.events = "event114";
                    if(typeof _satellite !== "undefined") {
                        _satellite.track("trackEventsGeneral");
                    }
                }

                //Call alternates service
                _SELF.getAlternates(options);

            })

            //listen to Accessories links
            $(document).on('click', ".js-required-accessories , .js-warranty-services", function (e) {

                var html;
                var options = {};
                var $this = $(this);
                var accessoryType = $this.data('accessorytype');
                var originalTitle = $this.data('originaltitle');
                ;
                e.preventDefault();

                //set element
                options.element = $this;

                //callback to handle AJAX response
                options.callback = function (data) {
                    data.config = {};
                    data.config.originalProduct = {};
                    data.config.originalProduct.orderItemId = "nope";
                    data.config.header = i18nTranslations.cartUi.messages[accessoryType];
                    data.config.originalProduct.originalItemHeader = "";
                    data.config.modalMessage = originalTitle;
                    data.config.buttonText = "Test";
                    data.config.accessorytype = accessoryType;

                    //Pull in different template for mobile
                    if (fishersci.Common.getBreakpoint() === "mobile") {
                        html = Handlebars.partials['cart-accessory-modal-mobile'](data);
                    } else {
                        html = Handlebars.partials['cart-accessory-modal'](data);
                    }

                    _SELF.doGeneralProductModal({
                        html: html
                    })

                    //Capture event for Adobe
                    switch (accessoryType) {
                        case "requiredAccessories":
                            fisherDataLayer.events = "event111";
                            break;
                        default:
                            fisherDataLayer.events = "event112";
                            break;
                    }
                    if(typeof _satellite !== "undefined") {
                        _satellite.track("trackEventsGeneral");
                    }

                };

                _SELF.getAccessories(options);
            });

            //Remove a single item
            $(document).on('click', ".js-remove-item", function (e) {
                var $this = $(this);
                var orderItemId =$this.data('orderitemid');
                var isHyphen = (orderItemId.toString()).includes("-")?true : false
                //// checking the below condition to differentiate the main line item and accessory line item ///
                if(isHyphen){
                    var partNumber = ($this.data('removePartnumber').toString()).replace(/-/g, "");
                }
                if( $this.hasClass('working')){
                    return;
                }
                e.preventDefault();
                //Working..
                $ajaxSelectors.addClass('working');
                //delete the item
                _SELF.deleteItem({
                    orderItemId: orderItemId,
                    partNumber: partNumber,
                    callback: function () {
                        var $parentTbody = $this.closest('tbody');
                        //Capture event for Adobe
                        //Misc Data Layer requests
                        fisherDataLayer.productData.cartTotal = sessionStorage.getItem("cartTotal");
                        fisherDataLayer.productData.basePrice = $parentTbody.find('.js-selected-uom').data('listprice');
                        fisherDataLayer.productData.currency = "USD";
                        fisherDataLayer.productData.qty = $parentTbody.find('.js-original-qty').val();
                        fisherDataLayer.productData.productId = $parentTbody.find('[name="shoppingCartCatNum"]').val();
                        fisherDataLayer.productData.productName = $parentTbody.find('.cart_description').text();
                        fisherDataLayer.events = "event119,scRemove";
                        fisherDataLayer.products = ';' + partNumber;
                        fisherDataLayer.deleteSingle = true;
                        if(typeof _satellite !== "undefined") {
                            _satellite.track("deleteItem");
                        }
                        $ajaxSelectors.removeClass('working');
                    },
                    beforeSendCallback: function () {
                        try {
                            sessionStorage.setItem("cartTotal" , fisherDataLayer.productData.cartTotalOnLoad);
                        }catch(e){}
                        fishersci.components.CartCheckoutUI.editPartUI($this);
                    },
                    errorCallback: function () {
                        fishersci.components.CartCheckoutUI.resetEditPartUI($this);
                        $ajaxSelectors.removeClass('working');
                    }
                })

            });

            //Empty the cart, show confirmation
            $(document).on('click', ".js-delete-cart", function (e) {
                var $this = $(this);

                if( $this.hasClass('working')){
                    return;
                }

                e.preventDefault();

                var widthPercent = '20%';
                //Need to resize the popped up modal properly based on breakpoint.
                if(fishersci.Common.inDesktopBreakpoint()){
                    widthPercent='20%';
                }
                else if(fishersci.Common.inTabletBreakpoint()){
                    widthPercent='60%';
                }
                else if (fishersci.Common.inMobileBreakpoint()){
                    widthPercent='80%';
                }

                //Working..
                $ajaxSelectors.addClass('working');

                _SELF.confirmModal({
                    "header": i18nTranslations.cartUi.messages.clearYourCart,
                    "message": i18nTranslations.cartUi.messages.emptyCartMessage,
                    "buttonText": i18nTranslations.cartUi.messages.emptyCartBtn,
                    "icon": false,
                    "showCancel": true,
                    "element": $this,
                    "width": widthPercent,
                    "options": {
                        "cartLineItems": cartLineItems
                    }
                },
                _SELF.deleteItem,
                {
                    "deleteallitems": true,
                    "this": _SELF,
                    callback: function () {
                        //Delete CART_ID cookie
                        $.removeCookie('CART_ID', {path: "/"});
                        $.removeCookie("addToCartInitiated", { expires: -1, path: "/" });
                        if (fishersci.Common.inMobileBreakpoint() || fishersci.Common.inTabletBreakpoint()){
                            var mobileCheckoutModal = document.querySelector(".mobile-checkout-modal");
                            hideableCheckoutButton = mobileCheckoutModal.querySelector(".hideable-checkout-button");
                            hideableCheckoutButton.classList.add("hide");
                            $(".js-checkout-button").addClass("disabled");
                        }

                        //Set up data layer
                        fisherDataLayer.cart = [];
                        $('.shopping_cart_main tbody.cart-ui-product-table').each(function() {
                            var products = {};
                            var $parentTbody = $(this);
                            products.cartTotal =  sessionStorage.getItem("cartTotal");
                            products.basePrice = $parentTbody.find('.js-selected-uom').data('listprice');
                            products.currency = "USD";
                            products.qty = $parentTbody.find('.js-original-qty').val();
                            products.productId = $parentTbody.find('[name="shoppingCartCatNum"]').val();
                            products.productName = $parentTbody.find('.cart_description').text();
                            fisherDataLayer.cart.push(products);
                        });

                        //Done working..
                        $ajaxSelectors.removeClass('working');
                    },
                    beforeSendCallback: function(){
                        try {
                            sessionStorage.setItem("cartTotal" , fisherDataLayer.productData.cartTotalOnLoad);
                        }catch(e){

                        }
                    }
                }
                );
            });
            //Remove config items
            $(document).on('click', ".js-remove-config", function (e) {
                var $this = $(this);
                var configOrder = $this.data('itemtype');

                if( $this.hasClass('working')){
                    return;
                }

                e.preventDefault();

                //Working..
                $ajaxSelectors.addClass('working');

                _SELF.deleteConfigItem
                ({
                    configOrder: configOrder,
                    beforeSendCallback: function () {
                        fishersci.components.CartCheckoutUI.editPartUI($this);
                    },
                    errorCallback: function () {
                        fishersci.components.CartCheckoutUI.resetEditPartUI($this);
                        //Done working..
                        $ajaxSelectors.removeClass('working');
                    }
                })
            });

            //radio buttons for modal items - need to update hidden input UOM field
            $(document).on('click', '.js-modal-uom', function () {
                var $this = $(this);
                var uom = $this.val();
                var $costSavings = $this.data('costsavings');

                //update hidden field
                $this.closest('.js-item-row').find('[name="selectedUom"]').val(uom);

                //Update Savings if applicable
                if ( $costSavings !== "" ){
                    $('.js-switch-save').text($costSavings);
                }
            });

            $(document).on('click', '.js-modal-uom-mobile', function () {
                var $this = $(this);
                var uom = $this.val();
                var $costSavings = $this.data('costsavings');

                //update hidden field
                $this.closest('.mobile-js-item-row').find('[name="selectedUom"]').val(uom);

                //Update Savings if applicable
                if ( $costSavings !== "" ){
                    $('.js-switch-save').text($costSavings);
                }
            });

            //Add to cart button for modal items
            $(document).on('click', '.js-cart-modal-add-button', function (e) {
                e.preventDefault();
                var $this = $(this);

                //which action?
                var action = $this.data("action");

                //build item details
                var partNumber = $this.attr('data-partnumber').replace(/-/g, "");
                var orderItemId = $this.attr('data-original-order-id');
                if (screenWidth == 320) {
                    var $row = $('#generalProductModal').find('.mobile-js-item-row');
                }
                else {
                    var $row = $this.closest('.js-item-row');
                }
                var uom = $row.find('[name="selectedUom"]').val();
                var qty = $row.find('.qty-field').val() || 1;
                var $messageContainer = $row.find('.js-message-container');
                var validQty = _SELF.validateQty(qty);
                var data = {};
                var omnitureParts = [];
                var accessoryType = $this.data('accessorytype');
                var addToCartFrom = "In-Cart " + accessoryType;

                //Add analytics tracking
                omnitureParts.push(partNumber);


                //send different data based on 'action'
                switch (action) {
                    case "switch" :
                        data = {
                            "addToCartFrom": "Product switch",
                            "itemList": [{
                                "partNumber": partNumber,
                                "uom": uom,
                                "quantity": qty
                            }],
                            "orderItemId": orderItemId
                        };
                        break;

                    case "add" :
                        data = {
                            "addToCartFrom": "In-Cart Req Accessories",
                            "itemList": [{
                                "partNumber": partNumber,
                                "uom": uom,
                                "quantity": qty
                            }]
                        };
                        break;
                    default :
                        break;
                }


                //bad qty
                if (!validQty.result && typeof(validQty.message) !== "undefined") {
                    $messageContainer.removeClass('hide').find('.js-message').text(validQty.message);
                } else {
                    //valid qty - add to cart
                    $messageContainer.addClass('hide');
                    _SELF.addToCart({
                        data: data,
                        updateUi: false,
                        callback: function (data) {
                            $this.find('span').remove();

                            //Show item qty total if available
                            if (data.itemQtyTotal) {
                                $this.append("&nbsp;<span>(" + data.itemQtyTotal + ")</span>")
                            }

                            //if any url-query messages, reload the cart
                            fishersci.components.CartCheckoutUI.checkResponseForMessages({data: data});

                            //Close modal if switch action
                            if (action == "switch") {
                                $.colorbox.close();
                            }


                            //update shipping and tax
                            if(env.punchoutUser  && !env.punchoutUseShippingAndTaxService){
                                fishersci.components.CartCheckoutUI.updateCartUi({"data" : data});
                            } else {
                                fishersci.components.CartCheckoutUI.updateShippingAndTax();
                            }
                            fishersci.components.CartCheckoutUI.doAfterUiUpdate(data);

                            fishersci.components.CartCheckoutUI.addToCartAnalytics({
                                "parts": omnitureParts,
                                "addToCartFrom": addToCartFrom
                            });
                        }

                    })
                }
                //resize to handle messages, etc
                //$.colorbox.resize();
            });

            //List for preferred product link clicks
            $(document).on('click', '.js-general-product', function (e) {
                e.preventDefault();
                var html;
                var preferredId = $(this).attr('data-preferred-id');
                var data = preferredObj[preferredId];

                //Add in accessory / alt type label for Adobe tracking - will show up as data attribute on add to cart button
                data.accessorytype = "alternativeOption";

                //process template
                if (fishersci.Common.getBreakpoint() === "mobile") {
                    html = Handlebars.partials['cart-general-product-mobile'](data);
                } else {
                    html = Handlebars.partials['cart-general-product'](data);
                }

                //display contents in modal
                _SELF.doGeneralProductModal({
                    html: html
                })

                //Capture event for Adobe
                fisherDataLayer.events = "event113";
                if(typeof _satellite !== "undefined") {
                    _satellite.track("trackEventsGeneral");
                }

            });

            //Listen to configurable item Edit buttons
            $(document).on('click', '.js-config-edit', function (e) {
                var theURL = document.location.href;
                var $this = $(this);
                var configNumber = $this.data('confignumber');
                var vendorIdentity = $this.data('vendorid');
                var formAction = $this.data('editurl');
                var gsessionId = $.cookie('gsessionId');

                //new Config, different form action
                if($.cookie('new_config')){
                    formAction = '/store1/configuratorpunchout/'
                }

                e.preventDefault();

                //Send events to Omniture
                fisherDataLayer.uiLabel = "Edit Configurator Item - Vendor " + vendorIdentity;
                fisherDataLayer.customLinkGeneral = "UI Event captured: Edit Configurator Item - Vendor " + vendorIdentity;
                if(typeof _satellite !== "undefined") {
                    _satellite.track('trackUiGeneral');
                }

                //update configurator form and submit it
                document.ConfiguratorsEditCartForm.idCfgNbr.value = configNumber;
                document.ConfiguratorsEditCartForm.gSessionId.value = gsessionId;
                document.ConfiguratorsEditCartForm.vendorIdentity.value = vendorIdentity;
                document.ConfiguratorsEditCartForm.currentURL.value = theURL;
                document.ConfiguratorsEditCartForm.action = formAction;
                document.ConfiguratorsEditCartForm.submit();
            })

            //Add listener for new add to list
            $(document).on('click', '.cart-item-add-to-list', function(e) {
                e.preventDefault();
                $('.create_list_error').remove();
                var $this = $(this);
                var partNumber = $this.data('partnumber');
                var unit = $this.data('unit');
                var description = $this.data('shortdesc');
                var quantity = $this.data('qty');

                fisherDataLayer.generalData.pageType = 'MyList';
                fisherDataLayer.eventAction = 'Add to List';
                fisherDataLayer.eventLocation = 'Cart';
                fisherDataLayer.events = 'event161';

                if(typeof _satellite !== "undefined") {
                    _satellite.track('event_tracking');
                }

                $.ajax({
                    url: "/store1/mylist/service/addtolist",
                    method: "POST",
                    contentType: "application/json",
                    data: JSON.stringify({
                        "partNumbers": [
                            {
                                partNumber: partNumber,
                                unit: unit,
                                description: description,
                                quantity: quantity
                            }
                        ],
                        "language": LocalePath.getLanguage(),
                        "countryCode": LocalePath.getCountry(),
                        "time": Date.now(),
                        "top": $this.offset().top + 30,
                        "horizontalPosition": $this.offset().left + 40
                    }),
                    beforeSend: function() {
                        fishersci.components.CartCheckoutUI.addSpinnerToElement($this);
                    },
                    success: function(data) {
                        $('body').append(data);
                        $('.create_list_error').remove();

                        fishersci.components.CartCheckoutUI.removeSpinnerFromElement($this);

                        addNewAddToListObserver(function(name, args) {
                            switch (name) {
                                case "ADDED_TO_LIST":
                                    $this.html('<span class="js_add_to_list css_add_to_list bold"><span class="icon_Check valid"></span>' + i18nTranslations.cartUi.messages.addedToList + '</span>');
                                    break;
                                case "DUPLICATED_LIST_TITLE":
                                    //$this.parent().parent().append('<span class="create_list_error"><span class="font_icon icon_Warning_Triangle"></span>' + i18nTranslations.cartUi.messages.newListName + '</span>');
                                    break;
                                case "ERROR_ADDING_TO_EXISTING_LIST":
                                case "ERROR_ADDING_TO_NEW_LIST":
                                    //$this.parent().parent().append('<span class="create_list_error"><span class="font_icon icon_Warning_Triangle"></span>' + i18nTranslations.cartUi.messages.notAddedToList + '</span>');
                                    break;
                                default:
                                    break;
                            }
                        });
                    }
                });
            });

            $(document).on('click', '.cart-item-add-all-to-list', function(e) {
                e.preventDefault();

                var $this = $(this);
                var partNumbers = [];
                $(".cart-item-add-to-list").each(function(x, y) {
                    var $el = $(y);
                    var partNumber = {
                        partNumber: $el.data('partnumber'),
                        unit: $el.data('unit'),
                        description: $el.data('shortdesc'),
                        quantity: $el.data('qty')
                    }
                    partNumbers.push(partNumber);
                });

                fisherDataLayer.generalData.pageType = 'MyList';
                fisherDataLayer.eventAction = 'Add all to List';
                fisherDataLayer.eventLocation = 'Cart';
                fisherDataLayer.events = 'event161';

                if(typeof _satellite !== "undefined") {
                    _satellite.track('event_tracking');
                }

                $.ajax({
                    url: "/store1/mylist/service/addtolist",
                    method: "POST",
                    contentType: "application/json",
                    data: JSON.stringify({
                        "partNumbers": partNumbers,
                        "language": LocalePath.getLanguage(),
                        "countryCode": LocalePath.getCountry(),
                        "time": Date.now(),
                        "top": $this.offset().top + 40,
                        "horizontalPosition": $this.offset().left + 80
                    }),
                    beforeSend: function() {
                        fishersci.components.CartCheckoutUI.addSpinnerToElement($this);
                    },
                    success: function(data) {
                        $('body').append(data);
                        $('.create_list_error').remove();

                        fishersci.components.CartCheckoutUI.removeSpinnerFromElement($this);

                        addNewAddToListObserver(function(name, args) {
                            switch (name) {
                                case "ADDED_TO_LIST":
                                    $this.html('<span class="js_add_to_list css_add_to_list bold"><span class="icon_Check valid"></span>' + i18nTranslations.cartUi.messages.addedToList + '</span>');
                                    break;
                                case "DUPLICATED_LIST_TITLE":
                                    //$this.parent().parent().append('<span class="create_list_error"><span class="font_icon icon_Warning_Triangle"></span>' + i18nTranslations.cartUi.messages.newListName + '</span>');
                                    break;
                                case "ERROR_ADDING_TO_EXISTING_LIST":
                                case "ERROR_ADDING_TO_NEW_LIST":
                                    //$this.parent().parent().append('<span class="create_list_error"><span class="font_icon icon_Warning_Triangle"></span>' + i18nTranslations.cartUi.messages.notAddedToList + '</span>');
                                    break;
                                default:
                                    break;
                            }
                        });
                    }
                });
            });

            // Save for later functionality

            $(document).on('click', '.js-save-for-later', function(e) {
                e.preventDefault();
                // save single item in cart for later

                var $this = $(this);
                var saveId = localStorage.getItem('saveForLaterCartId') || null;
                var cartId = $.cookie('CART_ID') || null;
                var subtotal = (window.digitalData && window.digitalData.cart && window.digitalData.cart.subtotal) ? window.digitalData.cart.subtotal : 0;
                var data = {
                    "saveForLaterCartId": saveId,
                    "itemList": [
                        {
                            "partNumber": $this.data('partnumber'),
                            "quantity": $this.data('qty'),
                            "uom": $this.data('unit'),
                            "uomType": $this.data('uomtype'),
                            "orderItemId": $this.closest('tbody').data('containerOrderitemid')
                        }
                    ],
                    "addToCartFrom": "Save Item for Later"
                };

                var saveForLaters = $(".js-save-for-later");
                var partSubtotal = $this.data('subtotal') || 0;
                var partPrice = $this.data('price') || 0;
                if (window.fisherAnalytics && window.fisherAnalytics.utils && typeof window.fisherAnalytics.utils.cleanAndConvertToFloat === 'function') {
                    partSubtotal = window.fisherAnalytics.utils.cleanAndConvertToFloat(partSubtotal);
                    partPrice = window.fisherAnalytics.utils.cleanAndConvertToFloat(partPrice);
                }
                if (saveForLaters.length > 1) {
                    document.dispatchEvent(new CustomEvent("saveForLater", {
                        detail: {
                            product: {
                                name: $this.data('title'),
                                id: $this.data('partnumber'),
                                price: partPrice,
                                quantity: $this.data('qty'),
                                variation: $this.data('unit'),
                                discount: ""
                            },
                            total: partSubtotal //analytics event for save when not the last item
                        }}));
                }

                $.ajax({
                    url : '/store1/cart/saveforlater/save/?language=' + LocalePath.getLanguage().toLowerCase() + '&countryCode=' + LocalePath.getCountry().toUpperCase(),
                    type: 'POST',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: JSON.stringify(data),
                    beforeSend: function() {
                        fishersci.components.CartCheckoutUI.editPartUI($this);
                    },
                    success: function(data) {
                        //Set this value on every save or save all
                        localStorage.setItem('saveForLaterCartId', data.saveForLaterCartId);

                        //Capture event for Adobe
                        if(data.cartEmpty){
                            document.dispatchEvent(new CustomEvent("cartSaved", {detail:{cartId: cartId, subtotal: subtotal}}));
                            delete window.digitalData.cart;
                            localStorage.removeItem('cartDetails');
                            localStorage.removeItem('cartFindingMethod');
                        }
                        fisherDataLayer.products=";" + $this.data('partnumber');
                        fisherDataLayer.uiLabel = "Item Saved for Later";
                        fisherDataLayer.customLinkGeneral = "UI Event captured: Item Saved for Later";
                        if(typeof _satellite !== "undefined") {
                            _satellite.track('trackUiGeneral');
                        }

                        _SELF.updateCartUi({"data":data});
                        _SELF.getSavedForLaterItems();
                    },
                    error: function(xhr) {
                        console.log(xhr);
                    },
                    done: function() {
                        fishersci.components.CartCheckoutUI.resetEditPartUI($this);
                    }
                });
            });

            $(document).on('click', '#saveAllForLater', function(e) {
                e.preventDefault();
                // save all items in cart for later
                var $this = $(this);
                var saveId = localStorage.getItem('saveForLaterCartId') || null;
                var cartId = $.cookie('CART_ID') || null;
                var subtotal = (window.digitalData && window.digitalData.cart && window.digitalData.cart.subtotal) ? window.digitalData.cart.subtotal : 0;
                var items = [];
                var adobeProductString = [];

                $(".js-save-for-later").each(function(x, y) {
                    var $el = $(y);
                    var item = {
                        "partNumber": $el.data('partnumber'),
                        "quantity": $el.data('qty'),
                        "uom": $el.data('unit'),
                        "uomType": $el.data('uomtype') ? $el.data('uomtype') : "STD",
                        "orderItemId": $el.closest('tbody').data('containerOrderitemid')
                    }
                    items.push(item);
                    adobeProductString.push(";" + $el.data('partnumber'));
                });

                var data = {
                    "saveForLaterCartId": saveId,
                    "itemList": items,
                    "addToCartFrom": "Save Items for Later",
                    "saveall": true
                };

                $.ajax({
                    url : '/store1/cart/saveforlater/save/?language=' + LocalePath.getLanguage().toLowerCase() + '&countryCode=' + LocalePath.getCountry().toUpperCase(),
                    type: 'POST',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: JSON.stringify(data),
                    beforeSend: function() {
                        fishersci.components.CartCheckoutUI.addSpinnerToElement($this, {"image": "transparent-loader.gif", "position":"after"});
                    },
                    success: function(data) {
                        //Set this value on every save or save all
                        localStorage.setItem('saveForLaterCartId', data.saveForLaterCartId);

                        //Capture event for Adobe
                        document.dispatchEvent(new CustomEvent("cartSaved", {detail:{cartId: cartId, subtotal: subtotal}}));
                        delete window.digitalData.cart;
                        localStorage.removeItem('cartDetails');
                        localStorage.removeItem('cartFindingMethod');
                        fisherDataLayer.products = adobeProductString.join(",");
                        fisherDataLayer.uiLabel = "All Items Saved for Later";
                        fisherDataLayer.customLinkGeneral = "UI Event captured: All Items Saved for Later";
                        if(typeof _satellite !== "undefined") {
                            _satellite.track('trackUiGeneral');
                        }

                        _SELF.updateCartUi({"data":data});
                        _SELF.getSavedForLaterItems();
                    },
                    error : function(xhr) {
                        console.log(xhr);
                    },
                    done: function() {
                        fishersci.components.CartCheckoutUI.removeSpinnerFromElement($this);
                    }
                });
            });

            $(document).on('click', '.js-remove-saved-item', function(e) {
                e.preventDefault();
                // remove single saved item for later

                var $this = $(this);
                var saveId = localStorage.getItem('saveForLaterCartId') || null;
                var $partNumber = $(this).data('partnumber');
                var $qty = $(this).data('qty');
                var data = {
                    "saveForLaterCartId": saveId,
                    "orderItemId": $this.closest('tbody').data('containerOrderitemid')
                };

                $.ajax({
                    url : '/store1/cart/saveforlater/delete/?language=' + LocalePath.getLanguage().toLowerCase() + '&countryCode=' + LocalePath.getCountry().toUpperCase(),
                    type: 'POST',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: JSON.stringify(data),
                    beforeSend: function() {
                        fishersci.components.CartCheckoutUI.editPartUI($this);
                    },
                    success: function(data) {
                        //Capture event for Adobe
                        fisherDataLayer.uiLabel = "Single Saved for Later item Deleted";
                        fisherDataLayer.customLinkGeneral = "UI Event captured: Single Saved for Later Item Deleted";
                        fisherDataLayer.products = ';' + $partNumber + ';' + $qty;
                        fisherDataLayer.events = "scRemove";
                        if(typeof _satellite !== "undefined") {
                            _satellite.track('trackUiGeneral');
                        }
                        //Render saved item count
                        if( typeof data.saveForLaterItems !== "undefined" ){
                            data.saveForLaterItemCount = Object.keys(data.saveForLaterItems).length;
                        }

                        //update ID
                        localStorage.setItem('saveForLaterCartId', data.saveForLaterCartId);
                        //update UI
                        _SELF.updateSaveForLaterUi({"data":data});
                        _SELF.initToolTips();
                        $(".js-checkout-button").removeClass("disabled");
                    },
                    error : function(xhr) {
                        if (xhr.status === 200 && xhr.statusText == 'OK') {
                            _SELF.getSavedForLaterItems();
                        }
                    },
                    done: function() {
                        fishersci.components.CartCheckoutUI.resetEditPartUI($this);
                    }
                });
            });

            $(document).on('click', '#qa_delete_saved_items', function(e) {   // remove all saved items for later
                e.preventDefault();
                var $this = $(this);
                var modalWidth = "20%"; //default modal width
                //Need to resize the popped up modal properly based on breakpoint.
                if (screenWidth == 768 || screenWidth == 992){
                    modalWidth = '50%';
                } else if(screenWidth == 320){
                    modalWidth = '80%';
                }
                _SELF.confirmModal({
                    "header": i18nTranslations.cartUi.messages.clearYourSFL,
                    "message": i18nTranslations.cartUi.messages.emptySFLMessage,
                    "buttonText": i18nTranslations.cartUi.messages.emptyCartBtn,
                    "icon": false,
                    "showCancel": true,
                    "element": $this,
                    "width": modalWidth
                },
                _SELF.deleteAllSavedItems,
                {
                    "this": _SELF,
                    beforeSendCallback: function() {
                        fishersci.components.CartCheckoutUI.addSpinnerToElement($this, {"image": "transparent-loader.gif", "position":"after"});
                    },
                    callback: function() {
                        var adobeProductString = [];
                        //loop current saved items and build product string for Adobe to track
                        for(var part in fisherDataLayer.savedItems){
                            if( typeof fisherDataLayer.savedItems[part] !== 'function'){
                                adobeProductString.push(';' + fisherDataLayer.savedItems[part].savedPartNumber + ';' + fisherDataLayer.savedItems[part].savedPartQty + ';;;');
                            }
                        }
                        localStorage.removeItem('saveForLaterCartId');
                        _SELF.getSavedForLaterItems();
                        fishersci.components.CartCheckoutUI.removeSpinnerFromElement($this);
                        $('.save-for-later-footer').addClass('hide') //hide footer for S4L

                        //Capture event for Adobe
                        fisherDataLayer.uiLabel = "All Saved for Later Items Deleted";
                        fisherDataLayer.customLinkGeneral = "UI Event captured: All Saved for Later Items Deleted";
                        fisherDataLayer.products = adobeProductString.join(",");
                        fisherDataLayer.events = "scRemove";

                        if(typeof _satellite !== "undefined") {
                            _satellite.track('trackUiGeneral');
                        }
                    },
                    errorCallback: function(xhr) {
                        if (xhr.status === 200 && xhr.statusText == 'OK') {
                            localStorage.removeItem('saveForLaterCartId');
                            _SELF.getSavedForLaterItems();
                        }
                        fishersci.components.CartCheckoutUI.removeSpinnerFromElement($this);
                    }
                })
            });

            $(document).on('click', '.js-move-to-cart', function(e) {
                e.preventDefault();
                // move single saved item to cart

                var $this = $(this);
                var saveId = localStorage.getItem('saveForLaterCartId') || null;
                var $partNumber = $this.data('partnumber');
                var omnitureParts = [];
                var data = {
                    "saveForLaterCartId": saveId,
                    "itemList": [
                        {
                            "partNumber": $partNumber,
                            "quantity": $this.data('qty'),
                            "uom": $this.data('unit'),
                            "uomType": $this.data('uomtype')? $this.data('uomtype') : "STD",
                            "orderItemId": $this.closest('tbody').data('containerOrderitemid')
                        }
                    ],
                    "addToCartFrom": "Save Item for Later",
                    "fromSaveForlater": "true"
                };

                $.ajax({
                    url : '/store1/cart/saveforlater/movetocart/?language=' + LocalePath.getLanguage().toLowerCase() + '&countryCode=' + LocalePath.getCountry().toUpperCase(),
                    type: 'POST',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: JSON.stringify(data),
                    beforeSend: function() {
                        fishersci.components.CartCheckoutUI.editPartUI($this);
                    },
                    success: function(data) {
                        var shippingAndTaxData = {};

                        _SELF.updateCartUi({"data":data});
                        _SELF.getSavedForLaterItems();

                        //Check for duplicate items
                        if ( typeof data.duplicateQuoteItems !== "undefined" ){
                            shippingAndTaxData.duplicateQuoteItems = data.duplicateQuoteItems;
                        }

                        //Check for messages
                        if (typeof data.messageList !== "undefined") {
                            $.each(data.messageList, function (key, value) {
                                if (value === "DUPLICATE_ITEM") {
                                    shippingAndTaxData.DUPLICATE_ITEM = true;
                                }
                            })
                        }

                        if( data.wasAdded && ( data.productsNotFoundQuickAdd == "" || !data.productsNotFoundQuickAdd ) ){
                            if(env.punchoutUser && !env.punchoutUseShippingAndTaxService){
                                fishersci.components.CartCheckoutUI.updateCartUi({"data":$.extend(data,shippingAndTaxData)})
                            } else {
                                fishersci.components.CartCheckoutUI.updateShippingAndTax(shippingAndTaxData);
                            }
                        } else {
                            //Pass bad parts into shipping and tax call so we can stuff them in the JSON
                            shippingAndTaxData.productsNotFoundQuickAdd = data.productsNotFoundQuickAdd;

                            if(env.punchoutUser  && !env.punchoutUseShippingAndTaxService){
                                fishersci.components.CartCheckoutUI.updateCartUi({"data":$.extend(data,shippingAndTaxData)})
                            } else {
                                fishersci.components.CartCheckoutUI.updateShippingAndTax(shippingAndTaxData);
                            }
                        }

                        omnitureParts.push($partNumber);

                        //Treat as Add to Cart for Adobe
                        fishersci.components.CartCheckoutUI.addToCartAnalytics({
                            "parts": omnitureParts,
                            "addToCartFrom": "Move to Cart from Saved Items"
                        });

                    },
                    error : function(xhr) {
                        console.log(xhr);
                    },
                    done: function() {
                        fishersci.components.CartCheckoutUI.resetEditPartUI($this);
                    }
                });
            });

            $(document).on('click', '#movealltocart', function(e) {   // move all saved for later items to cart
                e.preventDefault();
                var $this = $(this);
                var saveId = localStorage.getItem('saveForLaterCartId') || null;
                var items = [];
                var omnitureParts = [];

                $(".js-move-to-cart").each(function(x, y) {
                    var $el = $(y);
                    var $partNumber = $el.data('partnumber');
                    var item = {
                        "partNumber": $partNumber,
                        "quantity": $el.data('qty'),
                        "uom": $el.data('unit'),
                        "uomType": $el.data('uomtype')? $el.data('uomtype') : "STD",
                        "orderItemId": $el.closest('tbody').data('containerOrderitemid')
                    }
                    items.push(item);
                    omnitureParts.push($partNumber);
                });

                var data = {
                    "saveForLaterCartId": saveId,
                    "itemList": items,
                    "addToCartFrom": "Save Items for Later",
                    "moveall": true,
                    "fromSaveForlater": "true"
                };

                $.ajax({
                    url : '/store1/cart/saveforlater/movetocart/?language=' + LocalePath.getLanguage().toLowerCase() + '&countryCode=' + LocalePath.getCountry().toUpperCase(),
                    type: 'POST',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: JSON.stringify(data),
                    beforeSend: function() {
                        fishersci.components.CartCheckoutUI.addSpinnerToElement($this, {"image": "transparent-loader.gif", "position":"after"});
                    },
                    success: function(data) {
                        localStorage.removeItem('saveForLaterCartId');

                        var shippingAndTaxData = {};

                        _SELF.updateCartUi({"data":data});
                        _SELF.getSavedForLaterItems();

                        //Check for duplicate items
                        if ( typeof data.duplicateQuoteItems !== "undefined" ){
                            shippingAndTaxData.duplicateQuoteItems = data.duplicateQuoteItems;
                        }

                        //Check for messages
                        if (typeof data.messageList !== "undefined") {
                            $.each(data.messageList, function (key, value) {
                                if (value === "DUPLICATE_ITEM") {
                                    shippingAndTaxData.DUPLICATE_ITEM = true;
                                }
                            })
                        }

                        if( data.wasAdded && ( data.productsNotFoundQuickAdd == "" || !data.productsNotFoundQuickAdd ) ){
                            if(env.punchoutUser && !env.punchoutUseShippingAndTaxService){
                                fishersci.components.CartCheckoutUI.updateCartUi({"data":$.extend(data,shippingAndTaxData)})
                            } else {
                                fishersci.components.CartCheckoutUI.updateShippingAndTax(shippingAndTaxData);
                            }
                        } else {
                            //Pass bad parts into shipping and tax call so we can stuff them in the JSON
                            shippingAndTaxData.productsNotFoundQuickAdd = data.productsNotFoundQuickAdd;

                            if(env.punchoutUser  && !env.punchoutUseShippingAndTaxService){
                                fishersci.components.CartCheckoutUI.updateCartUi({"data":$.extend(data,shippingAndTaxData)})
                            } else {
                                fishersci.components.CartCheckoutUI.updateShippingAndTax(shippingAndTaxData);
                            }
                        }

                        fishersci.components.CartCheckoutUI.removeSpinnerFromElement($this);
                        $('.save-for-later-footer').addClass('hide') //hide footer for S4L
                        //Treat as Add to Cart for Adobe
                        fishersci.components.CartCheckoutUI.addToCartAnalytics({
                            "parts": omnitureParts,
                            "addToCartFrom": "Move to Cart from Saved Items"
                        });
                    },
                    error : function(xhr) {
                        console.log(xhr);
                    },
                    done: function() {
                        //
                    }
                });
            });
        },
        initVariables: function () {
            $_SHOPPING_CART_PROGRESS = $('.shopping_cart_progress');
            $_SHIPPING_FORM = $('.shipping_info_block');
            $_CUSTOMER_DATA_FORM = $('#customer_specific_data');
            $_FORM_ERRORS = $('.form_errors');
            $_PAYMENT_FORM = $('[data-formname="payment"]');
            $_CHECKOUT_FORM = $('.checkout_form');
            $_MEMBER_ID = $('#memberId').val();
            _GUEST_CHECKOUT_MODAL = '/content/fishersci/en_US/guestcheckoutlogin.html';
            $_VALID_ZIP_ELEMENT = $('#stateZipValid');
            $_DATA_ERROR_MESSAGE = 'data-form-error-message';
            _DATA_ZIP_TYPE = 'data-zip-type';
            $_STATE_ZIP_ELEMENT = $('[data-zip-type]');
            _CART_SERVICE = '/store1/cart/service?language=' + LocalePath.getLanguage().toUpperCase() + '&countryCode=' + LocalePath.getCountry().toUpperCase();
            _CONFIRMATION_SERVICE = '/shop/service/orderconfirmation';
            isPunchout = $('#isPunchout').length > 0;
            $ajaxSelectors = $('.js-remove-item , .js-uom, .qty-field, .js-promo-code-input, .js-delete-cart');
            maximumLineItemsForQuote = 100;

            //Set up partials for use on the CLIENT SIDE - make sure to register any new templates here
            Handlebars.registerPartial("cart-assay-id-field", ShoppingCart.templates['cart-assay-id-field']);
            Handlebars.registerPartial("cart-account", ShoppingCart.templates['cart-account']);
            Handlebars.registerPartial("cart-errors", ShoppingCart.templates['cart-errors']);
            Handlebars.registerPartial("cart-footer", ShoppingCart.templates['cart-footer']);
            Handlebars.registerPartial("cart-footer-messages", ShoppingCart.templates['cart-footer-messages']);
            Handlebars.registerPartial("cart-header", ShoppingCart.templates['cart-header']);
            Handlebars.registerPartial("cart-header-msg", ShoppingCart.templates['cart-header-msg']);
            Handlebars.registerPartial("cart-layout", ShoppingCart.templates['cart-layout']);
            Handlebars.registerPartial("cart-order-summary", ShoppingCart.templates['cart-order-summary']);
            Handlebars.registerPartial("cart-order-summary-empty", ShoppingCart.templates['cart-order-summary-empty']);
            Handlebars.registerPartial("cart-order-summary-mobile", ShoppingCart.templates['cart-order-summary-mobile']);
            Handlebars.registerPartial("cart-product-table", ShoppingCart.templates['cart-product-table']);
            Handlebars.registerPartial("cart-pci-warning", ShoppingCart.templates['cart-pci-warning']);
            Handlebars.registerPartial("cart-product-table-invalid", ShoppingCart.templates['cart-product-table-invalid']);
            Handlebars.registerPartial("cart-standard-item", ShoppingCart.templates['cart-standard-item']);
            Handlebars.registerPartial("cart-standard-item-accessories", ShoppingCart.templates['cart-standard-item-accessories']);
            Handlebars.registerPartial("cartlet", ShoppingCart.templates['cartlet']);
            Handlebars.registerPartial("cart-zip-code-form", ShoppingCart.templates['cart-zip-code-form']);
            Handlebars.registerPartial("cartlet-dev", ShoppingCart.templates['cartlet-dev']);
            Handlebars.registerPartial("cart-general-product", ShoppingCart.templates['cart-general-product']);
            Handlebars.registerPartial("cart-select-alt-product", ShoppingCart.templates['cart-select-alt-product']);
            Handlebars.registerPartial("cart-general-product-mobile", ShoppingCart.templates['cart-general-product-mobile']);
            Handlebars.registerPartial("cart-accessory-modal", ShoppingCart.templates['cart-accessory-modal']);
            Handlebars.registerPartial("cart-modal-item-row", ShoppingCart.templates['cart-modal-item-row']);
            Handlebars.registerPartial("cart-modal-item-row-invalid", ShoppingCart.templates['cart-modal-item-row-invalid']);
            Handlebars.registerPartial("cart-accessory-modal-mobile", ShoppingCart.templates['cart-accessory-modal-mobile']);
            Handlebars.registerPartial("cart-modal-item-row-mobile", ShoppingCart.templates['cart-modal-item-row-mobile']);
            Handlebars.registerPartial("cart-modal-item-row-invalid-mobile", ShoppingCart.templates['cart-modal-item-row-invalid-mobile']);
            Handlebars.registerPartial("cart-promotions", ShoppingCart.templates['cart-promotions']);
            Handlebars.registerPartial("confirm-modal", ShoppingCart.templates['confirm-modal']);
            Handlebars.registerPartial("cart-error-modal", ShoppingCart.templates['cart-error-modal']);
            Handlebars.registerPartial("cart-share-email", ShoppingCart.templates['cart-share-email']);
            Handlebars.registerPartial("cart-share-email-form", ShoppingCart.templates['cart-share-email-form']);
            Handlebars.registerPartial("cart-configurator", ShoppingCart.templates['cart-configurator']);
            Handlebars.registerPartial("cart-notifications", ShoppingCart.templates['cart-notifications']);
            Handlebars.registerPartial("cart-b2b-web-quote", ShoppingCart.templates['cart-b2b-web-quote']);
            Handlebars.registerPartial("cart-availability", ShoppingCart.templates['cart-availability']);
            Handlebars.registerPartial("cart-stockroom-availability", ShoppingCart.templates['cart-stockroom-availability']);
            Handlebars.registerPartial("cart-reference-fields", ShoppingCart.templates['cart-reference-fields']);
            Handlebars.registerPartial("cart-reference-fields-config", ShoppingCart.templates['cart-reference-fields-config']);
            Handlebars.registerPartial("cart-csd-fields", ShoppingCart.templates['cart-csd-fields']);
            Handlebars.registerPartial("cart-icon-links", ShoppingCart.templates['cart-icon-links']);
            Handlebars.registerPartial("cart-saved-product-table", ShoppingCart.templates['cart-saved-product-table']);
            Handlebars.registerPartial("cart-saved-product-footer", ShoppingCart.templates['cart-saved-product-footer']);
            Handlebars.registerPartial("cart-saved-standard-item", ShoppingCart.templates['cart-saved-standard-item']);
            Handlebars.registerPartial("cart-saved-items-layout", ShoppingCart.templates['cart-saved-items-layout']);
            Handlebars.registerPartial("cart-unavailable-item", ShoppingCart.templates['cart-unavailable-item']);
            Handlebars.registerPartial("cart-unavailable-product-table", ShoppingCart.templates['cart-unavailable-product-table']);
            Handlebars.registerPartial("cart-add-to-list-link", ShoppingCart.templates['cart-add-to-list-link']);
            Handlebars.registerPartial("cart-web-quote-sales-quote", ShoppingCart.templates['cart-web-quote-sales-quote']);
            Handlebars.registerPartial("cart-web-quote-buttons", ShoppingCart.templates['cart-web-quote-buttons']);
            Handlebars.registerPartial("cart-mobile-checkout-modal", ShoppingCart.templates['cart-mobile-checkout-modal']);


            //Helpers
            //Helper to determine if we have to show the bulky message row on the line item level
            Handlebars.registerHelper("showMessageRow", function (orderitemId, root, options){
                var itemDerived;
                var item;

                //Make sure this is a valid item
                if(typeof root.lineItems !== "undefined"){
                    item = root.lineItems[orderitemId];
                } else {
                    return options.inverse(this);
                }

                if(typeof item !=="undefined" && typeof item.itemDerived !== "undefined"){
                    itemDerived = item.itemDerived;
                } else {
                    return options.inverse(this);
                }

                //Check the various scenarios that would generate a message in this <tr>
                if(item.preferredItems
                    || (typeof item.preferredMessages !== "undefined" && item.preferredMessages.length > 0)
                    || itemDerived.cdcorSmartFilter
                    || (root.lpdProductInCart && itemDerived.lpdProduct)
                    || itemDerived.thirdPartyFreightFlag )
                {
                    return options.fn(this);
                }
                //Default
                return options.inverse(this);
            });

            Handlebars.registerHelper('inArray', function(array, value, block) {
                if (array.indexOf(value) !== -1) {
                    return block.fn(this);
                } else {
                    return block.inverse(this);
                }
            });
            Handlebars.registerHelper("getAddress", function(value, requestedValue){
                var request = requestedValue || "companyName";
                var returnValue;
                var addressArray;

                if( typeof value !== "undefined"){
                    addressArray = value.split("\n");

                    //default is "companyName"
                    returnValue = addressArray[0];

                    if(request === "address"){
                        returnValue = addressArray[1];
                    }
                } else {
                    return false;
                }
                return returnValue;
            });
            Handlebars.registerHelper("limit", function(context, limit) {
                var options = arguments[arguments.length - 1];
                var ret = '';
                var ctx;

                if (context && context.length > 0) {
                    var max = Math.min(context.length, limit);
                    for (var i = 0; i < max; i++) {
                        ctx = Object.create(context[i]);
                        ctx.index = i;
                        ret += options.fn(ctx);
                    }
                } else {
                    ret = options.inverse(this);
                }

                return ret;
            });

            Handlebars.registerHelper("stringLength", function(str){
                return str.length;
            });

            Handlebars.registerHelper('switch', function(value, options) {
                this._switch_value_ = value;
                var html = options.fn(this); // Process the body of the switch block
                delete this._switch_value_;
                return html;
            });

            Handlebars.registerHelper('toLowerCase',function (val) {
                if ( typeof  val !== "undefined"){
                    return val.toLowerCase();
                }
                return;
            });

            Handlebars.registerHelper("switch", function(value, options) {
                this._switch_value_ = value;
                var html = options.fn(this); // Process the body of the switch block
                delete this._switch_value_;
                return html;
            });

            Handlebars.registerHelper("case", function() {
                var args = Array.prototype.slice.call(arguments);
                var options    = args.pop();
                var caseValues = args;

                if (caseValues.indexOf(this._switch_value_) === -1) {
                    return '';
                } else {
                    return options.fn(this);
                }
            });

            Handlebars.registerHelper('objLength', function (context) {
                if (!context || (typeof context !== "object")) {
                    return false;
                }
                return Object.keys(context).length;
            });

            Handlebars.registerHelper('replaceToken', function (needle, replaceWith, key) {

                var haystack = Handlebars.helpers['translate'].apply(this, [key]);
                var newString = Handlebars.helpers.replaceString.apply(this, [needle, replaceWith, haystack]);

                return newString;
            });

            Handlebars.registerHelper('replaceString', function (needle, replaceWith, haystack, options) {
                var replaceString;
                var regEx;
                replaceString = replaceWith;

                if(typeof haystack === 'undefined' || !haystack){
                    return;
                }

                //If options.hash.translate is true, translate the replaceWith argument using Mongo
                if ( options ){
                    if( options.hash.translate  ) {
                        replaceString = Handlebars.helpers['translate'].apply(this, [replaceWith]);
                    }

                    if( options.hash.escape ){
                        haystack = haystack.replace(/"/g,'\\"');
                    }

                }

                regEx = new RegExp(needle, "g");

                //if haystack is an array, convert it to a string
                if (Array.isArray(haystack)) {
                    haystack = haystack.toString();
                }

                return haystack.replace(regEx, replaceString);
            });

            Handlebars.registerHelper('empty', function (obj, options) {

                var isempty = options.hash.isempty || true;

                //Object is empty
                if (Object.size(obj) === 0) {
                    //Do we want to know if it empty (true) or populated (false)
                    if (isempty) {
                        return options.inverse(this);
                    } else {
                        return options.fn(this);
                    }
                } else {
                    //Object is populated
                    if (!isempty) {
                        return options.inverse(this);
                    } else {
                        return options.fn(this);
                    }
                }
            });

            Handlebars.registerHelper("compare", function (lvalue, rvalue, options) {
                if (arguments.length < 3)
                    throw new Error("Handlerbars Helper 'compare' needs 2 parameters");
        
                var operator = options.hash.operator || "==";
        
                var operators = {
                    '==': function (l, r) {
                        return l == r;
                    },
                    '===': function (l, r) {
                        return l === r;
                    },
                    '!=': function (l, r) {
                        return l != r;
                    },
                    '!==': function (l, r) {
                        return l !== r;
                    },
                    '<': function (l, r) {
                        return l < r;
                    },
                    '>': function (l, r) {
                        return l > r;
                    },
                    '<=': function (l, r) {
                        return l <= r;
                    },
                    '>=': function (l, r) {
                        return l >= r;
                    },
                    '&&': function (l, r) {
                        return l && r;
                    },
                    '||': function (l, r) {
                        return l || r;
                    },
                    'typeof': function (l, r) {
                        return typeof l == r;
                    },
                    'false': function (l, r) {
                        return !l && !r
                    }
                };
        
                if (!operators[operator])
                    throw new Error("Handlebars Helper 'compare' doesn't know the operator " + operator);
        
                var result = operators[operator](lvalue, rvalue);
                
                if(result && typeof options.fn == 'function'){
                    return options.fn(this);
                }
                else if(typeof options.inverse == 'function'){
                    return options.inverse(this);
                }
                else {
                    return result;
                }
        
            });


            Handlebars.registerHelper("include", function (context) {
                if (!context) return "";
                Handlebars.i18n = context.messages || {};
                return "";
            });

            Handlebars.registerHelper("contains", function (needle, haystack, options) {
                var result = haystack.indexOf(needle) !== -1;

                if (result) {
                    return options.fn(this);
                } else {
                    return options.inverse(this);
                }
            });

            Handlebars.registerHelper("CSDToolTip", function(format, options){
                /*
                  All X = range of alphanumberic
                  ALL N = exact amount of numbers
                  Mixture - send format back
                */
                var selectField = options.hash.select;
                var alphaNumeric = /X/g;
                var numeric = /N/g;
                var alpha = /A/g;
                var stringLength = format.length;

                //return false for Drop down
                if( selectField ){
                    return false;
                }

                //return false for all X
                if (format.match(alphaNumeric)) {
                    if (format.match(alphaNumeric).length === stringLength) {
                        return false;            }
                }

                //return false for all Numeric (N)
                if (format.match(numeric)) {
                    if (format.match(numeric).length === stringLength) {
                        return false;            }
                }

                //return false for all letters (A)
                if (format.match(alpha)) {
                    if (format.match(alpha).length === stringLength) {
                        return false;            }
                }

                //Return true for literal format
                return true;
            });

            Handlebars.registerHelper("csdMessage", function(format, options){
                /*
                  All X = range of alphanumberic
                  ALL N = exact amount of numbers
                  Mixture - send format back
                */
                var selectField = options.hash.select;
                var required = options.hash.required;
                var alphaNumeric = /X/g;
                var numeric = /N/g;
                var alpha = /A/g;
                var stringLength = format.length;
                var optional = required === "Y" ? '' : ' ' + Handlebars.helpers['translate'].apply(this, ["optional"]);
                var pleaseEnter = Handlebars.helpers['translate'].apply(this, ["pleaseEnterMsg"]);
                var pleaseSelect = Handlebars.helpers['translate'].apply(this, ["pleaseSelect"]);
                var lettersOrNumbers = Handlebars.helpers['translate'].apply(this, ["lettersOrNumbers"]);
                var letters = Handlebars.helpers['translate'].apply(this, ["letters"]);
                var numbers = Handlebars.helpers['translate'].apply(this, ["numbers"]);
                var characters = Handlebars.helpers['translate'].apply(this, ["characters"]);

                //Drop down we don't care about format
                if( selectField ){
                    return pleaseSelect;
                }

                //Test for all X
                if (format.match(alphaNumeric)) {
                    if (format.match(alphaNumeric).length === stringLength) {
                        return pleaseEnter + "1 -" + stringLength + optional + " " + lettersOrNumbers;
                    }
                }

                //Test for all Numeric (N)
                if (format.match(numeric)) {
                    if (format.match(numeric).length === stringLength) {
                        return pleaseEnter + " " + stringLength + optional + " " +numbers;
                    }
                }

                //Test for all letters (A)
                if (format.match(alpha)) {
                    if (format.match(alpha).length === stringLength) {
                        return pleaseEnter + " " + stringLength + optional + " " + letters;
                    }
                }

                //Return literal format
                return pleaseEnter + " " + stringLength + optional + " " + characters + ":" + Handlebars.helpers.csdExample(format);
            });

            Handlebars.registerHelper("csdExample", function(format) {
                var numeric = "1";
                var randomAlpha = "ABC1";
                var alpha = "A";
                var stringLength = format.length;
                var newFormat = "";

                _getRandomNumber = function() {
                    return Math.floor(Math.random() * randomAlpha.length);
                };

                //Let's loop and replace each character for a better example
                for (var x = 0; x < stringLength; x++) {

                    switch (format[x]) {
                        case "X":
                            newFormat += format[x].replace(/X/, randomAlpha[_getRandomNumber()]);
                            break;

                        case "N":
                            newFormat += format[x].replace(/N/, numeric);
                            break;

                        case "A":
                            newFormat += format[x].replace(/A/, alpha);
                            break;

                        default:
                            newFormat += format[x];
                            break;

                    }
                }
                return newFormat;
            });

            Handlebars.registerHelper('toJSON', function (object) {
                return new Handlebars.SafeString(JSON.stringify(object));
            });

            Handlebars.registerHelper('encodeHtmlString', function (inputData) {
                var escapedData = Handlebars.Utils.escapeExpression(inputData);
                return new Handlebars.SafeString(escapedData);
            });

            Handlebars.registerHelper('translate', function (key, orderingAttributesList, options) {
                options = options || {};
                options.hash = options.hash || {};
                orderingAttributesList = orderingAttributesList || [];

                Handlebars.i18n = I18n.translations[I18n.locale].cartUi.messages;

                var language;
                for (i = 0; i < orderingAttributesList.length; i++) {
                    if (key === orderingAttributesList[i]) {
                        return key;
                    }
                }

                if (typeof key !== "string") {
                    //throw "{{i18n}} helper: invalid key. Object keys must be formatted as strings.";
                }

                if (typeof Handlebars.i18n[key] === "undefined") {
                    return "missing translation for '" + key + "'";
                }

                return Handlebars.i18n[key];
            });

            Handlebars.registerHelper("var", function (name, value, context) {
                this[name] = value;
            });

            Handlebars.registerHelper("limitTo", function(arr, limit) {
                if (!arr) return [];
                return arr.slice(0, limit);
            });

            Handlebars.registerHelper("math", function (lvalue, operator, rvalue, options) {
                lvalue = parseFloat(lvalue);
                rvalue = parseFloat(rvalue);

                return {
                    "+": lvalue + rvalue,
                    "-": lvalue - rvalue,
                    "*": lvalue * rvalue,
                    "/": lvalue / rvalue,
                    "%": lvalue % rvalue
                }[operator];
            });

            Handlebars.registerHelper("and-or", function (lvalue, rvalue, options) {
                var result;
                var operator = options.hash.operator || "&&";
                var bool = options.hash.bool || "true"
        
                if (operator === "&&") {
                    switch (bool) {
                        case "true":
                            result = (lvalue && rvalue);
                            break;
                        case "falsetrue":
                            result = (!lvalue && rvalue);
                            break;
                        case "truefalse":
                            result = (lvalue && !rvalue);
                            break;
                        default:
                            result = (!lvalue && !rvalue);
                            break;
                    }
                }
        
                if (operator === "||") {
                    switch (bool) {
                        case "true":
                            result = (lvalue || rvalue);
                            break;
                        case "falsetrue":
                            result = (!lvalue || rvalue);
                            break;
                        case "truefalse":
                            result = (lvalue || !rvalue);
                            break;
                        default:
                            result = (!lvalue || !rvalue);
                            break;
                    }
                }
        
                if(result && typeof options.fn == 'function'){
                    return options.fn(this);
                }
                else if(typeof options.inverse == 'function'){
                    return options.inverse(this);
                }
                else {
                    return result;
                }
            });
        },
        initItemLevelPromos: function () {
            $(".js-promoBlock").each(function () {
                $(this).closest("li").attr("style", "width: 96%; border-style: solid; border-color: #999; border-width: 0 0 1px 0; padding: 20px 1.5%; margin: 0 1.5%;").addClass("ie8PromoLi");
            });
            $(".promoContentTrigger").click(function () {
                if (!($("#promoPopupContent").length)) {
                    $("body").append("<div id='promoPopupContent'>" + $(this).prev(".promo_messageContent").html() + "</div>");
                    $("#promoPopupContent").show();
                    $(".promo_closeContent").click(function () {
                        $("#promoPopupContent").remove();
                        return false;
                    });
                }
            });
        },
        renderI18n: function () {
            $("[class*='i18n-']").each(function () {
                var classNames = this.className.split(/\s+/);
                for (var i = 0; i < classNames.length; ++i) {
                    var thisClassName = classNames[i];
                    if (thisClassName.substr(0, 5) === "i18n-") {
                        $(this).text(I18n.t(thisClassName.split("-").splice(1, 2).join(".")));
                    }
                }
            });
        },
        renderItemLevelPromo: function (options) {
            var options = options || {};

            if (!options.href) {
                return;
            }

            $.colorbox({
                href: options.href
                , width: "90%"
                , onComplete: function () {
                    if (options.callback) {
                        options.callback();
                    }
                }
            })

        },
        // Sticky check out button button moves with the screen or window
        stickyCheckoutBtn: function () {
            var _SELF = this;
            //find either the mobile checkout button or default to desktop
            var checkoutButton = $('.js-summary-section').find(".js-checkout-button-wrapper");
            if($('.js-summary-section').css('display') == 'none'){
                checkoutButton = $('.js-summary-section-tablet').find(".js-checkout-button-wrapper");
            }
            var mobileCheckoutButton = $('#mobileCheckoutButton');
            var sticky;
            var stickyMobile;
            var wayPointOffset = _SELF.isNewHeader() ? 120 : 0;

            Waypoint.destroyAll();

            if (fishersci.Common.getBreakpoint() !== "mobile") {
                if (checkoutButton.length) {
                    sticky = new Waypoint.Sticky({
                        element: checkoutButton[0],
                        wrapper: '<div class="checkout-button-wrapper waypoint" />',
                        offset: wayPointOffset
                    })
                }
            }


            if (mobileCheckoutButton.length) {
                stickyMobile = new Waypoint.Sticky({
                    element: mobileCheckoutButton[0],
                    wrapper: '<div class="checkout-button-wrapper-mobile checkout-button-wrapper-tabvar waypoint hide-in-print" />',
                    handler: function () {
                        //When sticky moves back to normal (up) hide est. total
                        if (arguments[0] == "up") {
                            $('.js-mobile-est-total').addClass('hide').removeClass('float_left');
                            $('.js-checkout-button-container').removeClass('float_right');
                        } else {
                            $('.js-mobile-est-total').removeClass('hide').addClass('float_left');
                            $('.js-checkout-button-container').addClass('float_right');
                        }
                    }
                })
            }
        },
        doCheckoutButton: function () {
            var _SELF = this;
            //Punchout users have a different checkout flow
            if (isPunchout) {
                _SELF.sendB2BPurchaseAnalytics();
                setTimeout(function(){
                    document.getElementById("punchoutreview_desktop").submit();
                }, 1200);
                return;
            } else {
                if(LocalePath.getCountry().toUpperCase() !== "US" && LocalePath.getCountry().toUpperCase() !== "CA"){
                    _SELF.doEUCommerceForm();
                } else {
                    _SELF.doCommerceForm();
                }

                //Renable button
                $('.js-checkout-button').removeClass('disabled');
                fishersci.components.CartCheckoutUI.startCheckout();
            }
        },
        buildB2BProductString:  function(){
            var productsArray = [];
            try {
                $('.js-hidden-inputs').not('.filter-from-checkout').each(function () {
                    var $this = $(this);
                    var part = $this.find('[name="condensedPartNum"]').val();
                    var uom = $this.find('[name="selectedUom"]').val();
                    var qty = $this.find('.qty-field').val();
                    var unitPrice = $this.find('[data-adobeitemsubtotal]').data('adobeitemsubtotal') || "";

                    //To handle global prices, remove all non-numeric characters and divide the value by 100
                    productsArray.push(";" + part + ";" + qty + ";" + unitPrice.replace(/[^0-9]/g, '') / 100 + ";;eVar28=Punch Out Item|eVar6=" + uom);
                });
            } catch (e){
                console.error(e);
            }

            return productsArray;
        },
        sendB2BPurchaseAnalytics:   function(){
            var _SELF = this;
            var purchaseId;

            if( typeof env.cartId !== "undefined" && env.cartId.length > 0 ){
                fisherDataLayer.cartId = env.cartId;
                purchaseId = env.cartId.replace(/-/g,"").substring(0,19);
            }

            fisherDataLayer.linkTrackVars = "events,products,purchaseID,eVar30,eVar28,eVar6,eVar35,eVar44,prop15,prop16,prop54,channel";
            fisherDataLayer.linkTrackEvents = 'scCheckout,purchase,event30';
            fisherDataLayer.events = "scCheckout,purchase,event30";
            fisherDataLayer.products = _SELF.buildB2BProductString().join(",");
            fisherDataLayer.purchaseID = purchaseId;
            fisherDataLayer.orderId = purchaseId;
            fisherDataLayer.userData.xrefSessionID = purchaseId;
            fisherDataLayer.channel = LocalePath.getCountry().toUpperCase();

            if(typeof _satellite !== "undefined") {
                _satellite.track('punchoutConfirmation');
            }
            document.dispatchEvent(new CustomEvent("cartReturnToPurchase"));
        },
        cancelCxmlOrder: function () {
            document.forms.punchoutcancel.submit();
            return;
        },
        doGeneralProductModal: function (options) {
            if (!options) {
                return;
            }

            //display contents in modal
            $.colorbox({
                transition: "elastic",
                html: options.html,
                width: "75%",
                onComplete: function () {
                    $.colorbox.resize();
                }
            });
        },
        doViewAltProductModal: function (options) {
            if (!options) {
                return;
            }
            //default modal sizing
            var modalWidth = '1000px';
            var modalHeight = '640px';
            //Need to resize the popped up modal properly based on breakpoint.
            if(screenWidth == 992){
                modalWidth = '890px';
                modalHeight = '950px';
            } else if (screenWidth == 768){
                modalWidth = '720px';
                modalHeight = '830px';
            } else if(screenWidth == 320){
                modalWidth = '320px';
                modalHeight = '1300px';
            }

            $.colorbox({
                transition: "elastic",
                html: options.html,
                width: modalWidth,
                onComplete: function () {
                    $.colorbox.resize({'height': modalHeight});
                    $('#cboxLoadedContent').css('overflow','hidden');
                }
            });
        },
        doCommerceForm: function () {
            var commerceForm = $('#sendToCommerce');

            //Wipe existing form
            commerceForm.html('');

            $('.js-hidden-inputs').not('.filter-from-checkout').each(function () {
                var $this = $(this);
                var part = $this.find('[name="condensedPartNum"]').val();
                var uom = $this.find('[name="selectedUom"]').val();
                var qty = $this.find('.qty-field').val();
                var speedNumber = $this.find('[name="userEnteredProdId"]').val() || "";
                var assayId = $this.find('[name="assayId"]').val() || "";
                var itemComments = $this.find('[name="itemComments"]').val() || "";
                var lineItemType = $this.find('[name="lineItemType"]').val() || "";
                var lineItemDesc = $this.find('[name="lineItemDesc"]').val() || "";
                var quoteNumber = $this.find('[name="quoteNumber"]').val() || "";
                var quoteType = $this.find('[name="quoteType"]').val() || "";
                var quoteLineNumber = $this.find('[name="lineNumber"]').val() || "";
                var unitPrice = $this.find('[name="unitPrice"]').val() || "";

                //inventory management fields
                var stockRoomCode = $this.find('[name="stockRoomCode"]').val() || "";
                var stockRoomLocation = $this.find('[name="stockRoomLocation"]').val() || "";
                var stockRoomStreet1 = $this.find('[name="stockRoomStreet1"]').val() || "";
                var stockRoomStreet2 = $this.find('[name="stockRoomStreet2"]').val() || "";
                var stockRoomStreet3 = $this.find('[name="stockRoomStreet3"]').val() || "";
                var stockRoomStreet4 = $this.find('[name="stockRoomStreet4"]').val() || "";
                var stockRoomStreet5 = $this.find('[name="stockRoomStreet5"]').val() || "";
                var stockRoomCity = $this.find('[name="stockRoomCity"]').val() || "";
                var stockRoomState = $this.find('[name="stockRoomState"]').val() || "";
                var stockRoomZipCode = $this.find('[name="stockRoomZipCode"]').val() || "";
                var stockRoomCountry = $this.find('[name="stockRoomCountry"]').val() || "";
                var productType = $this.find('[name="productType"]').val() || "";
                var adminBuy = $this.find('[name="adminBuy"]').val() || "";
                var childPart = $this.find('[name="childPart"]').val() || "";
                var vendorNumber = $this.find('[name="vendorNumber"]').val() || "";
                var vendorPartNumber = $this.find('[name="vendorPartNumber"]').val() || "";

                commerceForm.append('<input type="hidden" name="shoppingCartCatNum" value="' + part + '"/>');
                commerceForm.append('<input type="hidden" name="shoppingCartUnits" value="' + uom + '"/>');
                commerceForm.append('<input type="hidden" name="shoppingCartQty" value="' + qty + '"/>');
                commerceForm.append('<input type="hidden" name="userEnteredProdId" value="' + speedNumber + '"/>');
                commerceForm.append('<input type="hidden" name="assayId" value="' + assayId + '"/>');
                commerceForm.append('<input type="hidden" name="itemComments" value="' + itemComments + '"/>');
                commerceForm.append('<input type="hidden" name="lineItemType" value="' + lineItemType + '"/>');
                commerceForm.append('<input type="hidden" name="lineItemDesc" value="' + lineItemDesc + '"/>');
                commerceForm.append('<input type="hidden" name="quoteNumber" value="' + quoteNumber + '"/>');
                commerceForm.append('<input type="hidden" name="quoteType" value="' + quoteType + '"/>');
                commerceForm.append('<input type="hidden" name="lineNumber" value="' + quoteLineNumber + '"/>');
                commerceForm.append('<input type="hidden" name="unitPrice" value="' + unitPrice.replace("$", "") + '"/>');

                commerceForm.append('<input type="hidden" name="stockRoomCode" value="' + stockRoomCode + '"/>');
                commerceForm.append('<input type="hidden" name="stockRoomLocation" value="' + stockRoomLocation + '"/>');
                commerceForm.append('<input type="hidden" name="stockRoomStreet1" value="' + stockRoomStreet1 + '"/>');
                commerceForm.append('<input type="hidden" name="stockRoomStreet2" value="' + stockRoomStreet2 + '"/>');
                commerceForm.append('<input type="hidden" name="stockRoomStreet3" value="' + stockRoomStreet3 + '"/>');
                commerceForm.append('<input type="hidden" name="stockRoomStreet4" value="' + stockRoomStreet4 + '"/>');
                commerceForm.append('<input type="hidden" name="stockRoomStreet5" value="' + stockRoomStreet5 + '"/>');
                commerceForm.append('<input type="hidden" name="stockRoomCity" value="' + stockRoomCity + '"/>');
                commerceForm.append('<input type="hidden" name="stockRoomState" value="' + stockRoomState + '"/>');
                commerceForm.append('<input type="hidden" name="stockRoomZipCode" value="' + stockRoomZipCode + '"/>');
                commerceForm.append('<input type="hidden" name="stockRoomCountry" value="' + stockRoomCountry + '"/>');
                commerceForm.append('<input type="hidden" name="productType" value="' + productType + '"/>');
                commerceForm.append('<input type="hidden" name="adminBuy" value="' + adminBuy + '"/>');
                commerceForm.append('<input type="hidden" name="childPart" value="' + childPart + '"/>');
                commerceForm.append('<input type="hidden" name="vendorNumber" value="' + vendorNumber + '"/>');
                commerceForm.append('<input type="hidden" name="vendorPartNumber" value="' + vendorPartNumber + '"/>');

            })
        },
        doEUCommerceForm: function () {

            var commerceForm = $('#sendToCommerce');
            var itemObj = {};
            var promoCode = !fisherDataLayer.promoCodeRemoved ? (fisherDataLayer.promoCode || "") : "";
            var $standardItems = $('.js-hidden-inputs').not('.js-config-item');
            var $configItems = $('.js-config-item');
            var standardItems;
            var configItems;
            var $ibsCartRefId = $('#ibsCartRefId').val() || 0;

            //Wipe existing form
            commerceForm.html('');

            //IBS Cart reference
            itemObj.ibsCartRefId = $ibsCartRefId;

            //Add Promo Code
            itemObj.promoCode = promoCode;

            //get regular items
            standardItems = _buildItemObjects({
                element: $standardItems
            });

            //get configItems
            configItems = _buildItemObjects({
                element: $configItems
            });

            //Add regular items to object
            itemObj.items = standardItems;

            //Add config items if they exist
            if (configItems.length > 0) {
                itemObj.configItems = configItems;
            }

            //Add a textarea containing JSON representation of all necessary data
            commerceForm.append('<textarea class="hide" name="checkoutJson">' + JSON.stringify(itemObj) + '</textarea>');

            function _buildItemObjects(options) {
                var items = [];
                var item = {};
                $.each(options.element, function() {
                    var $this = $(this);
                    var part = $this.find('[name="condensedPartNum"]').val();
                    var $quoteVersion = $this.find('[name="quoteVersion"]').val() || "00";
                    var $quoteNumber = $this.find('[name="quoteNumber"]').val();
                    var $quoteLineNumber = _padLineNumber({
                        "val" : $this.find('[name="lineNumber"]').val(),
                        "maxlength" : 5
                    });
                    var $unitPrice = $this.find('[name="unitPrice"]').val().replace(/[^0-9]+/g, ''); //get rid of any currency regardless of location
                    var qty = $this.find('.qty-field').val();
                    var consolidatedFieldObject = {};
                    var $consolidatedFields = $this.closest('.js-shippedItem').find('.reference-fields-container');
                    var $finalUnitPrice = $unitPrice.slice(0 , ($unitPrice.length -2)) + "." + $unitPrice.slice(($unitPrice.length -2), $unitPrice.length);
                    if ($consolidatedFields.length) {
                        $.each($consolidatedFields, function() {
                            var $this = $(this);
                            var $data = $this.find('.reference-data');

                            $.each($data, function() {
                                var $this = $(this);
                                consolidatedFieldObject[$this.attr('name')] = $this.val();
                            })

                        });
                    }

                    item = {
                        "itemCode": part,
                        "quantity": qty,
                        "consolidatedFields": consolidatedFieldObject
                    };

                    //If there's a quote, add it to the item object
                    if ($quoteNumber !== ""){
                        item.quotedItem = $quoteNumber + "." + $quoteVersion + "." + $quoteLineNumber + "_" + $finalUnitPrice;
                    }

                    //push each item into array
                    items.push(item);
                });

                return items;

            }

            function _padLineNumber( options ){
                return Array(options.maxlength - String(options.val).length + 1).join( options.fillString || '0') + options.val;
            }
        },
        doValidateModalForm:    function( options ){

            if( !options ) {
                return;
            }

            var errors = 0;

            //Loop through required fields and test
            $(options.selector).each(function(){
                var $this = $(this);
                var $fieldType = $this.data('type');
                var emailRegEx = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
                var allNonWhiteSpace = new RegExp(/[\S]+/g);

                var _testEmail = function( element ){
                    return emailRegEx.test( $(element).val() );
                };

                var _testText = function ( element ){
                    return allNonWhiteSpace.test( $(element).val() );
                };

                var _handleError = function ( element ){
                    errors++;
                    $(element).addClass('error');
                    $(element).next('label').removeClass('hide');
                    $.colorbox.resize();
                };

                var _clearError = function ( element ){
                    $(element).removeClass('error');
                    $(element).next('label').addClass('hide');
                };

                switch( $fieldType ){
                    case "email":
                        !_testEmail( $this ) ? _handleError( $this ) : _clearError( $this );
                        break;

                    case "text":
                        !_testText( $this ) ? _handleError( $this ) : _clearError( $this );
                        break;

                    default:
                        break;
                }
            });

            return errors === 0;
        },

        doCommerceFormSubmit: function () {
            var checkoutForm = $('#sendToCommerce');
            var userType = env.checkoutUserType.toLowerCase();

            //If we're in the new checkout flow, POST data there instead
            console.log('Use new checkout: ' + _useNewCheckout() + ' with cartid: ' + env.cartId);
            if(_useNewCheckout()){
                checkoutForm = $('#checkoutFlow');
                _updateFormAction();
            } else {
                _updateCommerceFormAction();
            }

            //pass in gSessionId
            if(checkoutForm[0].gSessionId){
                checkoutForm[0].gSessionId.value = $.cookie('gsessionId');
            }

            //Private methods
            function _useNewCheckout(){
                if(!isPunchout){
                    return true
                }

                //Registered users not 100% yet ( fund tracking, etc still on old checkout )
                if ( userType === "r" && env.newCheckout ){
                    return true;
                }

                //guest and mini
                return userType === "g" || userType === "m";
            }

            function _updateFormAction(){
                if(LocalePath.getCountry().toUpperCase() !== "US" && LocalePath.getCountry().toUpperCase() !== "CA"){
                    checkoutForm[0].action = "/store1/checkout-eu/initiateCheckout/?language=" +  LocalePath.getLanguage() + "&countryCode=" + LocalePath.getCountry().toUpperCase();
                }
            }

            function _updateCommerceFormAction(){
                if(LocalePath.getCountry().toUpperCase() !== "US" && LocalePath.getCountry().toUpperCase() !== "CA"){
                    checkoutForm[0].action = "/shop/service/checkout";
                }
            }

            //submit checkout form
            checkoutForm.submit();
        },
        doValidateZipState: function () {
            var $this = $(this),
                zipType = $this.attr(_DATA_ZIP_TYPE),
                zip = $('#' + zipType + 'Zip').val(),
                state = $('#' + zipType + 'State').val();

            var validate = fishersci.Common.validateZipCode({zipCode: zip, state: state}),

                //results will be undefined if either the state or zip is missing
                results = validate.getZip();

            if (typeof results !== 'undefined') {

                if (results.isValidZipCode) {
                    $_VALID_ZIP_ELEMENT.val('true')
                } else {
                    $_VALID_ZIP_ELEMENT.val('').attr($_DATA_ERROR_MESSAGE, results.errorMsg);
                }
            }
        },
        doCheckExpirationDates: function () {
            console.log('doCheckExpirationDates called from ' + _SCRIPT_NAME);

            var dateErrors = 0,
                $msgEl = $(),
                $fieldDate = $('[data-form-select-field-date]');

            //Handle expiration date errors
            $fieldDate.each(function () {
                var $this = $(this),
                    msgEl = $this.attr('data-form-error-element');
                $msgEl = $('#' + msgEl);

                if ($this.val() === '0') {
                    dateErrors++;
                }
            });

            if ($fieldDate.length > 0) {
                if (dateErrors > 0) {
                    $msgEl.removeClass('hide').parent().addClass('error');
                } else {
                    $msgEl.addClass('hide').parent().removeClass('error');
                }
            }

            return dateErrors;
        },
        doCheckCreditCardSelected: function () {
            console.log('doCheckAllCreditCardTypes called from ' + _SCRIPT_NAME);

            var cardSelectErrors = 0,
                $msgEl = $(),
                $fieldCredit = $('[data-form-select-field-credit]');

            //Handle All credit cart type errors
            $fieldCredit.each(function () {
                var $this = $(this),
                    msgEl = $this.attr('data-form-error-element');
                $msgEl = $('#' + msgEl);

                if ($this.val() === '0') {
                    cardSelectErrors++;
                }
            });

            if ($fieldCredit.length > 0) {
                if (cardSelectErrors > 0) {
                    $msgEl.removeClass('hide').parent().addClass('error');
                } else {
                    $msgEl.addClass('hide').parent().removeClass('error');
                }
            }

            return cardSelectErrors;

        },
        getAlternates: function (options) {
            if (!options) {
                return;
            }
            var url = "/store1/cart/substitute/?language=" +  LocalePath.getLanguage() + "&countryCode=" + LocalePath.getCountry().toUpperCase();

            $.ajax({
                url: url,
                data: options.data,
                type: 'POST',
                dataType: 'json',
                error: function (xhr, status, error) {
                    console.log(error);
                },
                success: function (data) {
                    options.callback(data);
                }
            });
        },
        getAccessories: function (options) {
            if (!options) {
                return;
            }
            var url = options.element.data("accessoryurl");

            $.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                error: function (xhr, status, error) {
                    console.log(error);
                },
                success: function (data) {
                    options.callback(data);
                }
            });
        },
        startCheckout: function () {
            fishersci.components.CartCheckoutUI.redirectToNextPage();
        },
        redirectToNextPage: function () {
            var _SELF = this;

            if ($('#memberId').val() == "") {
                if (window.location.protocol == "http:") {
                    var checkoutURL = fishersci.Common.getFullURL().replace(/http:/ig, "https:");
                    var newURL = fishersci.util.QueryString.update(checkoutURL, "modal", "guestCheckout");
                    window.location.href = newURL;
                } else {
                    fishersci.components.CartCheckoutUI.openGuestCheckoutModal();
                }
            } else {
                //Populate and POST form to old checkout process
                _SELF.doCommerceFormSubmit();
            }
        },
        openGuestCheckoutModal: function () {
            var _SELF = this;
            if(screenWidth == 768 || screenWidth == 992){
                var  innerWidth = "700px";
            }
            else if(screenWidth == 320){
                var  innerWidth = "320px";
            }
            else{
                var  innerWidth = "880px";
            }

            $.colorbox({width: innerWidth,href:"/store1/cart/updatecart/proceedtocheckout/?language=" + LocalePath.getLanguage().toUpperCase() + "&countryCode=" + LocalePath.getCountry().toUpperCase()}, function(){
                $( "#guestCheckoutUsername, #guestCheckoutPassword" ).on( "keydown", function(e) {
                    if(e.which == 13) {
                        var newURL = fishersci.util.QueryString.remove(fishersci.Common.getFullURL(),"modal");
                        $("#redirectHereOnLogin").val(newURL);
                        fishersci.Login.detectLogin();
                    }
                });
                $("#guestCheckoutUsername").focus();
            });

            $("#cboxWrapper").on("click", "#loginOverlayContent .btn-sign-in", function (event) {
                var newURL = fishersci.util.QueryString.remove(fishersci.Common.getFullURL(), "modal");
                $("#redirectHereOnLogin").val(newURL);
                fishersci.Login.detectLogin();
                event.cancelBubble = true;
                event.preventDefault();

                if (event.stopPropagation) {
                    event.stopPropagation();
                }
            });

            $("#cboxWrapper").on("click", "#loginOverlayContent .continue_btn", function (e) {

                e.preventDefault();

                var checkoutURL = $('.js-checkout-button').attr("data-href");
                $("#cboxWrapper .continue_btn").attr("href", checkoutURL);


                //Submit hidden form
                _SELF.doCommerceFormSubmit();
            });
        },
        openPrintViewPage: function (serviceURL, title) {

            //testing stuff
            serviceURL = "/store1/cart/service?language=" + LocalePath.getLanguage().toUpperCase() + "&countryCode=" + LocalePath.getCountry().toUpperCase();

            if (fishersci.Common.getQueryString('stub')) {
                serviceURL += '&stub=' + fishersci.Common.getQueryString('stub');
            }
            Handlebars.registerPartial("cart-item-print-view", ShoppingCart.templates['cart-item-print-view']);
            Handlebars.registerPartial("cart-item-details-print", ShoppingCart.templates['cart-item-details-print']);
            Handlebars.registerPartial("cart-print-standard-items", ShoppingCart.templates['cart-print-standard-items']);
            Handlebars.registerPartial("cart-print-config-items", ShoppingCart.templates['cart-print-config-items']);
            Handlebars.registerPartial("cart-table-print-summary", ShoppingCart.templates['cart-table-print-summary']);
            Handlebars.registerPartial("cart-shipping-tax", ShoppingCart.templates['cart-shipping-tax']);

            $.ajax({
                url: serviceURL,
                dataType: 'json',
                beforeSend: function () {
                    console.log('Getting cart for Print View');
                },
                error: function (data) {
                },
                success: function (data) {
                    var imgSrc = $('#main-nav-header .logo').attr('src');
                    var printView;

                    data.imgURL = imgSrc;
                    printView = (ShoppingCart.templates['cart-print-view'](data));

                    //This method hides the entire body, then prints only the shopping_cart_print_view selector
                    fishersci.Common.printHtmlElement(printView, '.shopping_cart_print_view');
                }
            });
        },
        addToCart: function (options) {
            if (!options) {
                return;
            }

            //Force shipping and tax call each time if anything is added directly in the cart
            env.callShippingAndTax = true;

            var defaults = {
                updateUi: false
            };

            var _SELF = this;
            var url = "/store1/addToCartService/service/?language=" +  LocalePath.getLanguage() + "&countryCode=" + LocalePath.getCountry().toUpperCase();
            var options = $.extend(defaults, options);

            //render as HTML?
            if (options.html) {
                //url += '&html=true';
            }

            $.ajax({
                url: url,
                data: options.data,
                type: 'POST',
                dataType: 'json',
                beforeSend: function () {
                    if (options.beforeSendCallback) {
                        options.beforeSendCallback();
                    }
                },
                error: function (xhr, status, error) {
                    if (options.errorCallback) {
                        options.errorCallback(xhr, status, error);
                    }
                },
                success: function (data) {
                    //if there's a callback, run it
                    if (options.callback) {
                        options.callback(data);
                    }

                    if ( options.updateUi ){
                        _SELF.updateCartUi({"data":data});
                    }
                }
            });

        },
        validateFields:  function( options ){
            var $element = options.element;
            var errorCount = 0;

            $($element).each(function(){
                var $this = $(this);
                var $reg = $this.data('regex');
                var $val = $this.val();
                var isDropdown = $this.is('select');
               
                if((!isDropdown && !$val.match($reg)) || (isDropdown && $val == "")){
                    if ( !options.suppressCssError ){
                        $this.addClass('error');
                        $this.next().addClass('error-text');
                    }

                    if ( options.toggle ){
                        $this.next().removeClass('visibility-hidden');
                    }

                    errorCount++;
                } else {
                    $this.removeClass('error');
                    $this.next().removeClass('error-text');

                    if ( options.toggle ){
                        $this.next().addClass('visibility-hidden');
                    }
                }
            });

            return errorCount;
        },
        validateEmptyFields:  function( options ){
            var $element = options.element;
            var errorCount = 0;

            $($element).each(function(){
                var $this = $(this);
                var $val = $this.val();
                if( $.trim($val) === "" ){
                    if ( !options.suppressCssError ){
                        $this.addClass('error');
                        $this.next().addClass('error-text');
                    }

                    if ( options.toggle ){
                        $this.next().removeClass('visibility-hidden');
                    }

                    errorCount++;
                } else {
                    $this.removeClass('error');
                    $this.next().removeClass('error-text');

                    if ( options.toggle ){
                        $this.next().addClass('visibility-hidden');
                    }
                }
            });

            return errorCount;
        },
        updateLineLevel: function ( options ){

            var extraParams = options.extraParams || false;

            if (!options){
                return;
            }

            if( options.extraParams ){
                extraParams = $.param(options.extraParams);
            }

            //Call update endpoint
            $.ajax({
                data: options.data,
                type: "POST",
                dataType: "json",
                url: "/store1/cart/updatecart/linelevel/" + options.endpoint + "?language=" + LocalePath.getLanguage() + "&countryCode=" + LocalePath.getCountry().toUpperCase()  + "&" + extraParams,
                beforeSend: function () {
                    if (options.beforeSendCallback) {
                        options.beforeSendCallback();
                    }
                },
                success: function (data) {
                    if (options.callback) {
                        options.callback(data);
                    }
                },
                error: function (xhr, status, error) {
                    if (options.errorCallback) {
                        options.errorCallback(xhr, status, error);
                    }
                }
            })

        },
        doInlineNotification:   function( options ){
            var defaults = {
                element: $('.notification'),
                top : 0,
                right: 0,
                data : {}
            };
            var options = options || {};
            var $options = $.extend(defaults, options);

            //Adjust top to match element
            $options.element.css({'top' : $options.top, 'right' : $options.right});

            //Show the element
            $options.element.removeClass('hide');

            //Update data elements
            $options.element.data($options.data);

        },
        updateCart: function (options) {
            if (!options) {
                return;
            }

            //call updatecart cart service
            $.ajax({
                url: "/store1/cart/updatecart/?language=" +  LocalePath.getLanguage() + "&countryCode=" + LocalePath.getCountry().toUpperCase() + "&orderItemId=" + options.data.orderItemId,
                data: options.data,
                type: 'POST',
                dataType: 'json',
                beforeSend: function () {
                    if (options.beforeSendCallback) {
                        options.beforeSendCallback();
                        $(".js-checkout-button").addClass("disabled");
                    }
                },
                error: function (xhr, status, error) {
                    if (options.errorCallback) {
                        options.errorCallback(xhr, status, error);
                        $(".js-checkout-button").removeClass("disabled");
                    }
                },
                success: function (data) {
                    options.callback(data);
                    $(".js-checkout-button").removeClass("disabled");
                }
            });
        },
        updateCartlet: function (data) {
            var qtyToShow = "";

            //For new cartvar testing
            if ($.cookie('CART_ID') && $.cookie('CART_ID') !== "") {
                var cartIdArray = $.cookie('CART_ID').split("_");
                if (cartIdArray[1] !== "") {
                    qtyToShow = cartIdArray[1];

                    if (qtyToShow > 999) {
                        qtyToShow = "999+";
                    }

                    $('.shopping_cart_quantity').text(qtyToShow).removeClass('hide');
                } else {
                    $('.shopping_cart_quantity').text(qtyToShow).addClass('hide');
                }

            } else {
                $('.shopping_cart_quantity').text(qtyToShow).addClass('hide');
            }

            // Update flag on cartvar to force refresh on next hover
            $('#cartletDrop').attr('data-refresh', 1);
        },
        updateCartUi: function (options) {
            var _SELF = this;
            var _data = options.data;
            var defaults = {
                html: false
            };

            var options = options || {};
            var cart, mobileCheckoutModal;
            
            //default switch account link to false
            _data.showSwitchAccounts = false;

            //Merge defaults and optional params
            options = $.extend(defaults, options);

            //pass in country code and language
            options.data.language = LocalePath.getLanguage().toLowerCase();
            options.data.countryCode = LocalePath.getCountry().toUpperCase();

            //static path for glyphs
            _data.staticRoot = window.env.staticRoot;

            //New web quote modal
            _data.showWebQuoteModal = env.showWebQuoteModal || false;

            //Web quote button - flag comes from config, we set env to handle client side needs during cart updates
            _data.showWebQuoteButton = env.showWebQuoteButton || false;

            //Web quote button - flag comes from config, we set env to handle client side needs during cart updates
            _data.showWebQuoteButtonPersistentUsers = env.showWebQuoteButtonPersistentUsers || false;

            //Is Save for Later enabled?
            _data.enableSaveForLater = env.enableSaveForLater || false;

            //Spending progress bar versus legacy
            _data.enableSpendingProgressBar = env.enableSpendingProgressBar || false;

            if (options.data.status == "500") {
                console.log("There was an issue updating the UI");
                return;
            }

            //You can compile the cart on the client (remove html param) or Node side (html=true)
            if( options.html ){
                cart = options.data;
            } else {
                try {
                    if( !_data.userDetails.newCheckout ){
                        _data.userDetails.selectedAccount.hasCSD = false;
                    }
                } catch (e) {
                    console.log(e);
                }   
                
                _data.userDetails.enableZipCodeForm = _data.userDetails.persistentUser
                ? false 
                : _data.userDetails.enableZipCodeForm;

                if( _data.userDetails.accounts ){
                    _data.showSwitchAccounts = _data.userDetails.accounts.length > 1 && (!_data.cartDerived.punchoutCart || _data.cartDerived.punchoutInventoryUser);
                    // enabling the switch button for EU Punchout user after updating the cart
                    if( _data.cartDerived.punchoutCart && LocalePath.getCountry().toUpperCase() !== "US" && LocalePath.getCountry().toUpperCase() !== "CA" && _data.userDetails.accounts.length > 1) {
                        _data.showSwitchAccounts = true;
                    }
                }

                //Override data.showSwitchAccounts if this is a persistent user ( temp fix )
                if( _data.userDetails.persistentUser ){
                    _data.showSwitchAccounts = true;
                }
                cart = Handlebars.partials['cart-layout'](_data);
                mobileCheckoutModal = Handlebars.partials['cart-mobile-checkout-modal'](_data);
            }

            if ($(window).width() < 640) { //re-init mobile checkout modal
                $('#mobileCheckoutModalContainer').html(mobileCheckoutModal);
                fishersci.components.CartMobileCheckoutModal.init()
            }
            $('#cartContainer').html(cart);

            try {
                var modal = document.querySelector('#checkout-recommendations-modal');
                if (modal && _data.cartDerived && _data.cartDerived.showProceedToCheckoutButton) {
                    const checkoutButton = modal.querySelector('.checkout-button-recommendations .checkout-button');
                    if (checkoutButton) {
                        checkoutButton.classList.remove('disabled');
                    }
                }
            } catch(error) {
                console.error('Error re-enabling checkout in checkout recommendations: ', error);
            }


            //Misc cleanup after update
            _SELF.doAfterUiUpdate(options.data);
        },
        updateSaveForLaterUi: function(options) {
            var options = options || {};
            var _data = options.data;
            var defaults = {
                html: false
            };
            var sfl;
            var savedForLaterTab = document.querySelector('#savedForLaterTab');
            var savedForLaterRadio = document.querySelector('#savedForLaterTabRadio');
            var favoritesTab = document.querySelector('#favoritesTab');
            var favoritesTabRadio = document.querySelector('#favoritesTabRadio');
            var myTopPurchasesTab = document.querySelector('#myTopPurchasesTab');
            var myTopPurchasesTabRadio = document.querySelector('#myTopPurchasesTabRadio');

            //Merge defaults and optional params
            options = $.extend(defaults, options);

            //pass in country code and language
            options.data.language = LocalePath.getLanguage().toLowerCase();
            options.data.countryCode = LocalePath.getCountry().toUpperCase();

            //Add all to list?
            options.data.hasAddAllToList = typeof env.hasAddAllToList !== "undefined";

            //Flag for new My List function
            _data.useNewMyList = true;

            //static path for glyphs
            _data.staticRoot = window.env.staticRoot;
            //object with just the items
            _data.saveForLaterItems = options.data.saveForLaterItems || {};
            //save for later item count
            _data.saveForLaterItemCount = options.data.saveForLaterItemCount;

            if (options.data.status == "500") {
                console.log("There was an issue updating the UI");
                return;
            }

            //You can compile the cart on the client (remove html param) or Node side (html=true)
            if( options.html ){
                sfl = options.data;
            } else {
                sfl = Handlebars.partials['cart-saved-items-layout'](_data);
            }

            $('#sflContainer').html(sfl);

            if (Object.keys(_data.saveForLaterItems).length > 0) {
                document.querySelector('#sflContent').classList.remove('hide');
                savedForLaterTab.classList.remove('hide');
                savedForLaterRadio.setAttribute('checked','checked');
                savedForLaterRadio.click();
                $('.save-for-later-footer').removeClass('hide') //show proper footer
                $('.top-purchases-footer').addClass('hide')
                $('.favorites-footer').addClass('hide')
                document.querySelector('.tab-container').classList.remove('hide');
                $("#FS-CAS-B2B-US").addClass('absolute-position-survey-box');
            } else {
                localStorage.removeItem('saveForLaterCartId');
                document.querySelector('#sflContent').classList.add('hide');
                savedForLaterTab.classList.add('hide');
                savedForLaterRadio.removeAttribute('checked');
                $('.save-for-later-footer').addClass('hide') //hide footer for S4L


                //Hide all tabs if they're all hidden
                if ( favoritesTab.classList.value.indexOf('hide') !== -1 && myTopPurchasesTab.classList.value.indexOf('hide') !== -1 ){
                    document.querySelector('.tab-container').classList.add('hide');
                } else if( myTopPurchasesTab.classList.value.indexOf('hide') === -1 ) { //show mytoppurchases tab if it's not hidden
                    myTopPurchasesTabRadio.click();
                    $('.top-purchases-footer').removeClass('hide') //show proper footer
                    $('.save-for-later-footer').addClass('hide')
                    $('.favorites-footer').addClass('hide')
                } else{ // show favorites tab if it's not hidden
                    favoritesTabRadio.click();
                    $('.favorites-footer').removeClass('hide') //show proper footer
                    $('.top-purchases-footer').addClass('hide')
                    $('.save-for-later-footer').addClass('hide')
                }

            }
        },
        //TODO - consider removing the cartUI update because we call Shipping and Tax right after
        updateZipCode: function (options) {
            if (!options) {
                return;
            }
            var _SELF = this;
            var promoCodeParam = "";

            //pass in promo code if not null
            if( options.promoCode ){
                promoCodeParam = "&promoCode=" + options.promoCode;
            }

            $.ajax({
                url: "/store1/cart/updatezipcode/?language=" +  LocalePath.getLanguage() + "&countryCode=" + LocalePath.getCountry().toUpperCase() + "&zipCode=" + options.zipcode + promoCodeParam,
                type: 'GET',
                dataType: 'json',
                beforeSend: function () {
                    if (options.beforeSendCallback) {
                        options.beforeSendCallback();
                    }
                },
                error: function (xhr, status, error) {
                    if (options.errorCallback()) {
                        options.errorCallback();
                    }
                },
                success: function (data) {
                    _SELF.updateCartUi({"data":data});
                    if (options.callback) {
                        options.callback( data );
                    }
                }
            });
        },
        applyPromo: function (options) {
            if (!options) {
                return;
            }
            var _SELF = this;
            $.ajax({
                type: "GET",
                dataType: "json",
                url: "/store1/cart/promos/?language=" +  LocalePath.getLanguage() + "&countryCode=" + LocalePath.getCountry().toUpperCase() + "&promoCode=" + options.promoCode + "&action=" + options.action,
                beforeSend: function () {
                    if (options.beforeSendCallback) {
                        options.beforeSendCallback();
                    }
                },
                error: function (e) {
                    console.log(e);
                    // Close core-modal if it exists
                    var modal = document.querySelector('#promotionModal');
                    if (modal && modal.isopen) {
                        modal.isopen = false;
                    }
                    if (options.errorCallback) {
                        options.errorCallback();
                    }
                },
                success: function (data) {
                    // Close core-modal if it exists
                    var modal = document.querySelector('#promotionModal');
                    if (modal && modal.isopen) {
                        modal.isopen = false;
                    }
                    if (options.callback) {
                        options.callback();
                    }
                    _SELF.updateCartUi({"data":data});

                    //show quote promo message if need be
                    if ( options.action == "add"){
                        if ( env.quoteInCart && LocalePath.getCountry().toLowerCase() !== "us"){
                            if(!sessionStorage.getItem("quotePromoMessageOnLoad")) {
                                setTimeout(function() {
                                    fishersci.components.CartCheckoutUI.doQuotePromoMessage();

                                    //Show only once
                                    sessionStorage.setItem("quotePromoMessageOnLoad", "true");
                                }, 1500);
                            }
                        }
                    } else {
                        //Remove any static notices
                        $('.notification-widget').remove();
                    }

                }
            })

        },

        deleteItem: function (options) {

            if (!options) {
                return;
            }

            var _SELF = options.this || this;
            var deleteOptions = typeof options.orderItemId !== "undefined" ? "&orderItemId=" + options.orderItemId : "&deleteallitems=" + options.deleteallitems;
            ////// checking if part number comes from delete request ////////
            if(options.partNumber){
                var url = "/store1/cart/deleteitem/?language=" +  LocalePath.getLanguage() + "&countryCode=" + LocalePath.getCountry().toUpperCase()  + deleteOptions + "&partNumber=" + options.partNumber;
            }
            else{
                var url = "/store1/cart/deleteitem/?language=" +  LocalePath.getLanguage() + "&countryCode=" + LocalePath.getCountry().toUpperCase()  + deleteOptions;
            }
            //////////////////////////////
            //delete item
            $.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                beforeSend: function () {
                    if (options.beforeSendCallback) {
                        options.beforeSendCallback();
                        $(".js-checkout-button").addClass("disabled");
                    }
                },
                error: function (xhr, status, error) {
                    if (options.errorCallback) {
                        options.errorCallback();
                        $(".js-checkout-button").removeClass("disabled");
                    }
                },
                success: function (data) {
                    if (options.callback) {
                        options.callback(data);
                    }
                    $(".js-checkout-button").addClass("disabled");
                    _SELF.updateCartlet(data);
                    _SELF.updateCartUi({"data":data});
                }
            });
        },
        deleteAllSavedItems: function(options) {
            if (!options) {
                return;
            }

            var saveId = localStorage.getItem('saveForLaterCartId') || null;
            var data = {
                "saveForLaterCartId": saveId
            };

            $.ajax({
                url : '/store1/cart/saveforlater/deleteall/?language=' + LocalePath.getLanguage().toLowerCase() + '&countryCode=' + LocalePath.getCountry().toUpperCase() + '&saveForLaterCartId=' + data.saveForLaterCartId,
                type: 'DELETE',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(data),
                beforeSend: function() {
                    if (options.beforeSendCallback) {
                        options.beforeSendCallback();
                    }
                },
                success: function(data) {
                    if (options.callback) {
                        options.callback(data);
                    }
                },
                error: function(xhr) {
                    if (options.errorCallback) {
                        options.errorCallback(xhr);
                    }
                }
            });
        },

        editPartUI: function (element) {
            //Visual removal
            var deleteSpinnerHtml = '<div class="spinningCircle"></div>';
            element.closest('tbody').addClass('delete-item').append(deleteSpinnerHtml);
            fishersci.components.CartCheckoutUI.addSpinnerToElement(element);
            $(".js-checkout-button").addClass("disabled");
        },
        resetEditPartUI: function (element) {
            //Visual removal reset
            var deleteSpinnerHtml = '<div class="spinningCircle"></div>';
            element.closest('tbody').removeClass('delete-item').remove(deleteSpinnerHtml);
            fishersci.components.CartCheckoutUI.removeSpinnerFromElement(element);
            $(".js-checkout-button").removeClass("disabled");
        },
        cartErrorModal: function (options) {
            var options = options || {};

            var data = {
                "message": options.message || false,
                "alert": options.alert || false,
                "icon": options.icon || false,
                "options": options.options || false,
                "serviceErrorCode": options.serviceErrorCode || false
            };

            var modalHTML = ShoppingCart.templates['cart-error-modal'](data);
            $.colorbox({
                html: modalHTML,
                scrolling: false,
                width: options.width || "50%"
            });
        },
        confirmModal: function (options, callbackFunction, callbackOptions) {
            if (!options) {
                return;
            }

            var data = {
                "header": options.header || "Confirm",
                "message": options.message || false,
                "buttonText": options.buttonText || "Ok",
                "showCancel": options.showCancel || false,
                "alert": options.alert || false,
                "icon": options.icon || false,
                "options": options.options || false
            };

            var modalHTML = ShoppingCart.templates['confirm-modal'](data);
            $.colorbox({
                html: modalHTML,
                scrolling: false,
                width: options.width || "50%",
                onComplete: function () {
                    $(document).off('click', '#okButton').on('click', '#okButton', function () {
                        fisherDataLayer.events = "scRemove,event25";
                        fisherDataLayer.deleteSingle = false;
                        callbackFunction(callbackOptions);
                        if(typeof _satellite !== "undefined") {
                            _satellite.track("deleteItem");
                        }
                        $.colorbox.close();
                    });

                    //Remove all 'working' classes
                    $(options.element).removeClass('working');
                }
            });
        },
        deleteConfigItem: function (options) {

            if (!options) {
                return;
            }
            var _SELF = this;
            var typeOfOrder = options.configOrder;


            //delete config item
            $.ajax({
                url: "/store1/cart/deleteconfigitem/?language=" +  LocalePath.getLanguage() + "&countryCode=" + LocalePath.getCountry().toUpperCase() +"&type=" + typeOfOrder,
                type: 'GET',
                dataType: 'json',
                beforeSend: function () {
                    if (options.beforeSendCallback) {
                        options.beforeSendCallback();
                    }
                },
                error: function (xhr, status, error) {
                    if (options.errorCallback) {
                        options.errorCallback();
                    }
                },
                success: function (data) {
                    if (options.callback) {
                        options.callback(data);
                    }

                    _SELF.updateCartUi({"data":data});
                }
            });
        },
        validateQty: function (qty) {

            var validQty = Common.validQty(qty);

            //bad qty
            if (!validQty[0] && typeof(validQty[1]) !== "undefined") {
                return {
                    "result": false,
                    "message": i18nTranslations.cartUi.messages[validQty[1]]
                }
            }
            return true;
        },
        promocodeReset: function () {

            $(".js-apply, .js-promo-code-label").show();
            $("#promocodeAppliedWrapper").hide();
            $("#promocodeSubmitted").text("");
            $("#promoCodeRemove").css("display", "none");
            fisherDataLayer.promoCode = "";
        },
        doAfterUiUpdate: function (data) {
            var _SELF = this;

            //re-enable listeners, etc

            //Init tool tips
            _SELF.initToolTips();

            //update cartvar to handle deletions and additions
            _SELF.updateCartlet(data);

            // check if customer survey is existing
            if( !$('#FS-CAS-B2B-US').length ) { // we will not have a sticky proceed to checkout if the customer survey is attached
                _SELF.stickyCheckoutBtn();
            }

            //CSD RegEx
            _SELF.setCsdRegExpression();

            //Check CSD fields
            if( env.hasCSD ){
                setTimeout(function(){
                    _SELF.checkRequiredFields({
                        container: $('.js-csd-data-container'),
                        errorElement: $('#csdWarningError'),
                        callback : fishersci.components.CartCheckoutUI.validateFields
                    });
                },1000);
            }

            //Reference field Check only if enabled for the account (EU only currently)
            if( env.hasConsolidatedLineFields ){
                setTimeout(function(){
                    _SELF.checkRequiredFields({
                        container: $('.reference-fields-container'),
                        errorElement: $('#refFieldError'),
                        callback : fishersci.components.CartCheckoutUI.validateEmptyFields
                    });
                },1000);
            }

            //Toggles
            fishersci.Common.visibilityToggle();

            //Re-init Stock room code if scenario calls for it
            if (env.checkStockRoom) {
                fishersci.components.StockRoomModal.init();
                fishersci.components.StockRoomModal.initStockRoomElements('.stockroom-modal');
            }

            //Remove any leftover messages
            $('#item-moved-to-pick-up').addClass('hide');

            //Update any third party availability
            _SELF.findAvailabilityElements({
                element: $('.fetch-availability'),
                callback : _SELF.getAvailability
            });

            //Re-establish AJAX selectors
            $ajaxSelectors = $('.js-remove-item , .js-uom, .qty-field, .js-promo-code-input, .js-delete-cart');

            //check to see if there are assay ids still required
            if(fishersci.components.CartCheckoutUI.countInvalidAssays() !== 0){
                $('.js-checkout-button ').addClass('disabled');
                $('.notification-widget').remove();
                fishersci.components.CartCheckoutUI.showAssayNotification();
            } else {
                $('.notification-widget').remove();
            }

            //check for legal/license messages and show notification EU
            if(LocalePath.getCountry().toUpperCase() !== "US" && LocalePath.getCountry().toUpperCase() !== "CA") {
                try {
                    $.each(data.lineItems, function(x, y) {
                        fishersci.components.CartCheckoutUI.showChemLegalNotification(y.itemCore.chemicalLegalAndLicenseMsg);
                    });
                }catch (e){
                    console.log(e.message);
                }
            }

            //update cart count and rearm cart
            if(window.header && window.header.cart){
                window.header.cart.updateCount(window.header.cart.getCount())
                window.header.cart.reArmCartLink();
            }

            //check for optinMessage url query param and show notification as necessary
            _SELF.checkForB2bOptinMessage();
        },
        doInputSpinner: function (options) {
            if (!options) {
                return
            }

            $(options.element).addClass('input-spinner');
        },
        removeInputSpinner: function (options) {
            if (!options) {
                return
            }

            $(options.element).removeClass('input-spinner');
        },
        addSpinnerToElement: function (element, options) {
            if($(element).parent().find('.loading_image').length > 0){
                return; //return if spinner is already added
            }

            var defaults = {
                "position": "append",
                "classes": "wait loading_image",
                "imagePath": "/store1/cart/resources/images/",
                "image": "ajax_loader_product.gif"
            }

            var options = options || {};

            //Merge additional classes if defined
            if (options.classes) {
                defaults.classes += options.classes;
            }
            //Merge defaults and optional params
            options = $.extend(defaults, options);

            //add image
            var loadingImg = $(document.createElement('img')).attr({
                'class': options.classes,
                'src': options.imagePath + options.image
            });

            //append based on position option
            switch (options.position) {
                case "prepend":
                    $(element).prepend(loadingImg);
                    break;
                case "after":
                    $(element).after(loadingImg);
                    break;
                case "before":
                    $(element).before(loadingImg);
                    break;
                default:
                    $(element).append(loadingImg);
                    break;
            }
        },
        removeSpinnerFromElement: function (element) {
            $(element).parent().find('.loading_image').remove();
        },
        addToCartAnalytics: function (options) {
            var options = options || {};
            var omnitureProductString = [];
            var scOpenCartEvent;

            if ($.cookie("addToCartInitiated")) {
                 scOpenCartEvent = "";
            } else {
                // set a new cookie to indicate a product was added to the cart
                expiry = new Date();
                expiry.setTime(expiry.getTime()+(60*60*1000)); // 60 minutes
                // Date()'s toGMTSting() method will format the date correctly for a cookie
                $.cookie("addToCartInitiated", 'yes', { expires : expiry, path: "/" });

                scOpenCartEvent = ",scOpen";
            }

            //Add to Omniture tag
            for (var i = 0; i < options.parts.length; i++) {
                omnitureProductString.push(";" + options.parts[i] + ";;;;eVar33=" + options.addToCartFrom + "|eVar28=Regular Item - " + options.addToCartFrom);
            }

            try {
                //Omniture tags

                fisherDataLayer.linkTrackVars = "products,events,eVar28,eVar33";
                fisherDataLayer.linkTrackEvents = "scAdd" + scOpenCartEvent;
                fisherDataLayer.events = "scAdd" + scOpenCartEvent;
                fisherDataLayer.products = omnitureProductString;

                //Misc Data Layer requests
                fisherDataLayer.productData.cartId = options.cartId;
                fisherDataLayer.productData.cartTotal = options.cartTotal;
                fisherDataLayer.productData.partNumber = options.parts.join(",");
                fisherDataLayer.productData.qty = 1;
                fisherDataLayer.productData.addToCartFrom = "Cart";

                fisherDataLayer.customLinkGeneral = "Add to Cart from " + options.addToCartFrom;
                if(typeof _satellite !== "undefined") {
                    _satellite.track('addToCartGeneral');
                }


            } catch (e) {
                console.log(e.message);
            }
        },
        isNewHeader: function () {
            return typeof env.isNewHeader !== 'undefined';
        },
        checkResponseForMessages: function (options) {
            var options = options || {};
            var data = options.data || {};

            if (typeof data.messageList !== "undefined") {
                $.each(data.messageList, function (key, value) {
                    if (value === "mismatchTransTax") {
                        document.location.href = "/store1/cart/?language=" +  LocalePath.getLanguage() + "&countryCode=" + LocalePath.getCountry().toUpperCase() + "&urlMessages=mismatchTransTax";
                    }
                    if (value === "EXCEEDS_CART_LINES") {
                        document.location.href = "/store1/cart/?language=" +  LocalePath.getLanguage() + "&countryCode=" + LocalePath.getCountry().toUpperCase() + "&urlMessages=EXCEEDS_CART_LINES";
                    }
                })
            }
        },
        //Method to store the current state of the cart in relation to Pickup items - used to indicate an item has moved from Shipped to Pickup
        setCartState: function (options) {
            var $element = options.element;
            var storageName = options.storageName || false;
            var itemObject = {};

            $element.each(function () {
                var $this = $(this);
                var $orderItemId = $this.data('container-orderitemid');
                var $productTitle = $this.data('product-title');
                var $catalogNumber = $this.data('catalog-number');

                itemObject[$orderItemId] = {
                    "productTitle": $productTitle,
                    "catalogNumber": $catalogNumber
                }
            });

            //If storageName , create a sessionStorage reference
            if (storageName) {
                sessionStorage.setItem(storageName, JSON.stringify(itemObject));
            }

            return itemObject;
        },

        getAQuoteAction:    function( options ){
            var _SELF = fishersci.components.CartCheckoutUI;
            var hasMaximumLineItemsForQuote = false;

            //Check if cart has too many line items ( requirement says 100 )
            if ( _SELF.hasMaximumLineItemsForQuote() ){
                hasMaximumLineItemsForQuote = true;
            }
            // The uuid included in the url is the cartId
            $.ajax({ url: "/store1/quotes/service/getaquote/" + env.cartId + "/" + options.quoteType + "/" + hasMaximumLineItemsForQuote ,
                method: "GET",
                contentType: "application/json",
                success: function (data) {
                    var successMessage = document.getElementsByClassName('js-custom-quote-success');
                    // Add the response data to the body, this will render the modal
                    // and make the modal functions available
                    $('body').append(data);

                    //Remove any previous success messages
                    if ( successMessage.length > 0 ){
                        successMessage[0].remove();
                    }

                    // //Send disable event if user closes and reopens modal ( shouldn't be able , but just in case )
                    // if( typeof sendEventToGetAQuoteModal === 'function'){
                    //     sendEventToGetAQuoteModal({
                    //         eventType: 'DISABLE_INSTANT_QUOTE_BUTTON'
                    //     })
                    // }

                    // Now you can listen all the modal events by calling the listenGetAQuoteEvents
                    // you just have to send a listener function that will be called on every modal event
                    // the listener function should receive one parameter: event
                    // the 'event' parameter contains the event name and the specific data for each event
                    if ( typeof listenGetAQuoteEvents === 'function'){
                        listenGetAQuoteEvents(function myListener (event) {
                            if( event.eventType === 'SALES_QUOTE_SUBMITTED'){

                                //High level click tracking
                                fisherDataLayer.uiLabel = "UI Event captured: Request a Custom Quote from Modal";
                                fisherDataLayer.customLinkGeneral = "UI Event captured: Request a Custom Quote from Modal";
                                if(typeof _satellite !== "undefined") {
                                    _satellite.track('trackUiGeneral');
                                }

                                _SELF.handleSalesQuote({
                                    quoteData: event,
                                    success : function(){
                                        //close modal
                                        //closeGetAQuoteModal();
                                        if (typeof sendEventToGetAQuoteModal === 'function') {
                                            sendEventToGetAQuoteModal({
                                                eventType: 'CUSTOM_QUOTE_JUST_GENERATED'
                                            })
                                        }
                                    },
                                    error:  function(){
                                        fishersci.components.CartCheckoutUI.doNotifications({
                                            data: {
                                                message: '<h2>' + i18nTranslations.cartUi.messages.quoteSubmissionNotComplete + '</h2><p>' + i18nTranslations.cartUi.messages.issueSubmittingQuote + '</p>',
                                                icon: false,
                                                type: "alert-info"
                                            },
                                            additionalSelectors : "js-custom-quote-fail",
                                            showProgress: false,
                                            showProgressContainer: false,
                                            removeWhenDone: true,
                                            css : { borderLeft:"10px solid #F56A00" }
                                        });
                                    }
                                });
                            }

                            //Handle INSTANT QUOTES
                            if( event.eventType === 'INSTANT_QUOTE_REQUESTED'){
                                if ( typeof closeGetAQuoteModal === 'function'){
                                    //close modal
                                    //closeGetAQuoteModal();

                                    //High level click tracking
                                    fisherDataLayer.uiLabel = "UI Event captured: Get an Instant Quote from Modal";
                                    fisherDataLayer.customLinkGeneral = "UI Event captured: Get an Instant Quote from Modal";
                                    if(typeof _satellite !== "undefined") {
                                        _satellite.track('trackUiGeneral');
                                    }

                                    //Trigger click to existing generate function
                                    document.getElementById('generateWebQuote').click();
                                }
                            }

                            //Handle when user wants to change accounts
                            if ( event.eventType === 'SWITCH_ACCOUNT_REQUESTED' ){
                                if ( typeof closeGetAQuoteModal === 'function'){
                                    //close modal
                                    closeGetAQuoteModal();

                                    //High level click tracking
                                    fisherDataLayer.uiLabel = "UI Event captured: Quote Switch Account from Modal";
                                    fisherDataLayer.customLinkGeneral = "UI Event captured: Quote Switch Account from Modal";
                                    if(typeof _satellite !== "undefined") {
                                        _satellite.track('trackUiGeneral');
                                    }

                                    //Trigger click to existing generate function
                                    document.getElementById('switchAccounts').click();
                                }
                            }

                            if ( event.eventType === 'SHOW_CUSTOM_QUOTE_SUCCESS_MESSAGING') {
                                fishersci.components.CartCheckoutUI.doNotifications({
                                    data: {
                                        message: '<h2>' + i18nTranslations.cartUi.messages.customQuoteSubmitted + '</h2><p>' + i18nTranslations.cartUi.messages.customQuoteMessage + '</p>',
                                        icon: false,
                                        type: "success"
                                    },
                                    additionalSelectors : "js-custom-quote-success",
                                    showProgress: false,
                                    showCompleted: true,
                                    showProgressContainer: false,
                                    removeWhenDone: true,
                                    fontsize: "small"
                                });
                            }

                            if ( event.eventType === 'START_INSTANT_QUOTE_DOWNLOAD_PROCESS' ) {
                                var quoteNumber = event.data.quoteNumber;
                                var iframeSrc = "/store1/cart/generatewebquote/quotes/" + quoteNumber + "/?language=" + LocalePath.getLanguage() + "&countryCode=" + LocalePath.getCountry().toUpperCase();
                                var $hiddenFrame = $('#generateWebQuoteFrame');

                                //If 202 status, show email message
                                if( event.data.status === 202 ){
                                    fishersci.components.CartCheckoutUI.doNotifications({
                                        data: {
                                            message: i18nTranslations.cartUi.messages.webQuoteUnavailable,
                                            icon: "icon_Ok_Circle",
                                            type: "success"
                                        },
                                        showCompleted: true,
                                        removeWhenDone: true
                                    });

                                    return;
                                }

                                fishersci.components.CartCheckoutUI.doNotifications({
                                    data: {
                                        message: ( LocalePath.getCountry().toUpperCase() !== 'US' ? i18nTranslations.cartUi.messages.webQuoteDownloadingComplete : i18nTranslations.cartUi.messages.webQuoteReady ),
                                        type: "success"
                                    },
                                    showCompleted: true,
                                    removeWhenDone: true,
                                    callback:   function(){
                                        $('.js-web-quote-in-progress').fadeOut('slow', function(){
                                            _SELF.alignWidgets();
                                            $(this).remove();
                                        });
                                    }
                                });
                                $hiddenFrame.attr("src", iframeSrc );
                            }
                        })
                    }
                }
            })
        },

        handleSalesQuote:   function( options ){

            var dataForQuotes = {
                "cartId": env.cartId,
                "selectedAccountNumber": env.selectedAccountNumber
            };

            if( typeof options.quoteData !== "undefined"){
                if ( typeof options.quoteData.data !== "undefined"){
                    dataForQuotes.additionalRequirements = options.quoteData.data.additionalRequirements;
                }
            }

            $.ajax({
                url: "/store1/quotes/service/eloqua/",
                type: "POST",
                dataType: "json",
                data:   dataForQuotes,
                success: function (data) {
                    if( typeof options.success !== "undefined"){
                        options.success();
                    }
                },
                error : function(xhr){
                    if ( typeof  options.error !== "undefined"){
                        options.error();
                    }
                }
            });
        },

        generateWebQuoteListenerAction: function( event ){
            if(fishersci.components.CartCheckoutUI.countInvalidAssays() !== 0){
                $('.notification-widget').remove();
                fishersci.components.CartCheckoutUI.showAssayNotification();
                var $warningMessageContainer = $('.js-assay-id').closest('.js-assay-id-container').find('.js-assay-warning');
                var $warningMessage = $('.js-assay-id').closest('.js-assay-id-container').find('.js-assay-warning-message');
                $('.js-assay-id').closest('.js-assay-id-container').addClass('js-assay-needed js-assay-invalid');
                $('.js-assay-id').closest('.assay_id_form_container').addClass('assay-warn');
                $warningMessageContainer.removeClass('hide');
                 $warningMessage.text(i18nTranslations.cartUi.messages.invalidAssayId);
                $warningMessageContainer.find('.assay-icon').addClass('red');
                $('.js-assay-id').addClass('error-border');
                var $container = $('.js-assay-id').closest('.cart-ui-product-table')
                $('html, body').animate({
                    scrollTop: $container.offset().top-100
                }, 100);
                
            }
            else{
            var $this = event.b2bForm ? event.selector : $(this);
            var _SELF = fishersci.components.CartCheckoutUI;
            var showAddressModal = ['fr'];
            var $button = $('#generateWebQuote');
            var $pricingMessage = $('#pricingConfirmationMessage');

            //If identified as a country that supplies optional address fields, show modal and return
            if( $this.data('country') ){
                if ( showAddressModal.indexOf($this.data('country').toLowerCase()) !== -1){
                    $.colorbox({
                        inline: true,
                        href: "#pricingConfirmationAddress",
                        width: "33%",
                        onComplete: function () {
                            $.colorbox.resize();
                        },
                        onClosed: function () {
                            if ($('.gq-modal-container').length > 0) {
                                if (typeof closeGetAQuoteModalBase === 'function') {
                                    closeGetAQuoteModalBase();
                                }
                            }
                        }
                    });
                    return;
                }
            }

            //if identified as a punchout cart, call method to show modal and return
            if( $this.data('punchoutcart') ){
                var html;
                var data = {};
                html = Handlebars.partials['cart-b2b-web-quote'](data);

                $.colorbox({
                    transition: "elastic",
                    html: html,
                    width: "40%",
                    onComplete: function () {
                        $.colorbox.resize();
                    }
                });

                //Return out of this method to prevent progress bar from rendering
                return;
            }

            //If disabled, return
            if ($button.hasClass('disabled')) {
                return;
            }

            //show message
            $pricingMessage.removeClass('hide');
        

            _SELF.generateWebQuote({
                data : $("body").data('serializedB2B'),
                callback: function ( data ) {
                    var quoteNumber = data.quoteNumber;
                    var iframeSrc = "/store1/cart/generatewebquote/quotes/" + quoteNumber + "/?language=" + LocalePath.getLanguage() + "&countryCode=" + LocalePath.getCountry().toUpperCase();
                    var $hiddenFrame = $('#generateWebQuoteFrame');

                    //Capture event for Adobe
                    fisherDataLayer.uiLabel = "Generate Web Quote";
                    fisherDataLayer.customLinkGeneral = "UI Event captured: Generate Web Quote";

                    setTimeout(function () {
                        if(typeof _satellite !== "undefined") {
                            _satellite.track('trackUiGeneral');
                        }
                    }, 500);
                    if ( typeof sendEventToGetAQuoteModal === 'function') {
                        sendEventToGetAQuoteModal({
                            eventType: 'INSTANT_QUOTE_JUST_GENERATED',
                            data: {
                                quoteNumber: data.quoteNumber,
                                status: data.message
                            }
                        })
                        //Disabled button within modal
                        sendEventToGetAQuoteModal({
                            eventType: 'DISABLE_INSTANT_QUOTE_BUTTON'
                        })
                    } else {
                        //If 202 status, show email message
                        if( data.message === 202 ){
                            _SELF.doNotifications({
                                data: {
                                    message: i18nTranslations.cartUi.messages.webQuoteUnavailable,
                                    type: "success"
                                },
                                showCompleted: true,
                                removeWhenDone: true
                            });

                            return;
                        }

                        _SELF.doNotifications({
                            data: {
                                message: ( LocalePath.getCountry().toUpperCase() !== 'US' ? i18nTranslations.cartUi.messages.webQuoteDownloadingComplete : i18nTranslations.cartUi.messages.webQuoteReady ),
                                type: "success"
                            },
                            showCompleted: true,
                            removeWhenDone: true,
                            callback:   function(){
                                $('.js-web-quote-in-progress').fadeOut('slow', function(){
                                    _SELF.alignWidgets();
                                    $(this).remove();
                                });
                            }
                        });

                        $hiddenFrame.attr("src", iframeSrc );
                    }
                },
                beforeSendCallback: function () {
                    var message = LocalePath.getCountry().toUpperCase() !== 'US' ? i18nTranslations.cartUi.messages.webQuoteDownloading : i18nTranslations.cartUi.messages.webQuoteGenerated;

                    //Only show this message when customers have instant quote ONLY.  When using the modal, this message is unnecessary
                    if( env.permittedQuoteType === 'instant'){
                        _SELF.doNotifications({
                            data: {
                                message: message
                            },
                            removeWhenDone: true,
                            additionalSelectors: "js-web-quote-in-progress "
                        });
                    }
                    //TODO add message and disable quote button on CART page
                    //disable button
                    $button.addClass('disabled');
                },
                errorCallback: function ( data ) {
                    if ( typeof closeGetAQuoteModal === 'function' ){
                        //close get-a-quote modal on error
                        closeGetAQuoteModal();
                    }
                    var options = {};
                    var responseText = data.responseText || '{ "code":"S1"}';
                    var messageType = "error";
                    var trackingMessage = "Error";
                    var responseJson ;
                    var retryCodes = ["S1", "S2", "S4", "S5", "C1", "C2"]; // Codes that get 'retry' message
                    var emailQuoteCodes = ["S3"]; //Codes that get 'quote sent via email' message
                    var errorCode;
                    var cancelToaster = false;

                    //503 and other errors that return HTML
                    try {
                        responseJson = JSON.parse(responseText);
                        errorCode =  responseJson.code || "S1";
                    }catch(e){
                        //send retry code
                        errorCode = "S1";
                    }

                    //Which message to show
                    if( retryCodes.indexOf(errorCode) !== -1 ){
                        options.message = i18nTranslations.cartUi.messages.webQuoteIssue;
                        if ( typeof sendEventToGetAQuoteModal === 'function') {
                            cancelToaster = true;
                            //Show error message in modal
                            sendEventToGetAQuoteModal({
                                eventType: 'INSTANT_QUOTE_ERROR_RETRY'
                            })
                        }
                    }

                    if( emailQuoteCodes.indexOf(errorCode) !== -1 ){
                        options.message = i18nTranslations.cartUi.messages.webQuoteUnavailable;
                        messageType = "success";
                        trackingMessage = "Send via Email"

                        if ( typeof sendEventToGetAQuoteModal === 'function') {
                            cancelToaster = true;
                            //Show email message in modal
                            sendEventToGetAQuoteModal({
                                eventType: 'INSTANT_QUOTE_UNAVAILABLE_EMAIL'
                            })
                        }
                    }

                    //show notification badge if non-modal scenario
                    if ( !cancelToaster ){
                        _SELF.doNotifications({
                            data: {
                                message: options.message,
                                type: messageType
                            },
                            showProgress: false,
                            showCompleted: true,
                            removeWhenDone: true,
                            notificationTimeout: 8000,
                            callback:   function(){
                                $('.js-web-quote-in-progress').fadeOut('slow', function (){
                                    _SELF.alignWidgets();
                                });
                            }
                        });
                    }

                    //re-enable button only on non-success messages
                    if( messageType === "error" ){
                        $button.removeClass('disabled');
                    }

                    //Capture event for Adobe
                    fisherDataLayer.uiLabel = "Generate Web Quote - " + trackingMessage;
                    fisherDataLayer.customLinkGeneral = "UI Event captured: Generate Web Quote - " + trackingMessage;

                    setTimeout(function () {
                        if(typeof _satellite !== "undefined") {
                            _satellite.track('trackUiGeneral');
                        }
                    }, 500);
                }
            })
            }
        },

        //method to generate web quote
        generateWebQuote: function (options) {
            var url = "/store1/cart/generatewebquote/?cartId=" + env.cartId + "&language=" +  LocalePath.getLanguage() + "&countryCode=" + LocalePath.getCountry().toUpperCase();

            //If sending extra address fields for EU, add to URL
            if( typeof env.pricingConfirmationFields !== "undefined"){
                url += "&address1=" + encodeURIComponent(env.pricingConfirmationFields.address1) + "&address2=" +encodeURIComponent(env.pricingConfirmationFields.address2);
                delete env.pricingConfirmationFields;
            }

            //for testing, allow QA to append query param to force a timeout
            if (fishersci.util.QueryString.getByKey("timeout")) {
                url += "&timeout=true";
            }

            if (fishersci.util.QueryString.getByKey("testError")) {
                url += "&testError=true";
            }

            if (fishersci.util.QueryString.getByKey("sendQuoteEmail")) {
                url += "&sendQuoteEmail=true";
            }

            $.ajax({
                timeout: env.webQuoteTimeout || 12000,
                data: options.data,
                type: "GET",
                dataType: "json",
                url: url,
                beforeSend: function () {
                    if (options.beforeSendCallback) {
                        options.beforeSendCallback();
                    }
                },
                success: function (data) {

                    if (options.callback) {
                        options.callback(data);
                    }
                },
                error: function (xhr, status, error) {
                    if (options.errorCallback) {
                        options.errorCallback(xhr, status, error);
                    }
                }
            })

        },

        //Generic method to create notifications - most UI is statically controlled by CSS
        doNotifications: function (options) {
            var html;
            var defaults = {
                data: {
                    message: i18nTranslations.cartUi.messages.webQuoteReady,
                    type: "general"
                },
                selector: ".notification-widget",
                domTarget: "body",
                domPosition: "append",
                showProgress: true,
                progressSpeed: 100,
                progressIncrement: 2,
                progressMaxWidth: 415,
                showCompleted: false,
                removeWhenDone: false,
                removeAfterTime: false,
                notificationTimeout: 7000,
                stackMessages: true,
                notificationId: Date.now(),
                additionalSelectors: "",
                fontsize : "normal",
                callback:   function(){}
            };
            var _SELF = this;

            //make a recursive copy first
            var $options = $.extend(true, {}, defaults, options);

            var _removeWhenDone = function () {
                //if we need to remove the notifications when they complete progress, do so
                if ($options.removeWhenDone) {
                    setTimeout(function () {
                        _removeNotifications();
                        _SELF.alignWidgets();
                    }, $options.notificationTimeout)
                }
            };

            var _removeNotifications = function () {
                $('#' + $options.notificationId).fadeOut('slow', function () {
                    $(this).remove();
                })
            };

            //kill any existing animations
            clearInterval(window._progressTime);

            //Private method to handle progress animation
            var _doProgressAnimation = function () {
                var progressBar = document.getElementById('progress_' + $options.notificationId);
                progressBar.value = 0;

                window._progressTime = setInterval(function () {
                    //Increment progress bar
                    progressBar.value += $options.progressIncrement;

                    if ( progressBar.value >= $options.progressMaxWidth ) {
                        clearInterval(window._progressTime);
                        delete (window._progressTime);

                        //If we need to remove it, do so
                        _removeWhenDone();
                    }
                }, $options.progressSpeed)
                //Set interval ID as an option
                $options.intervalId = window._progressTime;
            };

            //hide any existing notifications
            if ( !$options.stackMessages ){
                _removeNotifications();
            }

            //bind data to template
            html = Handlebars.partials['cart-notifications']($options);

            //append / prepend html to domTarget
            switch ($options.domPosition) {
                case "append":
                    $($options.domTarget).append(html);
                    break;
                case "prepend":
                    $($options.domTarget).prepend(html);
                    break;
                case "before":
                    $($options.domTarget).before(html);
                    break;
                default:
                    $($options.domTarget).append(html);
                    break;
            }

            //apply any custom CSS to the widget
            _applyCss = function(){
                $('#' + $options.notificationId).css($options.css)
            };

            //show progress bar
            if ($options.showProgress) {
                $('#' + $options.notificationId).removeClass('hide');
            }

            //show progress bar container
            if (!$options.showProgressContainer) {
                $('#progress_container' + $options.notificationId).addClass('hide');
            }

            //If custom CSS, apply it
            if ( $options.css ){
                _applyCss($options.css);
            }

            //If we are to show the progress animation, only do so if we're not to show the completed progress onload of the widget
            if ($options.showProgress && !$options.showCompleted) {
                _doProgressAnimation();
            }

            //If we are to show the completed phase, just make the progress bar be max width
            if ($options.showCompleted) {

                if( document.getElementById('progress_' + $options.notificationId) ){
                    document.getElementById('progress_' + $options.notificationId).value = 100;
                }

                //Test to see if we need to remove it
                _removeWhenDone();
            }

            //If we want message to go away , removeAfterTime is true, use notificationTimeout as delay
            if( $options.removeAfterTime ){
                _removeWhenDone();
            }

            //run any callbacks
            if ( $options.callback ){
                $options.callback();
            }

            //stack multiple messages
            _SELF.alignWidgets();
        },

        //Removes notifications
        doDestroyNotification: function () {
            clearInterval(window._progressTime); //stop the animation
        },

        //Adjust for multiple widgets
        alignWidgets : function() {
            var widget;
            var widgetCount;
            widget = document.getElementsByClassName('notification-widget');
            widgetCount = widget.length;
            for( var w = 0; w < widgetCount; w ++ ){
                if( typeof widget[w-1] !== "undefined") {

                    //If positioned absolute, don't align
                    if( widget[w-1].className.indexOf('position-absolute') !== -1){
                        return;
                    }
                    widget[w].style.top = ( widget[w-1].offsetHeight + widget[w-1].offsetTop ) + 10 + "px";
                } else {
                    //If positioned absolute, don't align
                    if( widget[w].className.indexOf('position-absolute') !== -1){
                        return;
                    }
                    widget[w].style.top = '10px';
                }
            }
        },

        //Call service to send email for Smart Filter / CDC
        sendSmartFilterEmail:   function(){

            //No callbacks needed - call simply sends email if there are filtered items in the cart
            $.ajax({
                url: "/store1/cart/emailspecialitems/?language=" + LocalePath.getLanguage() + "&countryCode=" + LocalePath.getCountry().toUpperCase(),
                dataType : "json",
                type: "GET"
            })
        },

        //Build RegEx for CSD fields
        generateRegularExpression:  function (fieldFormat, required) {
            var _SELF = this;
            var regExpString = '^';
            var data = '~';
            var occurrence = 0;
            var isRequired = required ||  false;

            fieldFormat.split('').forEach(function(literal) {

                if (data !== literal) {
                    if (data !== '~') {
                        regExpString += _SELF.getExpression(data, occurrence);
                    }
                    data = literal;
                    occurrence = 1;
                } else {
                    occurrence++;
                }

            });

            if (data !== '~') {
                if (data === 'X' && regExpString === "^") {
                    regExpString += (isRequired ? ".*\\S.*" :  "(.*?)");
                } else {
                    regExpString += _SELF.getExpression(data, occurrence);
                }
            }

            regExpString += "$";
            return regExpString;

        },

        getExpression:  function (data, occurrence) {
            switch (data) {
                case 'A':
                    return "[a-zA-Z]{" + occurrence + "}";

                case 'N':
                    return "[0-9]{" + occurrence + "}";

                case 'X':
                    return ".{" + occurrence + "}";

                default:
                    return "[" + data + "]{" + occurrence + "}";
            }
        },

        setCsdRegExpression:    function(){
            var _SELF = this;
            $('[data-required]').each(function(){
                var $this = $(this);
                var format = $this.data('regex-format');

                if ( format ){
                    $this.data('regex', _SELF.generateRegularExpression(format, true));
                }
            })
        },

        //Find Products that need external availability ( third party, etc)

        findAvailabilityElements: function( options ){
            if( !options ){
                return;
            }
            var $element = options.element;
            var callback = options.callback || new Function();

            //Loop through element
            $($element).each(function(){
                var $this = $(this);
                callback({
                    element: $this,
                    callback: function(data){
                        if( $.trim(data) !== "" ){
                            $this.html(data);
                        }
                    }
                })
            })
        },

        //Third Party Availability

        getAvailability:  function( options ){
            if( !options ){
                return;
            }
            var $element = options.element;
            var parts = [];
            var data = {
                "pricing": false,
                "directShipAvailability" : true,
                "parts": parts
            }
            var $uom = $element.data('uom');
            var $partNumber = $element.data('partnumber');
            var $qty = $element.data('qty');
            var $zipcode = $element.data('zipcode');
            var $accountNumber = $element.data('account');
            var $orderItemId = $element.closest('tbody').data('containerOrderitemid');

            parts.push({
                partNumber: $partNumber,
                quantity: $qty,
                uom: $uom
            })

            //Make AJAX call and return HTML
            $.ajax({
                url: "/store1/cart/availability/?zipCode=" + $zipcode + "&accountNumber=" + $accountNumber + "&language=" + LocalePath.getLanguage() + "&countryCode=" + LocalePath.getCountry().toUpperCase() + "&orderItemId=" + $orderItemId,
                dataType : "html",
                type: "POST",
                data: data,
                success : function(data){
                    if (options.callback) {
                        options.callback(data);
                    }
                },
                error: function (xhr, status, error) {
                    if (options.errorCallback) {
                        options.errorCallback(xhr, status, error);
                    }
                }
            })

        },

        //Check all CSD fields on load, or after specific calls

        checkRequiredFields:   function( options ){
            var options = options || {};
            var defaults = {
                doClickAction : true
            };
            var $options = $.extend(defaults, options);
            var errorCount = 0;

            $(options.container).each(function(){
                var $formErrors = 0;
                var $this = $(this);
                $formErrors = options.callback({element: $this.find('[data-required]'),suppressCssError : true});

                if($formErrors > 0){
                    errorCount++;
                    // trigger 'Edit' button click to turn csd fields of current line item into edit mode.
                    if( $options.doClickAction ){
                        $this.closest('.csd-view').find('.js-edit-csd').click();
                    }
                }

                if(errorCount > 0){

                    //show error message - disable checkout button
                    if(options.errorElement){
                        $(options.errorElement).removeClass('hide');
                    }

                    if(options.errorCallback){
                        options.errorCallback();
                    }
                    $('.js-checkout-button').addClass('disabled');

                    //return false;
                } else {

                    //hide error message - enable checkout button
                    $(options.errorElement).addClass('hide');
                    $('.js-checkout-button').removeClass('disabled');
                }

            });
        },

        doQuotePromoMessage: function() {
            fishersci.components.CartCheckoutUI.doNotifications({
                data: {
                    message: i18nTranslations.cartUi.messages.promoOnQuote,
                    icon: "icon_Warning_Triangle",
                    type: "warning"
                },
                showProgress: false,
                showProgressContainer: false,
                removeWhenDone: true,
            });
        },

        updateShippingAndTax:   function( options ){
            var options = options || {};
            var _SELF = this;

            if ( env.callShippingAndTax ){
                _SELF.getShippingAndTax({
                    beforeSendCallback: function(){
                        $('.checkout-button').addClass('disabled');
                        $('.ring').removeClass('hide');
                        $('.order-summary.container').addClass('fader-medium');
                    },
                    errorCallback: function(){
                        //remove effects
                        $('.checkout-button').removeClass('disabled');
                        $('.ring').addClass('hide');
                        $('.order-summary.container').removeClass('fader-medium');
                    },
                    callback: function( data ){
                        $.extend(data,options);
                        fishersci.components.CartCheckoutUI.updateCartUi({"data":data});

                        //If errors, reset
                        if(data.status === 500 ){
                            //remove effects
                            $('.checkout-button').removeClass('disabled');
                            $('.ring').addClass('hide');
                            $('.order-summary.container').removeClass('fader-medium');
                            $('.wait .loading_image').remove();
                        }

                        if( options.callback ){
                            options.callback();
                        }

                    }
                });
            }
        },
        /*
        AJAX call to get shipping and tax
         */

        getShippingAndTax:   function( options ){
            $.ajax({
                type: "GET",
                dataType: 'json',
                url: "/store1/cart/shippingandtax/?language=" +  LocalePath.getLanguage() + "&countryCode=" + LocalePath.getCountry().toUpperCase(),
                beforeSend: function () {
                    if (options.beforeSendCallback) {
                        options.beforeSendCallback();
                    }
                },
                success: function (data) {

                    if (options.callback) {
                        options.callback(data);
                    }
                },
                error: function (xhr, status, error) {
                    if (options.errorCallback) {
                        options.errorCallback(xhr, status, error);
                    }
                }
            })
        },
        doTlsCheck: function() {
            //tls version set globally
            if (typeof tlsVersion === "undefined") {
                return;
            }

            var tls = sessionStorage.getItem('tls');
            var tlsWarning = sessionStorage.getItem('tlsWarningShown') || false;
            var tlsVersionNumber = parseInt(tlsVersion.replace(/[a-zA-Z.]/g, ""));

            fisherDataLayer.tlsVersion = tlsVersion;
            sessionStorage.setItem('tls', tlsVersion);

            //Show modal if version is less than 1.2 and user hasn't already seen warning this session
            if ((tlsVersionNumber < 12) && !tlsWarning) {
                sessionStorage.setItem('tlsWarningShown',true)
                $.colorbox({
                    html: $("#pci-warning").html(),
                    onComplete: function() {
                        $(document).on('click', '#cancelPciModal', function() {
                            $.colorbox.close();
                        });
                    }
                })
            }
        },
        initToolTips: function(){
            //Tooltips for glyphs and web pricing where we need to keep the modal open if it's hovered
            $('.new-glyph, .js-web-discount').tooltip({
                content: function () {
                    return $(this).prop('title');
                },
                show: null,
                close: function (event, ui) {
                    ui.tooltip.hover(

                        function () {
                            $(this).stop(true).fadeTo(400, 1);
                        },

                        function () {
                            $(this).fadeOut("400", function () {
                                $(this).remove();
                            })
                        });
                    $(".ui-helper-hidden-accessible > *:not(:last)").remove(); //known jQUery UI issue
                }
            });
            //Generic Tooltips
            $('.messageDialog').tooltip({
                content: function () {
                    return $(this).prop('title');
                }
            });
        },

        countInvalidAssays: function() {
            return $('.js-assay-needed').length;
        },
        //show assay notification
        showAssayNotification: function() {
        //Show upper right alert
            fishersci.components.CartCheckoutUI.doNotifications({
                data: {
                    message: "<b>" + i18nTranslations.cartUi.messages.assayCertainItems + "</b><br>" + i18nTranslations.cartUi.messages.assayPleaseEnter + "<br><a class='smaller-text js-find-out-more' href='javascript:void(0);'>" + i18nTranslations.cartUi.messages.findOutMore + "</a>",
                    icon: "icon_Warning_Triangle",
                    type: "warning"
                },
                showProgress: false,
                showProgressContainer: false,
                removeWhenDone: true,
                fontsize: "small"
            });
        },
        getColorboxWidth: function(){
            var modalWidth = '90%';

            if(fishersci.Common.inDesktopBreakpoint()){
                modalWidth = '440px';
            } else if(fishersci.Common.inTabletBreakpoint()){
                modalWidth = '75%';
            }
            return modalWidth;
        },
        // get saved for later items
        getSavedForLaterItems: function() {
            // get saved for later items
            var _SELF = this;
            var saveId = localStorage.getItem('saveForLaterCartId');
            var data = {
                "saveForLaterCartId": saveId || null
            };

            $.ajax({
                url : '/store1/cart/saveforlater/get/?language=' + LocalePath.getLanguage().toLowerCase() + '&countryCode=' + LocalePath.getCountry().toUpperCase(),
                type: 'GET',
                dataType: 'json',
                contentType: 'application/json',
                data: data,
                success: function(data) {
                    //Render saved item count
                    if( typeof data.saveForLaterItems !== "undefined" ){
                        data.saveForLaterItemCount = Object.keys(data.saveForLaterItems).length;
                    }
                    //update ID
                    localStorage.setItem('saveForLaterCartId', data.saveForLaterCartId);
                    //update UI
                    _SELF.updateSaveForLaterUi({"data":data});
                    _SELF.initToolTips();
                },
                error : function(xhr) {
                    console.log(xhr);
                }
            });
        },

        //Merge saved items when guest user converts to registered
        mergeSavedForLaterItems: function() {
            // get saved for later items
            var _SELF = this;
            var saveId = localStorage.getItem('saveForLaterCartId');
            var data = {
                "saveForLaterCartId": saveId || null
            };

            $.ajax({
                url : '/store1/cart/saveforlater/merge/?language=' + LocalePath.getLanguage().toLowerCase() + '&countryCode=' + LocalePath.getCountry().toUpperCase(),
                type: 'POST',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(data),
                success: function(data) {
                    //Set this value on every save or save all and merge
                    if( data.saveForLaterCartId ){
                        localStorage.setItem('saveForLaterCartId', data.saveForLaterCartId);
                    }
                    sessionStorage.setItem("savedCartMerged" , "true");

                    //Render saved item count
                    if( typeof data.saveForLaterItems !== "undefined" ){
                        data.saveForLaterItemCount = Object.keys(data.saveForLaterItems).length;
                    }

                    //update UI
                    _SELF.updateSaveForLaterUi({"data":data});
                    _SELF.initToolTips();
                },
                error : function(xhr) {
                    console.log(xhr);
                }
            });
        },
        initFavorites: function(){
            var _SELF = this;
            var timer;
            var counter = 0;
            var successCallback = function (data) {
                if(Object.keys(data).length > 0) {
                    totalPage = Math.ceil(Object.keys(data).length/6);
                    favList = Object.keys(data)
                    $('#light-pagination').pagination({

                        pages: totalPage,
                        displayedPages: 6,
                        edges: 1,
                        useStartEdge :true,
                        useEndEdge :true,
                        currentPage: 1,
                        useAnchors:false,
                        hrefTextPrefix:'',
                        hrefTextSuffix:'',
                        prevText: i18nTranslations.cartUi.messages.favoritePrev,
                        nextText: i18nTranslations.cartUi.messages.favoriteNext,
                        ellipseText:'&hellip;',
                        ellipsePageSet:false,
                        listStyle:'',
                        cssStyle:"compact-theme",
                        selectOnClick:true,
                        nextAtFront:false,
                        invertPageOrder:false,
                        onPageClick: function(pageNumber, event) {
                            var favoriteList = favList;
                            var sets=[];
                            for(var i=0;i<favoriteList.length;i+=6){
                            sets.push(favoriteList.slice(i,i+6));
                            }
                            var setindex = pageNumber-1;
                            var selectedSet = sets[setindex];
                            _SELF.getFavoritePartDetails({parts:JSON.stringify(selectedSet)});
                        },
                        onInit: function() {
                            // Callback triggered immediately after initialization
                            _SELF.getFavoritePartDetails({parts:JSON.stringify(Object.keys(data).slice(0,6))});
                        }
                      });
                    
                    //Show the tab
                    document.querySelector('#favoritesTab').classList.remove('hide');
                    document.querySelector('.tab-container').classList.remove('hide');
                    $("#FS-CAS-B2B-US").addClass('absolute-position-survey-box');
                } else {
                    //HIde the Favorites tab
                    document.querySelector('#favoritesTab').classList.add('hide');
                }
            }

            var errorCallback = function (err) {
                console.log(err);
            }
            try {
                timer = setInterval(function(){
                    if( counter < 10 ) {
                        if (typeof favoritesRawData !== "undefined") {
                            //this function comes from Shopping Tools JS
                            favoritesRawData.getFavoritePartNumbers(successCallback, errorCallback);
                            clearInterval(timer);
                        } else {
                            counter++;
                        }
                    } else {
                        console.warn('favoritesRawData not available after 10 tries');
                        clearInterval(timer);
                    }
                },100)
            }catch (e){
                console.warn(e.message);
            }
        },

        initMyTopPurchases: function(acctNum){
            var _SELF = this;

            try {
                _SELF.getMyTopPurchasesPartDetails(acctNum);
            } catch (e) {
                console.warn("Error calling getMyTopPurchasesPartDetails() " + e.message);
                document.querySelector('#myTopPurchasesTab').classList.add('hide');
            }
        },

        getFavoritePartDetails : function (options) {
            var xhr = new XMLHttpRequest();
            xhr.withCredentials = true;
    
            xhr.addEventListener("readystatechange", function() {
                if (this.readyState === 4) {
                    document.getElementsByClassName('js-favorites-content')[0].innerHTML = this.responseText;
                    if(!currentPageNumber){
                        currentPageNumber=1;
                    }
                    cache[currentPageNumber] = this.responseText;
                    
                    $('#light-pagination').pagination({
    
                            pages: totalPage,
                            displayedPages: 6,
                            edges: 1,
                            useStartEdge :true,
                            useEndEdge :true,
                            currentPage: currentPageNumber,
                            useAnchors:false,
                            hrefTextPrefix:'',
                            hrefTextSuffix:'',
                            prevText: i18nTranslations.cartUi.messages.favoritePrev,
                            nextText: i18nTranslations.cartUi.messages.favoriteNext,
                            ellipseText:'&hellip;',
                            ellipsePageSet:false,
                            listStyle:'',
                            cssStyle:"compact-theme",
                            selectOnClick:true,
                            nextAtFront:false,
                            invertPageOrder:false,
                            onPageClick: function(pageNumber, event) {
                                var favoriteList = favList;
                                currentPageNumber = pageNumber;
                                var sets=[];
                                for(var i=0;i<favoriteList.length;i+=6){
                                sets.push(favoriteList.slice(i,i+6));
                                }
                                var setindex = pageNumber-1;
                                var selectedSet = sets[setindex];
                                if(cache.hasOwnProperty(pageNumber)){
                                    document.getElementsByClassName('js-favorites-content')[0].innerHTML = cache[pageNumber];
                                    var pricingRadio = document.querySelectorAll('.js-pricing-block input');
                                    var addRadioListener = function(element) {
                                        //default the uom attribute on the button to the current STD uom
                                        if (element.getAttribute('checked')) {
                                            element.parentElement.parentElement.nextElementSibling.setAttribute('data-uom', element.getAttribute('value'));
                                            element.parentElement.parentElement.nextElementSibling.setAttribute('data-uomtype', element.getAttribute('data-uomtype'));
                                        }
                                        //add event listener for radio button
                                        element.addEventListener('click', function() {
                                            console.log(this.value);
                                            console.log(this.parentElement.parentElement.nextElementSibling);
                                            this.parentElement.parentElement.nextElementSibling.setAttribute('data-uom', this.value);
                                            this.parentElement.parentElement.nextElementSibling.setAttribute('data-uomtype', this.getAttribute('data-uomtype'));
                                        })
                    
                                    }
                                    pricingRadio.forEach(addRadioListener)
                                    //add event listener to add to cart button
                                    var favoriteButton = document.querySelectorAll('.js-add-favorites-to-cart');
    
    
                                    var addFavoriteEvents = function (favorite) {
                                        favorite.addEventListener('click', function () {
                                            addFavoriteToCart(favorite);
                                        })
                                    }
                                    console.log(favoriteButton.length);
                                    favoriteButton.forEach(addFavoriteEvents);
                                    paginationInitialization();
                                }
                                else{
                                    xhr.open("POST", "/store1/cart/favorites/");
                                    xhr.setRequestHeader("content-type", "application/json");
                                    xhr.setRequestHeader("cache-control", "no-cache");
                                    xhr.send(JSON.stringify(selectedSet));
                                } 
                            },
                        
                          });
                    if(favList.length > 6){
                        $('#light-pagination').css('display','block');
                    }
                    else{
                        $('#light-pagination').css('display','none');
                    }
                    var pricingRadio = document.querySelectorAll('.js-pricing-block input');
                    var addRadioListener = function(element) {
                        //default the uom attribute on the button to the current STD uom
                        if (element.getAttribute('checked')) {
                            element.parentElement.parentElement.nextElementSibling.setAttribute('data-uom', element.getAttribute('value'));
                            element.parentElement.parentElement.nextElementSibling.setAttribute('data-uomtype', element.getAttribute('data-uomtype'));
                        }
                        //add event listener for radio button
                        element.addEventListener('click', function() {
                            console.log(this.value);
                            console.log(this.parentElement.parentElement.nextElementSibling);
                            this.parentElement.parentElement.nextElementSibling.setAttribute('data-uom', this.value);
                            this.parentElement.parentElement.nextElementSibling.setAttribute('data-uomtype', this.getAttribute('data-uomtype'));
                        })
    
                    }
                    pricingRadio.forEach(addRadioListener)
    
                    //add event listener to add to cart button
                    var favoriteButton = document.querySelectorAll('.js-add-favorites-to-cart');
    
    
                    var addFavoriteEvents = function(favorite) {
                        favorite.addEventListener('click', function() {
                            addFavoriteToCart(favorite);
                        })
                    }
                    console.log(favoriteButton.length);
                    favoriteButton.forEach(addFavoriteEvents);
    
                    //If Favorites is the only tab, click it
                    if ( document.querySelector('#savedForLaterTab').classList.value.indexOf('hide') !== -1 && document.querySelector('#myTopPurchasesTab').classList.value.indexOf('hide') !== -1 ){
                        document.querySelector('#favoritesTabRadio').click();
                    }
                }
            });
            if(!cache.hasOwnProperty(currentPageNumber)){
            xhr.open("POST", "/store1/cart/favorites/");
            xhr.setRequestHeader("content-type", "application/json");
            xhr.setRequestHeader("cache-control", "no-cache");
            xhr.send(options.parts);
            }
    
            function paginationInitialization(){
                $('#light-pagination').pagination({
    
                    pages: totalPage,
                    displayedPages: 6,
                    edges: 1,
                    useStartEdge :true,
                    useEndEdge :true,
                    currentPage: currentPageNumber,
                    useAnchors:false,
                    hrefTextPrefix:'',
                    hrefTextSuffix:'',
                    prevText: i18nTranslations.cartUi.messages.favoritePrev,
                    nextText: i18nTranslations.cartUi.messages.favoriteNext,
                    ellipseText:'&hellip;',
                    ellipsePageSet:false,
                    listStyle:'',
                    cssStyle:"compact-theme",
                    selectOnClick:true,
                    nextAtFront:false,
                    invertPageOrder:false,
                    onPageClick: function(pageNumber, event) {
                        var favoriteList = favList;
                        currentPageNumber = pageNumber;
                        var sets=[];
                        for(var i=0;i<favoriteList.length;i+=6){
                        sets.push(favoriteList.slice(i,i+6));
                        }
                        var setindex = pageNumber-1;
                        var selectedSet = sets[setindex];
                        if(cache.hasOwnProperty(pageNumber)){
                            document.getElementsByClassName('js-favorites-content')[0].innerHTML = cache[pageNumber];
                            var pricingRadio = document.querySelectorAll('.js-pricing-block input');
                            var addRadioListener = function(element) {
                                //default the uom attribute on the button to the current STD uom
                                if (element.getAttribute('checked')) {
                                    element.parentElement.parentElement.nextElementSibling.setAttribute('data-uom', element.getAttribute('value'));
                                    element.parentElement.parentElement.nextElementSibling.setAttribute('data-uomtype', element.getAttribute('data-uomtype'));
                                }
                                //add event listener for radio button
                                element.addEventListener('click', function() {
                                    console.log(this.value);
                                    console.log(this.parentElement.parentElement.nextElementSibling);
                                    this.parentElement.parentElement.nextElementSibling.setAttribute('data-uom', this.value);
                                    this.parentElement.parentElement.nextElementSibling.setAttribute('data-uomtype', this.getAttribute('data-uomtype'));
                                })
            
                            }
                            pricingRadio.forEach(addRadioListener)
                            //add event listener to add to cart button
                            var favoriteButton = document.querySelectorAll('.js-add-favorites-to-cart');
    
    
                            var addFavoriteEvents = function (favorite) {
                                favorite.addEventListener('click', function () {
                                    addFavoriteToCart(favorite);
                                })
                            }
                            console.log(favoriteButton.length);
                            favoriteButton.forEach(addFavoriteEvents);
                            paginationInitialization();
                        }
                        else{
                            xhr.open("POST", "/store1/cart/favorites/");
                            xhr.setRequestHeader("content-type", "application/json");
                            xhr.setRequestHeader("cache-control", "no-cache");
                            xhr.send(JSON.stringify(selectedSet));
                        } 
                    },
                  });
            }
            function addFavoriteToCart(element) {
                //prevent double click
                if(element.classList.value.indexOf('working') !== -1){
                    return;
                }
    
                element.classList.add('working');
    
                //Animation
                if(element.classList.value.indexOf('loading') === -1) {
                    element.classList.add('loading');
                    element.querySelectorAll('li').forEach(function(el){
                        if(el.classList.value.indexOf('liAtc1') !== -1) {
                            el.style.display = 'none';
                        }
                        if(el.classList.value.indexOf('liAtc2') !== -1) {
                            el.style.display = 'block';
                        }
                    })
                }
    
                var data = {
                    "addToCartFrom": "Favorites - In Cart",
                    "itemList": [{
                        "partNumber": element.getAttribute('data-partnumber'),
                        "uom": element.getAttribute('data-uom'),
                        "uomType": element.getAttribute('data-uomtype')?element.getAttribute('data-uomtype'):'STD',
                        "quantity": element.getAttribute('data-qty')
                    }]
                }
                fishersci.components.CartCheckoutUI.addToCart({
                    data: data,
                    beforeSendCallback: function() {
                        element.classList.add('disabled');
                    },
                    errorCallback: function(xhr, status, error) {
    
                        element.classList.remove('disabled working');
                        //Reset buttons
                        if(element.classList.value.indexOf('inactiveATC') !== -1) {
                            element.classList.remove('activeATC loading');
                            //$this.css('background-color', '#e5e5e5');
                            element.querySelectorAll('li').forEach(function(el){
                                if(el.classList.value.indexOf('liAtc2') !== -1) {
                                    el.style.display = 'none';
                                }
                                if(el.classList.value.indexOf('liAtc1') !== -1) {
                                    el.style.display = 'block';
                                }
                            })
                        }
    
                        var errorJson;
    
                        try {
                            errorJson = JSON.parse(xhr.responseText);
    
                            if (errorJson.showError) {
                                _SELF.cartErrorModal({
                                    "message": i18nTranslations.cartUi.messages.webOrderingUnavailable,
                                    "serviceErrorCode": errorJson.serviceErrorCode,
                                    "icon": "icon_Warning_Triangle"
                                })
                            }
                        } catch (e) {
                            console.error(e);
                        }
                    },
                    callback: function(data) {
    
                        var shippingAndTaxData = {};

                        // Show added to cart success or reset the button in case of duplicate error
                        if(element.classList.value.indexOf('inactiveATC') !== -1) {
                            element.classList.add('done');
                            element.querySelectorAll('li').forEach(function(el){
                                if(el.classList.value.indexOf('liAtc2') !== -1) {
                                    el.style.display = 'none';
                                }
                                if(el.classList.value.indexOf('liAtc3') !== -1) {
                                    el.style.display = 'block';
                                }
                            })
                            element.classList.remove('working');
                        }
    
                        //In case of error from backend returned in 200 status
                        if (data.status) {
                            if (data.status !== 200) {
                                console.log(data);
                                return;
                            }
                        }
    
                        //Check for duplicate items
                        if (typeof data.duplicateQuoteItems !== "undefined") {
                            shippingAndTaxData.duplicateQuoteItems = data.duplicateQuoteItems;
                        }
    
                        //Check for messages
                        if (typeof data.messageList !== "undefined") {
                            $.each(data.messageList, function(key, value) {
                                if (value === "DUPLICATE_ITEM") {
                                    shippingAndTaxData.DUPLICATE_ITEM = true;
                                }
                            })
                        }
    
                        //Update Shipping and Taxes
                        //TODO clean up repetitive code
                        if (data.wasAdded && (data.productsNotFoundQuickAdd == "" || !data.productsNotFoundQuickAdd)) {
                            if (env.punchoutUser && !env.punchoutUseShippingAndTaxService) {
                                fishersci.components.CartCheckoutUI.updateCartUi({
                                    "data": $.extend(data, shippingAndTaxData)
                                })
                            } else {
                                fishersci.components.CartCheckoutUI.updateShippingAndTax(shippingAndTaxData);
                            }
                        } else {
                            //Pass bad parts into shipping and tax call so we can stuff them in the JSON
                            shippingAndTaxData.productsNotFoundQuickAdd = data.productsNotFoundQuickAdd;
    
                            if (env.punchoutUser && !env.punchoutUseShippingAndTaxService) {
                                fishersci.components.CartCheckoutUI.updateCartUi({
                                    "data": $.extend(data, shippingAndTaxData)
                                })
                            } else {
                                fishersci.components.CartCheckoutUI.updateShippingAndTax(shippingAndTaxData);
                            }
                        }
    
    
                        //if any url-query messages, reload the cart
                        fishersci.components.CartCheckoutUI.checkResponseForMessages({
                            data: data
                        });
    
                        //update cart count
                        if(window.header){
                            window.header.cart.updateCount(window.header.cart.getCount());
                        }
                        fishersci.components.CartCheckoutUI.addToCartAnalytics({
                            "parts": [element.getAttribute('data-partnumber')],
                            "addToCartFrom": "Favorites - In Cart",
                            "cartId": data.cartId,
                            "cartTotal": data.cartSummary.cartSubTotal,
                            "totalQty": data.cartLineItems
                        });
                    }
                })
            }
        },

        getMyTopPurchasesPartDetails : function (acctNum) {
            var xhr = new XMLHttpRequest();
            xhr.addEventListener("readystatechange", function() {
                if (this.readyState === 4) {
                    document.getElementsByClassName('js-my-top-purchases-content')[0].innerHTML = this.responseText;

                    var pricingRadio = document.querySelectorAll('.js-pricing-block-my-top-purchases input');
                    var addRadioListener = function(element) {
                        //default the uom attribute on the button to the current STD uom
                        if (element.getAttribute('checked')) {
                            //setting add to cart and add to subscription button elements data-uom attribute
                            element.parentElement.parentElement.nextElementSibling.setAttribute('data-uom', element.getAttribute('value'));
                            element.parentElement.parentElement.nextElementSibling.setAttribute('data-uomtype', element.getAttribute('data-uomtype'));
                        }
                        //add event listener for radio button
                        element.addEventListener('click', function() {
                            console.log(this.value);
                            console.log(this.parentElement.parentElement.nextElementSibling);
                            //setting add to cart and add to subscription button elements data-uom attribute
                            this.parentElement.parentElement.nextElementSibling.setAttribute('data-uom', this.value);
                            this.parentElement.parentElement.nextElementSibling.setAttribute('data-uomtype', this.getAttribute('data-uomtype'));
                        })
                    }
                    pricingRadio.forEach(addRadioListener)

                    //add event listener to add to cart button
                    var myTopPurchasesButton = document.querySelectorAll('.js-add-my-top-purchases-to-cart');

                    var addMyTopPurchaseEvents = function(myTopPurchase) {
                        myTopPurchase.addEventListener('click', function() {
                            addMyTopPurchaseToCart(myTopPurchase);
                        })
                    }
                    myTopPurchasesButton.forEach(addMyTopPurchaseEvents);

                    //add event listener to add to subscription button
                    var addToSubscriptionButtons = document.querySelectorAll('.js-add-top-purchase-to-subscription');
                    var addToSubscriptionEvents = function(addToSubscription) {
                        var shippedDirectFlag = addToSubscription.getAttribute('data-shippedDirect');
                        if(shippedDirectFlag === "true"){ // disable the subscription button for ship direct products
                            addToSubscription.classList.add('disabled');
                        } else{
                            addToSubscription.addEventListener('click', function() {
                                var $this = $(this);
                                var $element = $('<div>');
                                $element.data('partNumber', this.getAttribute('data-partnumber'))
                                $element.data('uom', this.getAttribute('data-uom'))
                                $element.data('quantity', this.getAttribute('data-quantity'))
                                $element.data('accountNumber', acctNum)
                                $element.data('listId', "null")
                                $('.js-ut-check-addToSubscription').addClass('hide');
                                fishersci.components.AddToSubscriptionUi().initEventHandlers($element);
                                fishersci.components.CartCheckoutUI.addSpinnerToElement($this);
                                setTimeout(function() { // 100ms wait to Prevent UI flashing
                                    $('.js-ut-check-addToSubscription').removeClass('hide');
                                    fishersci.components.CartCheckoutUI.removeSpinnerFromElement($this);
                                }, 1200);
                            })
                        }
                    }
                    if(LocalePath.getCountry().toUpperCase() === "US" && !env.punchoutUser){ //For US non punchout add the events
                        addToSubscriptionButtons.forEach(addToSubscriptionEvents);
                    }



                    //Show the tab only if we have items
                    if($('.my-top-purchases-container').length && $('.my-top-purchases-container').children().length > 0){
                        document.querySelector('#myTopPurchasesTab').classList.remove('hide');
                        document.querySelector('.tab-container').classList.remove('hide');
                        var myTopPurchasesTabRadio = document.querySelector('#myTopPurchasesTabRadio');
                        myTopPurchasesTabRadio.click();
                        $('.top-purchases-footer').removeClass('hide') //show proper footer
                        $('.save-for-later-footer').addClass('hide')
                        $('.favorites-footer').addClass('hide')
                        //scroll it into view if the cart is empty
                        if(env.cartIsEmpty){
                            var tabContainer = document.querySelector('.tab-container');
                            if (tabContainer.scrollIntoView) {  // Check browser support for scrollIntoView
                                tabContainer.scrollIntoView({ behavior: "smooth" });
                            }
                        }
                    }
                }
            });

            xhr.open("GET", "/store1/cart/myTopPurchases/" + "?accountNumber=" + acctNum + "&countryCode=" + LocalePath.getCountry().toUpperCase() + "&punchoutUser=" + env.punchoutUser);
            xhr.setRequestHeader("content-type", "application/json");
            xhr.setRequestHeader("cache-control", "no-cache");
            xhr.send();

            function addMyTopPurchaseToCart(element) {
                //prevent double click
                if(element.classList.value.indexOf('working') !== -1){
                    return;
                }

                element.classList.add('working');

                //Animation
                if(element.classList.value.indexOf('loading') === -1) {
                    element.classList.add('loading');
                    element.querySelectorAll('li').forEach(function(el){
                        if(el.classList.value.indexOf('liAtc1') !== -1) {
                            el.style.display = 'none';
                        }
                        if(el.classList.value.indexOf('liAtc2') !== -1) {
                            el.style.display = 'block';
                        }
                    })
                }

                var data = {
                    "addToCartFrom": "My Top Purchases - In Cart",
                    "itemList": [{
                        "partNumber": element.getAttribute('data-partnumber'),
                        "uom": element.getAttribute('data-uom'),
                        "uomType": element.getAttribute('data-uomtype')?element.getAttribute('data-uomtype'):"STD",
                        "quantity": element.getAttribute('data-qty')
                    }]
                }
                fishersci.components.CartCheckoutUI.addToCart({
                    data: data,
                    beforeSendCallback: function() {
                        element.classList.add('disabled');
                    },
                    errorCallback: function(xhr, status, error) {

                        element.classList.remove('disabled working');
                        //Reset buttons
                        if(element.classList.value.indexOf('inactiveATC') !== -1) {
                            element.classList.remove('activeATC loading');
                            element.querySelectorAll('li').forEach(function(el){
                                if(el.classList.value.indexOf('liAtc2') !== -1) {
                                    el.style.display = 'none';
                                }
                                if(el.classList.value.indexOf('liAtc1') !== -1) {
                                    el.style.display = 'block';
                                }
                            })
                        }

                        var errorJson;

                        try {
                            errorJson = JSON.parse(xhr.responseText);

                            if (errorJson.showError) {
                                _SELF.cartErrorModal({
                                    "message": i18nTranslations.cartUi.messages.webOrderingUnavailable,
                                    "serviceErrorCode": errorJson.serviceErrorCode,
                                    "icon": "icon_Warning_Triangle"
                                })
                            }
                        } catch (e) {
                            console.error(e);
                        }
                    },
                    callback: function(data) {

                        var shippingAndTaxData = {};

                        // Show added to cart success or reset the button in case of duplicate error
                        if(element.classList.value.indexOf('inactiveATC') !== -1) {
                            element.classList.add('done');
                            element.querySelectorAll('li').forEach(function(el){
                                if(el.classList.value.indexOf('liAtc2') !== -1) {
                                    el.style.display = 'none';
                                }
                                if(el.classList.value.indexOf('liAtc3') !== -1) {
                                    el.style.display = 'block';
                                }
                            })
                            element.classList.remove('working');
                        }

                        //In case of error from backend returned in 200 status
                        if (data.status) {
                            if (data.status !== 200) {
                                console.log(data);
                                return;
                            }
                        }

                        //Check for duplicate items
                        if (typeof data.duplicateQuoteItems !== "undefined") {
                            shippingAndTaxData.duplicateQuoteItems = data.duplicateQuoteItems;
                        }

                        //Check for messages
                        if (typeof data.messageList !== "undefined") {
                            $.each(data.messageList, function(key, value) {
                                if (value === "DUPLICATE_ITEM") {
                                    shippingAndTaxData.DUPLICATE_ITEM = true;
                                }
                            })
                        }

                        //Update Shipping and Taxes
                        //TODO clean up repetitive code
                        if (data.wasAdded && (data.productsNotFoundQuickAdd == "" || !data.productsNotFoundQuickAdd)) {
                            if (env.punchoutUser && !env.punchoutUseShippingAndTaxService) {
                                fishersci.components.CartCheckoutUI.updateCartUi({
                                    "data": $.extend(data, shippingAndTaxData)
                                })
                            } else {
                                fishersci.components.CartCheckoutUI.updateShippingAndTax(shippingAndTaxData);
                            }
                        } else {
                            //Pass bad parts into shipping and tax call so we can stuff them in the JSON
                            shippingAndTaxData.productsNotFoundQuickAdd = data.productsNotFoundQuickAdd;

                            if (env.punchoutUser && !env.punchoutUseShippingAndTaxService) {
                                fishersci.components.CartCheckoutUI.updateCartUi({
                                    "data": $.extend(data, shippingAndTaxData)
                                })
                            } else {
                                fishersci.components.CartCheckoutUI.updateShippingAndTax(shippingAndTaxData);
                            }
                        }


                        //if any url-query messages, reload the cart
                        fishersci.components.CartCheckoutUI.checkResponseForMessages({
                            data: data
                        });


                        fishersci.components.CartCheckoutUI.addToCartAnalytics({
                            "parts": [element.getAttribute('data-partnumber')],
                            "addToCartFrom": "My Top Purchases - In Cart",
                            "cartId": data.cartId,
                            "cartTotal": data.cartSummary.cartSubTotal,
                            "totalQty": data.cartLineItems
                        });
                    }
                })
            }
        },
    
        showChemLegalNotification: function(msg) {
            $.each(msg, function(x, y) {
            //Show upper right alert
                fishersci.components.CartCheckoutUI.doNotifications({
                    data: {
                        message: y,
                        icon: "icon_Warning_Triangle",
                        type: "warning"
                    },
                    showProgress: false,
                    showProgressContainer: false,
                    removeWhenDone: true,
                    fontsize: "small"
                });
            });
        },
        checkForB2bOptinMessage: function() {
            if (window.location.search.indexOf('optinMessage') > 0 && !env.optInMessageShown ) {
                fishersci.components.CartCheckoutUI.doNotifications({
                    data: {
                        message: i18nTranslations.cartUi.messages.b2bOptinMsg,
                        icon: "icon_OK_Circle",
                        type: "success"
                    },
                    showProgress: false,
                    showProgressContainer: false,
                    removeWhenDone: true,
                });

                //Flag to now show message for any other actions if closed
                env.optInMessageShown = true;
            }
        },
        hasMaximumLineItemsForQuote:    function(){
            return document.querySelectorAll('.js-hidden-inputs:not(.filter-from-checkout)').length >= maximumLineItemsForQuote;
        },
        showMaximumLineQuoteMessage : function(){
            //position above quote button
            var quoteButton = document.getElementById('getAnInstantQuote');
            var quoteButtonPosition;
            var quoteButtonLeftPosition;
            var quoteButtonTopPosition;

            if( typeof quoteButton !== "undefined"){
                quoteButtonPosition = quoteButton.getBoundingClientRect();
                quoteButtonTopPosition = quoteButtonPosition.top;
                quoteButtonLeftPosition = quoteButtonPosition.left;
            }

            fishersci.components.CartCheckoutUI.doNotifications({
                data: {
                    message: '<p>' + i18nTranslations.cartUi.messages.tooManyLineItems + '</p>',
                    icon: 'icon_Information_Circle',
                    type: "alert-info"
                },
                additionalSelectors : "js-custom-quote-fail position-absolute",
                showProgress: false,
                showProgressContainer: false,
                removeWhenDone: true,
                css : { borderLeft:"10px solid #F56A00", left: quoteButtonLeftPosition+ "px", top: quoteButtonTopPosition + "px", width: "270px" }
            })
        }
    }
}());

// Temporary override - this currently only gets called from Stockroom modal Add to Cart
// will move this function from FS_addToCart.js to COmmon.js to handle all stockroom modal add to cart functionality
function fs_updateCartletState(data) {

    var url = "/store1/cart/service?language=" +  LocalePath.getLanguage() + "&countryCode=" + LocalePath.getCountry().toUpperCase();

    //if 500 error, log in console
    if (data.status && data.status == 500) {
        console.log("Add to cart failed " + JSON.stringify(data));
        return false;
    }

    //update cartlet
    fishersci.components.CartCheckoutUI.updateCartlet(data);

    //if products not found, pass in query
    if (data.productsNotFoundQuickAdd) {
        url += "&productsNotFoundQuickAdd=" + data.productsNotFoundQuickAdd;
    }

    //if any url-query messages, reload the cart
    fishersci.components.CartCheckoutUI.checkResponseForMessages({data: data});

    //get the cart view in JSON format, update the UI, and cleanup
    $.ajax({
        url: url,

        type: 'GET',
        dataType: 'json',
        error: function (xhr, status, error) {
            console.log(xhr);
        },
        success: function (data) {

            var pickUpItems = {};
            var pickUpItemsObj = {};

            if(env.punchoutUser && !env.punchoutUseShippingAndTaxService){
                fishersci.components.CartCheckoutUI.updateCartUi({"data":data});
            } else {
                fishersci.components.CartCheckoutUI.updateShippingAndTax(data);
            }

            //Analytics
            try {
                fishersci.components.CartCheckoutUI.addToCartAnalytics({
                    "parts": data.cartletItems[0].partNumber.replace(/-/g, ''),
                    "addToCartFrom": "Stock Item Modal - In Cart"
                });
            } catch (e) {
                console.log(e);
            }

            //Test if Shipping Part (env.orderitemid) was moved to Pick up section
            pickUpItemsObj = fishersci.components.CartCheckoutUI.setCartState({element: $('.js-pickUpItem')});

            if (pickUpItemsObj) {
                //if true, item now exists in pickup section - update and show the message
                if (pickUpItemsObj[env.orderitemid]) {
                    $('#productTitlePlaceholder').text(pickUpItemsObj[env.orderitemid].productTitle);
                    $('#catalogNumberPlaceholder').text(pickUpItemsObj[env.orderitemid].catalogNumber);
                    $('#item-moved-to-pick-up').removeClass('hide');
                }
            }
            //Clean up
            delete env.orderitemid;

        }
    })
}

//Add to List Override for EU only ( they are still using the legacy My LIst )
//Once settled in, we can refactor the code in CQ to handle this change
try {
    setTimeout(function (){
        if ( env.enableSaveForLater ) {
            fishersci.components.AddToList.addAllItemsToHotlist = function (listId, listType) {
                var addToListButtons = $('[data-pa-element=addToHotlistButton]', '.js-saved-items'),
                    data = 'language=' + LocalePath.getLanguage() +
                        '&countryCode=' + LocalePath.getCountry().toUpperCase();

                //Get all of the items to add to hotlist.
                for (count = 0; count < $(addToListButtons).length; count++) {
                    var element = addToListButtons[count],
                        partNumber = $(element).attr('data-partnumber'),
                        prodDesc = $(element).attr('data-shortdesc'),
                        from = $(element).attr('data-origin'),
                        qty = $(element).attr('data-qty')
                    
                    var pricing = fishersci.components.AddToList.getQtyAndUom(element);
                    data += '&partNumber=' + partNumber + '&description=' + prodDesc
                        + '&unit=&quantity=' + qty;

                    if (LocalePath.getCountry().toUpperCase() == 'CA') {
                        var lineComment = $(element).closest('tbody').find('input[name^="comment"]').val();
                        if (typeof lineComment !== 'undefined') {
                            data += "&lineComments=" + lineComment;
                        }

                        var billingCode = $(element).closest('tbody').find('input[name^="customerItem"]').val();
                        if (typeof billingCode !== 'undefined') {
                            data += "&billingCode=" + billingCode;
                        }
                    }

                }

                data = encodeURI(data);
                element = $(".selected_add_to_list");
                $.ajax({
                    url: '/store/mylists/' + listId + '/items?' + data,
                    type: 'POST',
                    dataType: 'json',
                    error: function (xhr, status, error) {
                        fishersci.components.AddToList.general_hotlistAddResponse(false, 'ajaxFail', element);
                        $('#qa_add_list_spinner').remove();
                    },
                    success: function (data) {
                        //if the ajax completed successfully, remove hotlist window and send response
                        $('#qa_add_to_list_modal').remove();
                        fishersci.components.AddToList.general_hotlistAddResponse(true, data, element);
                        $('#qa_add_list_spinner').remove();
                        $('.save_as_template').html('<span class="js_add_to_list css_add_to_list bold"><span class="icon_Check valid"></span>'
                            + fishersci.Common.getTranslationMessage('mylist.messages.addedToList') + '</span>');
                        fishersci.components.AddToList.fs_resetButton(element, true, from);

                        //Capture event for Omniture
                        fisherDataLayer.events = "event120";
                        _satellite.track("trackEventsGeneral");
                    }
                });
            }
        }
    }, 2000)

}catch (e){
    console.error(e);
}